// icon configuration
export const iconConfig = {
	success: {
		markup: `
			<svg id="markup" xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 70 70">
				<g fill="none" fill-rule="evenodd">
					<circle cx="34.5" cy="34.5" r="34.5" __fill__ fill-rule="nonzero"/>
					<path __stroke__ stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M53 22L30.846 46.6 17 35.667"/>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 66,
			height: 57,
			fill: '#05E0A2',
			stroke: '#FFF',
		},
	},
	search: {
		markup: `
			<svg id="markup" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" __width__ __height__ viewBox="0 0 512.005 512.005" xml:space="preserve">
				<g>
					<g>
						<path __fill__ d="M505.749,475.587l-145.6-145.6c28.203-34.837,45.184-79.104,45.184-127.317c0-111.744-90.923-202.667-202.667-202.667
							S0,90.925,0,202.669s90.923,202.667,202.667,202.667c48.213,0,92.48-16.981,127.317-45.184l145.6,145.6
							c4.16,4.16,9.621,6.251,15.083,6.251s10.923-2.091,15.083-6.251C514.091,497.411,514.091,483.928,505.749,475.587z
								M202.667,362.669c-88.235,0-160-71.765-160-160s71.765-160,160-160s160,71.765,160,160S290.901,362.669,202.667,362.669z"/>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#999999',
		},
	},
	close: {
		markup: `
			<svg id="close" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" __width__ __height__ viewBox="0 0 329.26933 329" xml:space="preserve">
				<path __fill__ d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0" />
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#999999',
		},
	},
	filter: {
		markup: `
			<svg id="filter" __width__ __height__ enable-background="new 0 0 510.883 510.883" viewBox="0 0 510.883 510.883" xmlns="http://www.w3.org/2000/svg">
				<g>
					<path __fill__ d="m453.287 0h-395.691l161.76 226.649v234.461l72.17 49.773v-284.234z"/>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#003E7B',
		},
	},
	click: {
		markup: `
			<svg id="click" __width__ __height__ viewBox="-59 0 475 475.56972" xmlns="http://www.w3.org/2000/svg">
				<path __fill__ d="m318.917969 187.566406h-.667969c-9.121094-.050781-17.933594 3.300782-24.71875 9.398438-5.492188-15.199219-19.449219-26.125-35.796875-26.125-10.019531.070312-19.589844 4.183594-26.53125 11.414062-6.382813-12.921875-19.1875-21.6875-33.910156-21.6875h-.710938c-7.890625-.121094-15.589843 2.445313-21.832031 7.273438v-92.121094c0-22.261719-17.332031-40.371094-38.414062-40.371094-21.058594 0-38.300782 18.097656-38.3125 40.34375l-.175782 182.773438-10.34375-12.5625c-9.070312-11.292969-22.421875-18.304688-36.867187-19.363282-14.148438-.96875-28.066407 3.953126-38.457031 13.609376l-9 7.457031c-2.902344 2.40625-3.730469 6.507812-1.992188 9.851562l87.503906 168.199219c16 30.738281 46.441406 49.914062 79.445313 49.914062h98.613281v-.085937c50 0 90.539062-43.386719 90.589844-96.660156.019531-23.835938-.070313-41.601563-.054688-56 .050782-38.523438.011719-52.738281-.085937-95.179688-.050781-22.210937-17.257813-40.078125-38.28125-40.078125zm22.25 135.203125c-.015625 14.402344-.039063 32.238281-.0625 56.074219-.042969 44.464844-33.609375 80.722656-74.824219 80.722656h-98.140625c-27.015625 0-52.019531-15.878906-65.25-41.300781l-84.527344-162.425781 4.171875-3.480469c.105469-.085937.207032-.1875.308594-.277344 7.175781-6.753906 16.832031-10.222656 26.664062-9.578125 10.050782.769532 19.324219 5.683594 25.609376 13.5625l24.488281 29.796875c2.140625 2.613281 5.695312 3.59375 8.875 2.457031 3.179687-1.136718 5.304687-4.152343 5.304687-7.527343l.144532-205.09375c.007812-13.429688 10.164062-24.355469 22.414062-24.355469s22.40625 10.9375 22.40625 24.375v123.660156c0 .429688-.019531.863282-.019531 1.300782 0 .1875.019531.378906.019531.5625v52.871093c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-54.464843c0-12.957032 9.898438-23.082032 21.832031-23.082032h.710938c12.257812 0 22.457031 10.683594 22.457031 24.121094v48.378906c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-37.957031c0-13.441406 9.710938-24.375 22.035156-24.375 12.253906 0 21.964844 10.929687 21.964844 24.375v35.808594c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-19.390625c0-13.441406 10.242188-23.960938 22.5-23.960938h.667969c12.226562 0 22.191406 10.699219 22.222656 24.097656.097656 42.410157.078125 56.609376.027344 95.105469zm0 0" />
				
				<path __fill__ d="m72.609375 79.171875c4.417969 0 8-3.582031 8-8 .128906-30.527344 24.914063-55.203125 55.4375-55.203125 30.527344 0 55.308594 24.675781 55.4375 55.203125 0 4.417969 3.582031 8 8 8s8-3.582031 8-8c-.148437-39.351563-32.085937-71.171875-71.4375-71.171875-39.347656 0-71.289063 31.820312-71.4375 71.171875 0 4.417969 3.582031 8 8 8zm0 0" />
			</svg>
		`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003e7b',
		},
	},
	phone: {
		markup: `
			<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" __width__ __height__
			viewBox="0 0 384 384" style="enable-background:new 0 0 384 384;" xml:space="preserve">
				<g>
					<g>
						<path __fill__ d="M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.719-3.656-23.896-0.302-30.438,6.417l-43.177,32.594
							c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448
							c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.813C13.823,0,0,13.823,0,30.813
							C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z"
							/>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003e7b',
		},
	},
	discontinueRx: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="16px" height="16px" viewBox="0 0 206.000000 206.000000" preserveAspectRatio="xMidYMid meet">
			<g xmlns="http://www.w3.org/2000/svg" transform="translate(0.000000,206.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
			<path fill="#003e7b" d="M900 2004 c-426 -52 -756 -332 -861 -729 -27 -103 -37 -305 -19 -412 67 -416 392 -741 814 -814 102 -17 321 -6 416 21 282 81 518 280 637 538 73 157 105 359 84 530 -50 403 -344 739 -734 837 -95 24 -261 38 -337 29z m291 -100 c497 -113 802 -610 678 -1105 -20 -79 -80 -220 -112 -263 -14 -19 -15 -19 -30 11 -9 17 -25 71 -36 121 -23 107 -61 192 -100 225 -31 25 -214 82 -232 72 -27 -18 0 -38 81 -61 47 -14 96 -33 110 -42 36 -25 76 -114 95 -207 9 -44 27 -104 42 -134 l25 -53 -26 -26 -26 -27 -247 247 c-185 185 -244 250 -239 263 6 16 8 15 39 -2 17 -11 63 -43 101 -71 38 -29 74 -52 80 -52 6 0 29 -9 50 -21 26 -14 42 -17 49 -10 18 18 -3 42 -65 71 -108 50 -98 13 -98 379 l0 322 -25 24 -24 25 -321 0 -320 0 -40 -36 c-32 -30 -43 -34 -55 -24 -32 27 -155 155 -155 162 0 13 95 83 163 122 81 45 223 93 313 105 90 13 233 6 325 -15z m-779 -361 c84 -84 87 -88 70 -106 -15 -17 -17 -47 -19 -239 -2 -181 -5 -222 -18 -234 -60 -61 -65 -178 -9 -251 22 -29 24 -41 24 -132 0 -170 10 -178 230 -182 150 -3 155 -2 158 18 3 17 -4 21 -39 27 -34 6 -55 19 -113 76 l-71 69 103 104 c68 68 110 103 124 103 42 -2 27 25 -65 116 -98 98 -134 118 -211 118 l-36 0 0 175 c0 203 3 208 79 131 l44 -45 -34 -3 c-26 -2 -34 -8 -34 -23 0 -17 8 -20 55 -23 55 -2 103 -19 95 -32 -2 -4 -35 -8 -72 -9 -37 -1 -72 -6 -77 -11 -21 -21 9 -30 102 -30 l97 0 227 -227 228 -228 0 -112 c0 -101 -2 -113 -17 -113 -10 0 -33 -19 -52 -41 l-34 -42 68 5 c59 4 71 8 91 32 20 22 24 38 24 92 l0 64 43 -27 c23 -14 83 -67 134 -117 89 -87 92 -91 75 -109 -53 -60 -244 -161 -362 -192 -100 -26 -298 -31 -401 -10 -371 75 -653 362 -719 732 -18 99 -8 307 19 398 27 92 99 236 153 307 24 32 45 58 48 58 2 0 44 -39 92 -87z m836 -306 c2 -273 2 -278 -17 -267 -30 16 -66 12 -85 -9 -16 -18 -18 -18 -49 13 -18 18 -43 44 -56 59 l-23 26 33 45 c18 25 34 46 35 46 1 0 12 -16 24 -35 36 -58 50 -69 68 -52 12 13 9 22 -25 73 l-40 58 40 58 c36 53 39 60 25 74 -13 14 -18 12 -39 -13 -13 -16 -31 -40 -40 -53 l-16 -24 -17 26 c-16 25 -16 27 9 54 22 24 26 35 21 64 -8 52 -38 72 -105 68 l-56 -3 0 -135 c0 -128 1 -135 20 -135 17 0 21 8 25 60 l5 60 33 -47 c17 -26 32 -49 32 -53 0 -5 -48 -80 -66 -103 -1 -2 -33 29 -71 68 -48 52 -68 80 -68 99 0 22 -5 26 -31 29 -21 2 -46 18 -79 52 -48 49 -49 50 -46 107 1 32 5 61 8 65 2 5 127 7 276 6 l272 -3 3 -278z m-606 217 c-4 -22 -6 -24 -14 -10 -9 16 -3 36 11 36 5 0 6 -12 3 -26z m392 -57 c29 -21 16 -51 -22 -55 -31 -3 -32 -2 -32 32 0 40 20 48 54 23z m-376 -431 c15 -8 53 -41 84 -73 l58 -58 -105 -105 -105 -105 -65 65 c-69 69 -91 112 -82 166 16 95 131 154 215 110z m-44 -484 c-69 -5 -74 -1 -74 65 l0 57 60 -59 61 -60 -47 -3z"/>
			<path d="M593 1104 c-10 -26 17 -34 102 -32 72 3 80 5 80 23 0 18 -8 20 -88 23 -73 2 -88 0 -94 -14z"/>
			<path d="M1000 814 c-81 -13 -95 -18 -131 -51 -47 -43 -64 -73 -74 -130 -32 -196 225 -321 359 -173 46 51 57 81 57 147 0 99 -67 181 -166 203 -16 3 -37 5 -45 4z m120 -111 c0 -23 -189 -213 -212 -213 -41 0 -25 28 73 126 99 100 139 124 139 87z"/>
			<path d="M1353 495 c-6 -18 64 -86 86 -82 27 4 23 27 -12 62 -37 37 -64 44 -74 20z"/>
			<path d="M482 885 c-18 -39 -14 -90 7 -116 18 -22 21 -23 36 -8 16 16 16 19 -1 44 -17 26 -17 29 -1 57 9 16 15 34 11 39 -11 18 -41 9 -52 -16z"/>
			</g>
		</svg>`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003e7b',
		},
	},
	pass: {
		markup:
			'<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" __width__ __height__ xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" __fill__ viewBox="0 0 448.8 448.8"  xml:space="preserve"><g><g id="check"><polygon points="142.8,323.85 35.7,216.75 0,252.45 142.8,395.25 448.8,89.25 413.1,53.55"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>',
		defaultStyles: {
			fill: '#29a1a7',
			width: 12,
			height: 12,
		},
	},
	fail: {
		markup:
			'<svg xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 9 9"><path __fill__ fill-rule="nonzero" d="M9 .52L8.478 0 4.5 3.97.522 0 0 .52l3.978 3.971L0 8.461l.522.521L4.5 5.012l3.978 3.97.522-.52-3.979-3.97z"/></svg>',
		defaultStyles: {
			fill: '#EF6565',
			width: 12,
			height: 12,
		},
	},
	dash: {
		markup:
			'<svg x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" __fill__><path d="M465.064,207.562H26.908C12.076,207.562,0,219.698,0,234.53v22.804c0,14.832,12.072,27.104,26.908,27.104h438.156 c14.84,0,26.936-12.272,26.936-27.104V234.53C492,219.698,479.904,207.562,465.064,207.562z"/></svg>',
		defaultStyles: {
			fill: '#666',
		},
	},
	downArrow: {
		markup: `
			<svg id="downArrow" xmlns="http://www.w3.org/2000/svg" __width__ __height__ x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
				<g>
					<path __fill__ d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
						c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
						c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003e7b',
		},
	},
	bag: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 14 14">
				<defs>
					<path id="c26syt0gba" d="M9 2.5H7v-1c0-.275-.11-.525-.295-.705C6.525.61 6.275.5 6 .5H4c-.55 0-1 .45-1 1v1H1c-.55 0-1 .45-1 1V9c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V3.5c0-.55-.45-1-1-1zM5.494 4.305v1.507h1.507v.985H5.494v1.508H4.51V6.797H3v-.985H4.51V4.305h.985zM6 1.5v1H4v-1h2z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-51 -216) translate(40 162) translate(12 54)">
										<mask id="jsida5skub" fill="#fff">
											<use xlink:href="#c26syt0gba"/>
										</mask>
										<g __fill__ mask="url(#jsida5skub)">
											<path d="M0 0H25V25H0z" transform="translate(-8 -8)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>	
		`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#2d2d2d',
		},
	},
	person: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 14 14" >
				<defs>
					<path id="b57y0hw5ba" d="M6 6c1.657 0 3-1.343 3-3S7.657 0 6 0 3 1.343 3 3s1.343 3 3 3zm0 1.5c-2.002 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g transform="translate(-217 -1236) translate(40 851) translate(35 383) translate(143 2)">
											<mask id="dow2vdgynb" fill="#fff">
												<use xlink:href="#b57y0hw5ba"/>
											</mask>
											<g __fill__ mask="url(#dow2vdgynb)">
												<path d="M0 0H38V38H0z" transform="translate(-13 -13)"/>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#2d2d2d',
		},
	},
	phoneForward: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 14 14">
				<defs>
					<path id="d82vg0aypa" d="M10.083.583L7.167 3.5l2.916 2.917v-1.75h2.334V2.333h-2.334V.583zm.584 8.459c-.73 0-1.43-.117-2.083-.333-.204-.064-.431-.017-.595.14l-1.283 1.284c-1.651-.84-3.004-2.188-3.844-3.845L4.145 5c.163-.151.21-.379.146-.583-.216-.654-.333-1.354-.333-2.083 0-.32-.262-.583-.583-.583H1.333c-.32 0-.583.263-.583.583 0 5.478 4.44 9.917 9.917 9.917.32 0 .583-.262.583-.583V9.625c0-.32-.262-.583-.583-.583z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-162 -215) translate(40 162) translate(123 53)">
										<mask id="7rkkbqnqbb" fill="#fff">
											<use xlink:href="#d82vg0aypa"/>
										</mask>
										<g __fill__ mask="url(#7rkkbqnqbb)">
											<path d="M0 0H29V29H0z" transform="translate(-9 -8)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>	
		`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#2d2d2d',
		},
	},
	star: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 15 14">
				<defs>
					<path id="ogxmcwk6ya" d="M10.605 12.25L9.651 8.15 12.833 5.392 8.639 5.032 7 1.167 5.361 5.032 1.167 5.392 4.349 8.15 3.395 12.25 7 10.075z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-285 -207) translate(286 162) translate(0 12) translate(0 33)">
										<mask id="vrys0k8cob" fill="#fff">
											<use xlink:href="#ogxmcwk6ya"/>
										</mask>
										<g __fill__ mask="url(#vrys0k8cob)">
											<path d="M0 0H29V29H0z" transform="translate(-8 -8)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>	
		`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#ffbb00',
		},
	},
	somethingWentWrong: {
		markup: `
			<svg id="somethingWentWrong" xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 243 135">
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g transform="translate(-599 -288) translate(400 186) translate(199 102)">
								<path fill="#FCE0E3" d="M30.3 133.8C17.783 112.716 13.61 97.575 17.783 88.38c4.173-9.197 19.177-21.002 45.013-35.416 2.663-2.148 6.672-10.543 12.029-25.184 3.77-10.307 14.27-19.698 25.87-23.614C108.427 1.556 114.636.25 119.32.25c23.166-2.056 40.962 8.56 53.387 31.846 6.574 15.254 16.508 25.274 29.803 30.063 19.941 7.182 31.944 18.424 20.35 58.077-2.923 7.144-5.372 11.665-7.346 13.564H30.301z" opacity=".502" transform="matrix(-1 0 0 1 243.617 0)"/>
								<path stroke="#B9B9B9" stroke-width=".6" d="M.54 134.1h241.8"/>
								<g fill="#003E7B" fill-rule="nonzero" opacity=".7">
									<path d="M1.834 2.6L.117.883c-.156-.156-.156-.41 0-.566.156-.156.41-.156.566 0L2.4 2.034 4.117.317c.156-.156.41-.156.566 0 .156.156.156.41 0 .566L2.966 2.6l1.717 1.717c.156.156.156.41 0 .566-.156.156-.41.156-.566 0L2.4 3.166.683 4.883c-.156.156-.41.156-.566 0-.156-.156-.156-.41 0-.566L1.834 2.6z" transform="translate(196.5 72.8)"/>
								</g>
								<g fill="#DC3F25" fill-rule="nonzero">
									<path d="M.917 1.2L.06.341C-.02.263-.02.137.059.06.137-.02.263-.02.34.059L1.2.917 2.059.06c.078-.079.204-.079.282 0 .079.078.079.204 0 .282l-.858.859.858.859c.079.078.079.204 0 .282-.078.079-.204.079-.282 0L1.2 1.483l-.859.858c-.078.079-.204.079-.282 0-.079-.078-.079-.204 0-.282L.917 1.2z" transform="translate(189.5 12.1)"/>
								</g>
								<g fill="#003E7B" fill-rule="nonzero" opacity=".9">
									<path d="M1.376 1.8L.088.512C-.03.395-.03.205.088.088c.117-.117.307-.117.424 0L1.8 1.376 3.088.088c.117-.117.307-.117.424 0 .117.117.117.307 0 .424L2.224 1.8l1.288 1.288c.117.117.117.307 0 .424-.117.117-.307.117-.424 0L1.8 2.224.512 3.512c-.117.117-.307.117-.424 0-.117-.117-.117-.307 0-.424L1.376 1.8z" transform="translate(65.9 4.3)"/>
								</g>
								<rect width="4.8" height="4.8" x="40.5" y="79" fill="#89BBE8" opacity=".5" rx=".6"/>
								<rect width="4.8" height="4.8" x="210.5" y="40.5" stroke="#2D6DC1" stroke-width=".6" opacity=".7" rx=".6"/>
								<circle cx="115.4" cy="8.8" r="1.5" stroke="#2D6DC1" stroke-width=".6" opacity=".5"/>
								<circle cx="52.7" cy="31.3" r="1.2" fill="#05E0A2"/>
								<circle cx="168.5" cy="22.5" r="1.8" fill="#05E0A2" opacity=".3"/>
								<g>
									<path fill="#89BBE8" fill-rule="nonzero" d="M95.895 3.271c-.178-1.902-1.47-3.14-3.372-3.23-.397-.02-.797-.028-1.195-.028L65.335.012l-23.67.02L17.114.02 12.927.02c-.693 0-1.37.017-2.016.219C9.441.7 8.6 2.056 8.6 4.029c-.001 17.266-.003 34.533.005 51.798 0 .463.054.926.108 1.387l.057.506c.044.426.273 1.141 1.314 1.141h.01c8.974-.012 17.946-.014 26.92-.018l23.287-.007 34.058.015c1.012 0 1.321-.27 1.44-1.26.095-.798.14-1.465.141-2.1.007-17.098.004-34.193.002-51.29-.002-.31-.019-.619-.046-.93zm-3.12 51.687H11.642V4.147h81.133v50.81z" transform="translate(68 70.5)"/>
									<path fill="#89BBE8" d="M59.805 59.557c-.102.36-.411 1.123-1.192 1.123h-.07s-12.008 0-12.682.003c-.664 0-1.074-.784-1.224-1.126H.178v1.535l2.301 1 102.484-.025 2.358-1.001.052-1.51H59.805z" transform="translate(68 70.5)"/>
									<path fill="#F6F6F7" d="M11.2 3.85H92.75V54.95H11.2z" transform="translate(68 70.5)"/>
								</g>
								<g transform="translate(97.5 81.5)">
									<path fill="#FFDD35" d="M25.411 3.969l18.906 32.525c.693 1.193.288 2.724-.905 3.417-.382.222-.815.339-1.257.339H4.345c-1.38 0-2.5-1.12-2.5-2.5 0-.441.117-.875.338-1.256L21.09 3.969c.693-1.194 2.224-1.6 3.417-.906.375.218.687.53.905.906z"/>
									<circle cx="23" cy="33" r="2" fill="#3B4145"/>
									<path fill="#3B4145" fill-rule="nonzero" d="M23 14.5c1.15 0 2 .938 2 2.095v11.31C25 29.062 24.15 30 23 30s-2-.938-2-2.095v-11.31c0-1.157.85-2.095 2-2.095z"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 243,
			height: 135,
		},
	},
	noDataFound: {
		markup: `
			<svg id="noDataFound" xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 243 137">
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-599 -322) translate(40 244) translate(559 78)">
										<path fill="#FCE0E3" d="M30.3 136.5c-12.518-21.084-16.691-36.225-12.518-45.42 4.173-9.197 19.177-21.002 45.013-35.416 2.663-2.148 6.672-10.543 12.029-25.184 3.77-10.307 14.27-19.698 25.87-23.614 7.733-2.61 13.942-3.916 18.627-3.916 23.166-2.056 40.962 8.56 53.387 31.846 6.574 15.254 16.508 25.274 29.803 30.063 19.941 7.182 31.944 18.424 20.35 58.077-2.923 7.144-5.372 11.665-7.346 13.564H30.301z" opacity=".502" transform="matrix(-1 0 0 1 243.617 0)"/>
										<path stroke="#B9B9B9" stroke-width=".6" d="M.54 135.8h241.8"/>
										<g fill="#DC3F25" fill-rule="nonzero" opacity=".7">
											<path d="M1.834 2.6L.117.883c-.156-.156-.156-.41 0-.566.156-.156.41-.156.566 0L2.4 2.034 4.117.317c.156-.156.41-.156.566 0 .156.156.156.41 0 .566L2.966 2.6l1.717 1.717c.156.156.156.41 0 .566-.156.156-.41.156-.566 0L2.4 3.166.683 4.883c-.156.156-.41.156-.566 0-.156-.156-.156-.41 0-.566L1.834 2.6z" transform="translate(236.5 95)"/>
										</g>
										<g fill="#DC3F25" fill-rule="nonzero">
											<path d="M.917 1.2L.06.341C-.02.263-.02.137.059.06.137-.02.263-.02.34.059L1.2.917 2.059.06c.078-.079.204-.079.282 0 .079.078.079.204 0 .282l-.858.859.858.859c.079.078.079.204 0 .282-.078.079-.204.079-.282 0L1.2 1.483l-.859.858c-.078.079-.204.079-.282 0-.079-.078-.079-.204 0-.282L.917 1.2z" transform="translate(183 7.8)"/>
										</g>
										<g fill="#DC3F25" fill-rule="nonzero" opacity=".9">
											<path d="M1.376 1.8L.088.512C-.03.395-.03.205.088.088c.117-.117.307-.117.424 0L1.8 1.376 3.088.088c.117-.117.307-.117.424 0 .117.117.117.307 0 .424L2.224 1.8l1.288 1.288c.117.117.117.307 0 .424-.117.117-.307.117-.424 0L1.8 2.224.512 3.512c-.117.117-.307.117-.424 0-.117-.117-.117-.307 0-.424L1.376 1.8z" transform="translate(59.4)"/>
										</g>
										<rect width="4.8" height="4.8" x="4.5" y="85.7" fill="#2D6DC1" opacity=".5" rx=".6"/>
										<rect width="4.8" height="4.8" x="204" y="36.2" stroke="#2D6DC1" stroke-width=".6" opacity=".7" rx=".6"/>
										<circle cx="68.9" cy="19.5" r="1.5" stroke="#2D6DC1" stroke-width=".6" opacity=".5"/>
										<circle cx="46.2" cy="27" r="1.2" fill="#2D6DC1"/>
										<circle cx="181.3" cy="30" r="1.8" fill="#2D6DC1" opacity=".3"/>
										<g fill-rule="nonzero">
											<path fill="#FFF" d="M62.603 0H4.396C1.934 0 0 1.902 0 4.323V78.85C0 81.098 1.934 83 4.396 83h58.208C65.066 83 67 81.098 67 78.677V4.323C67 1.902 65.066 0 62.603 0z" transform="translate(88 52.2)"/>
											<g fill="#CDD7E1">
												<path d="M.06 9.36H16.671999999999997V13.392H.06zM.06.144H28.892999999999997V4.176H.06z" transform="translate(88 52.2) translate(30 10.5)"/>
											</g>
											<path fill="#89BBE8" d="M8.5 11H21.5V24H8.5z" transform="translate(88 52.2)"/>
											<g fill="#CDD7E1">
												<path d="M.06 9.336H16.671999999999997V13.368H.06zM.06.12H28.892999999999997V4.152H.06z" transform="translate(88 52.2) translate(30 34.5)"/>
											</g>
											<path fill="#89BBE8" d="M8.5 35H21.5V48H8.5z" transform="translate(88 52.2)"/>
											<g fill="#CDD7E1">
												<path d="M.06 9.379H16.671999999999997V13.358H.06zM.06.095H28.892999999999997V4.074H.06z" transform="translate(88 52.2) translate(30 58.5)"/>
											</g>
											<path fill="#89BBE8" d="M8.5 59H21.5V72H8.5z" transform="translate(88 52.2)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 243,
			height: 137,
		},
	},
	inboundCall: {
		markup: `
			<svg id="inboundCall" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 18 19">
				<defs>
					<path id="tsrxmxb3ca" d="M14.25.75L10.5 4.5l3.75 3.75V6h3V3h-3V.75zM15 11.625c-.938 0-1.838-.15-2.678-.428-.262-.082-.554-.022-.764.18l-1.65 1.65c-2.123-1.08-3.863-2.812-4.943-4.942l1.65-1.658c.21-.194.27-.487.188-.75-.278-.84-.428-1.74-.428-2.677 0-.413-.338-.75-.75-.75H3c-.413 0-.75.337-.75.75 0 7.043 5.707 12.75 12.75 12.75.412 0 .75-.338.75-.75v-2.625c0-.412-.338-.75-.75-.75z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g transform="translate(-59 -124) translate(40 110) translate(19 15)">
								<mask id="3kzga10g5b" fill="#fff">
									<use xlink:href="#tsrxmxb3ca"/>
								</mask>
								<g __fill__ mask="url(#3kzga10g5b)">
									<path d="M0 0H38V38H0z" transform="translate(-10 -10)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 19,
			fill: '#003E7B',
		}
	},
	outboundCall: {
		markup: `
			<svg id="outboundCall" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 18 19">
				<defs>
					<path id="38ovgbabqa" d="M13.5 8.25l3.75-3.75L13.5.75V3h-3v3h3v2.25zm1.5 3.375c-.938 0-1.838-.15-2.678-.428-.262-.082-.554-.022-.764.18l-1.65 1.65c-2.123-1.08-3.863-2.812-4.943-4.942l1.65-1.658c.21-.194.27-.487.188-.75-.278-.84-.428-1.74-.428-2.677 0-.413-.338-.75-.75-.75H3c-.413 0-.75.337-.75.75 0 7.043 5.707 12.75 12.75 12.75.412 0 .75-.338.75-.75v-2.625c0-.412-.338-.75-.75-.75z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g transform="translate(-236 -124) translate(220 110) translate(16 15)">
								<mask id="conal9k8bb" fill="#fff">
									<use xlink:href="#38ovgbabqa"/>
								</mask>
								<g __fill__ mask="url(#conal9k8bb)">
									<path d="M0 0H38V38H0z" transform="translate(-10 -10)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
	
		`,
		defaultStyles: {
			width: 18,
			height: 19,
			fill: '#003E7B',
		}
	},
	time: {
		markup: `
			<svg id="time" xmlns="http://www.w3.org/2000/svg" __width__ __height__ x="0px" y="0px" viewBox="0 0 209.28 209.28" style="enable-background:new 0 0 209.28 209.28;" xml:space="preserve">
				<g>
					<path __fill__ d="M104.641,0C46.943,0,0.002,46.94,0.002,104.637c0,57.701,46.941,104.643,104.639,104.643
						c57.697,0,104.637-46.943,104.637-104.643C209.278,46.94,162.338,0,104.641,0z M104.641,194.28
						c-49.427,0-89.639-40.214-89.639-89.643C15.002,55.211,55.214,15,104.641,15c49.426,0,89.637,40.211,89.637,89.637
						C194.278,154.066,154.067,194.28,104.641,194.28z"/>
					<path d="M158.445,102.886h-49.174V49.134c0-4.142-3.357-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5v61.252c0,4.142,3.358,7.5,7.5,7.5
						h56.674c4.143,0,7.5-3.358,7.5-7.5C165.945,106.244,162.587,102.886,158.445,102.886z"/>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#000'
		}
	},
	endCall: {
		markup: `
			<svg id="endCall" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ x="0px" y="0px"
			viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
				<g>
					<g>
						<path __fill__ d="M502.72,253.163c-66.944-63.445-154.581-98.389-246.72-98.389S76.224,189.717,9.067,253.355
							C3.2,259.2,0,267.029,0,275.413c0,8.448,3.371,16.491,9.067,21.845l50.688,50.709c11.712,11.669,32.747,11.328,43.627,0.491
							c15.851-14.677,33.323-26.816,51.776-36.053c11.435-5.525,15.509-19.051,15.509-29.845v-56.021
							c27.2-7.317,58.133-7.979,85.333-7.979c28.821,0,58.965,0.661,85.333,7.915v56.085c0,14.165,5.717,25.387,15.189,29.995
							c19.285,9.643,36.821,21.76,52.032,36.032c5.803,5.483,13.696,8.64,21.632,8.64c8.384,0,16.213-3.2,22.059-9.045l50.688-50.688
							c5.845-5.845,9.067-13.675,9.067-22.08C512,267.029,508.8,259.2,502.72,253.163z"/>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#000000'
		}
	},
	phoneMessage: {
		markup: `
			<svg id="phoneMessage" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 -2 18 18">
				<defs>
					<path id="uzzey4bnia" d="M13 9.625c-.938 0-1.838-.15-2.678-.428-.262-.082-.554-.022-.764.18l-1.65 1.65c-2.123-1.08-3.863-2.812-4.943-4.934l1.65-1.658c.21-.202.27-.495.188-.757-.278-.84-.428-1.74-.428-2.678 0-.412-.338-.75-.75-.75H1C.588.25.25.588.25 1 .25 8.043 5.957 13.75 13 13.75c.412 0 .75-.338.75-.75v-2.625c0-.412-.338-.75-.75-.75zM7 .25v7.5L9.25 5.5h4.5V.25H7z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<mask id="jgvtqv9n4b" fill="#fff">
										<use xlink:href="#uzzey4bnia"/>
									</mask>
									<g __fill__ mask="url(#jgvtqv9n4b)">
										<path d="M0 0H38V38H0z"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#003E7B'
		}
	},
	callActivity: {
		markup: `
			<svg id="callActivity" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 -2 18 18" preserveAspectRatio="none">
				<defs>
					<path id="zp57d308ia" d="M7.75 4.75h-1.5v1.5h1.5v-1.5zm3 0h-1.5v1.5h1.5v-1.5zM13 9.625c-.938 0-1.838-.15-2.678-.428-.262-.082-.554-.022-.764.18l-1.65 1.65c-2.123-1.08-3.863-2.812-4.943-4.934l1.65-1.658c.21-.202.27-.495.188-.757-.278-.84-.428-1.74-.428-2.678 0-.412-.338-.75-.75-.75H1C.588.25.25.588.25 1 .25 8.043 5.957 13.75 13 13.75c.412 0 .75-.338.75-.75v-2.625c0-.412-.338-.75-.75-.75zm-.75-4.875v1.5h1.5v-1.5h-1.5z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<mask id="5ydbxrbmxb" fill="#fff">
										<use xlink:href="#zp57d308ia"/>
									</mask>
									<g __fill__ mask="url(#5ydbxrbmxb)">
										<path d="M0 0H38V38H0z"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#003E7B'
		}
	},
	callNotes: {
		markup: `
			<svg id="callNotes" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 16 16" preserveAspectRatio="none">
				<defs>
					<path id="hdtfokfy4a" d="M10.667.667h-8c-.734 0-1.334.6-1.334 1.333v9.333h1.334V2h8V.667zm2 2.666H5.333C4.6 3.333 4 3.933 4 4.667V14c0 .733.6 1.333 1.333 1.333h7.334c.733 0 1.333-.6 1.333-1.333V4.667c0-.734-.6-1.334-1.333-1.334zm0 10.667H5.333V4.667h7.334V14z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g>
											<g transform="translate(-1122 -681) translate(40 335) translate(15 110) translate(1061 236) translate(6)">
												<mask id="sdnd9wjghb" fill="#fff">
													<use xlink:href="#hdtfokfy4a"/>
												</mask>
												<g __fill__ mask="url(#sdnd9wjghb)">
													<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -8.667)"/>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#003E7B'
		}
	},
	thumbUp: {
		markup: `
			<svg id="thumbUp" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 18 18">
				<defs>
					<path id="ncs144rbba" d="M.75 15.75h3v-9h-3v9zm16.5-8.25c0-.825-.675-1.5-1.5-1.5h-4.732l.712-3.428.022-.24c0-.307-.127-.592-.33-.794L10.627.75 5.692 5.692c-.277.27-.442.646-.442 1.058v7.5c0 .825.675 1.5 1.5 1.5h6.75c.623 0 1.155-.375 1.38-.915l2.265-5.288c.067-.172.105-.352.105-.547V7.567l-.008-.007.008-.06z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g>
											<g transform="translate(-600 -561) translate(275 110) translate(-1 442) translate(253 9) translate(73.5)">
												<mask id="qtegy7eoqb" fill="#fff">
													<use xlink:href="#ncs144rbba"/>
												</mask>
												<g __fill__ mask="url(#qtegy7eoqb)">
													<path d="M0 0H38V38H0z" transform="translate(-10 -10)"/>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#003E7B'
		}
	},
	thumbDown: {
		markup: `
			<svg id="thumbDown" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 -2 18 18">
				<defs>
					<path id="6ml9ttn3ba" d="M11.25.25H4.5c-.623 0-1.155.375-1.38.915L.855 6.452C.787 6.625.75 6.805.75 7v1.432l.007.008-.007.06c0 .825.675 1.5 1.5 1.5h4.732l-.712 3.428-.022.24c0 .307.127.592.33.795l.794.787 4.943-4.943c.27-.27.435-.645.435-1.057v-7.5c0-.825-.675-1.5-1.5-1.5zm3 0v9h3v-9h-3z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g>
											<g transform="translate(-686 -563) translate(275 110) translate(-1 442) translate(253 9) translate(159.5 2)">
												<mask id="4hilqxnwrb" fill="#fff">
													<use xlink:href="#6ml9ttn3ba"/>
												</mask>
												<g __fill__ mask="url(#4hilqxnwrb)">
													<path d="M0 0H38V38H0z" transform="translate(-10 -12)"/>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#003E7B'
		}
	},
	faceSad: {
		markup: `
			<svg id="faceSad" __width__ __height__ viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<g id="ic_Sad" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="Group-75">
						<path d="M-1.59560474e-14,11.9630877 C-1.59560474e-14,5.35621053 5.35592982,-1.27648379e-13 11.9629474,-1.27648379e-13 C18.5699649,-1.27648379e-13 23.9258947,5.35621053 23.9258947,11.9630877 C23.9258947,18.5701053 18.5699649,23.9260351 11.9629474,23.9260351 C5.35592982,23.9260351 -1.59560474e-14,18.5701053 -1.59560474e-14,11.9630877" id="Fill-177" fill="#FFD05D"></path>
						<path d="M8.43719298,9.06077193 C8.43719298,9.88140351 8.04252632,10.5465263 7.55564912,10.5465263 C7.06891228,10.5465263 6.67424561,9.88140351 6.67424561,9.06077193 C6.67424561,8.24014035 7.06891228,7.57501754 7.55564912,7.57501754 C8.04252632,7.57501754 8.43719298,8.24014035 8.43719298,9.06077193" id="Fill-180" fill="#303030"></path>
						<path d="M17.2517895,9.06077193 C17.2517895,9.88140351 16.8571228,10.5465263 16.370386,10.5465263 C15.8835088,10.5465263 15.4888421,9.88140351 15.4888421,9.06077193 C15.4888421,8.24014035 15.8835088,7.57501754 16.370386,7.57501754 C16.8571228,7.57501754 17.2517895,8.24014035 17.2517895,9.06077193" id="Fill-181" fill="#303030"></path>
						<path d="M19.0293333,6.55284211 C18.9006316,6.51522807 18.7754386,6.48014035 18.6530526,6.44603509 C18.3842807,6.37080702 18.130386,6.29978947 17.8850526,6.21473684 C17.5184561,6.09080702 17.1887719,5.95059649 16.8770526,5.78610526 C16.549193,5.61263158 16.2512281,5.41936842 15.9660351,5.19494737 C15.6544561,4.95312281 15.365193,4.67031579 15.0989474,4.40042105 C15.0839298,4.38512281 15.0609123,4.38063158 15.0411228,4.38947368 C15.0214737,4.39803509 15.0091228,4.41796491 15.0102456,4.4394386 C15.0300351,4.8477193 15.1915789,5.27003509 15.4774737,5.66063158 C15.738807,6.01389474 16.0888421,6.31157895 16.4895439,6.52126316 C16.8665263,6.7197193 17.2881404,6.84098246 17.7124211,6.87284211 C17.7287018,6.87410526 17.7451228,6.87522807 17.7615439,6.87621053 C18.2367719,6.90105263 18.6658246,6.82484211 19.0370526,6.64968421 C19.0564211,6.6405614 19.0683509,6.62007018 19.0665263,6.59859649 C19.0648421,6.57712281 19.0501053,6.55887719 19.0293333,6.55284211" id="Fill-182" fill="#414042"></path>
						<path d="M4.89670175,6.55284211 C5.02526316,6.51522807 5.15059649,6.48014035 5.27284211,6.44603509 C5.54161404,6.37080702 5.79550877,6.29978947 6.04084211,6.21473684 C6.4074386,6.09080702 6.73726316,5.95059649 7.04884211,5.78610526 C7.37670175,5.61263158 7.67466667,5.41936842 7.96,5.19494737 C8.2714386,4.95312281 8.56070175,4.67031579 8.82694737,4.40042105 C8.84210526,4.38512281 8.86512281,4.38063158 8.88491228,4.38947368 C8.9045614,4.39803509 8.91691228,4.41796491 8.91578947,4.4394386 C8.896,4.8477193 8.73431579,5.27003509 8.44842105,5.66063158 C8.18708772,6.01389474 7.83705263,6.31157895 7.43635088,6.52126316 C7.05950877,6.7197193 6.63789474,6.84098246 6.21361404,6.87284211 C6.19733333,6.87410526 6.18077193,6.87522807 6.16449123,6.87621053 C5.68912281,6.90105263 5.26007018,6.82484211 4.88898246,6.64968421 C4.86947368,6.6405614 4.85768421,6.62007018 4.85936842,6.59859649 C4.86105263,6.57712281 4.87592982,6.55887719 4.89670175,6.55284211" id="Fill-183" fill="#414042"></path>
						<path d="M7.4394386,17.1110175 C7.31438596,17.1253333 7.24266667,16.970807 7.24391342,16.8550175 C7.24982456,16.3233684 7.39157895,15.7804912 7.66540351,15.2411228 C7.92547368,14.7452632 8.29712281,14.2857544 8.74231579,13.9086316 C9.62470175,13.1705263 10.7978947,12.7454035 11.962386,12.7410526 C13.1465263,12.7185965 14.330386,13.1452632 15.2039298,13.9018947 C16.1118596,14.6785965 16.6647018,15.781614 16.6819992,16.8516491 C16.6839298,16.9738947 16.6014035,17.1317895 16.4651228,17.1073684 C16.3528421,17.0872982 16.2610526,16.9345965 16.1785263,16.8658246 C16.0509474,16.7597193 15.9185965,16.6590877 15.7828772,16.5633684 C15.5122807,16.3724912 15.2279298,16.2012632 14.9357193,16.0454737 C13.858386,15.4705965 12.6363509,15.16 11.4124912,15.2669474 C10.6334035,15.3348772 9.87677193,15.5689825 9.18175439,15.9246316 C8.76449123,16.1381053 8.36954386,16.3936842 7.99747368,16.6784561 C7.8562807,16.7865263 7.6245614,17.0763509 7.45052632,17.1094737 L7.4394386,17.1110175" id="Fill-184" fill="#5E4939"></path>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
		}
	},
	faceNeutral: {
		markup: `
			<svg id="faceNeutral" __width__ __height__ viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<g id="ic_Normal" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="Group-74-Copy">
						<path d="M1.39615415e-14,11.9630877 C1.39615415e-14,5.35621053 5.35592982,-1.27648379e-13 11.9629474,-1.27648379e-13 C18.5699649,-1.27648379e-13 23.9258947,5.35621053 23.9258947,11.9630877 C23.9258947,18.5701053 18.5699649,23.9260351 11.9629474,23.9260351 C5.35592982,23.9260351 1.39615415e-14,18.5701053 1.39615415e-14,11.9630877" id="Fill-170" fill="#FFD05D"></path>
						<path d="M8.42380441,15.2818342 C9.21373036,15.5453764 10.0419463,15.7145895 10.9084522,15.7894737 C11.6348155,15.8522466 12.7875095,15.9800585 14.1645768,15.7485653 C14.4600766,15.6988901 15.043514,15.534659 15.914889,15.255872 C16.2095856,15.1616037 16.5249123,15.3240667 16.6191957,15.6187585 C16.6368515,15.6739434 16.6458397,15.7315332 16.6458397,15.7894737 C16.6458397,16.2547608 16.3458292,16.6669756 15.9030753,16.8100178 C15.1212002,17.0626417 14.5417007,17.2166643 14.1645768,17.2720856 C12.8200452,17.469675 11.1744628,17.3894748 10.5248338,17.3333333 C9.78335832,17.2692544 9.11014816,17.127887 8.50520335,16.909231 C8.03355814,16.7387358 7.71929825,16.2909892 7.71929825,15.7894737 C7.71929825,15.4939224 7.95888989,15.2543308 8.25444116,15.2543308 C8.31200721,15.2543308 8.36919617,15.2636191 8.42380441,15.2818342 Z" id="Rectangle" fill="#5E4939"></path>
						<path d="M8.43705263,9.06077193 C8.43705263,9.88140351 8.04238596,10.5465263 7.55550877,10.5465263 C7.06877193,10.5465263 6.67410526,9.88140351 6.67410526,9.06077193 C6.67410526,8.24014035 7.06877193,7.57501754 7.55550877,7.57501754 C8.04238596,7.57501754 8.43705263,8.24014035 8.43705263,9.06077193" id="Fill-173" fill="#303030"></path>
						<path d="M17.2516491,9.06077193 C17.2516491,9.88140351 16.8569825,10.5465263 16.3702456,10.5465263 C15.8833684,10.5465263 15.4887018,9.88140351 15.4887018,9.06077193 C15.4887018,8.24014035 15.8833684,7.57501754 16.3702456,7.57501754 C16.8569825,7.57501754 17.2516491,8.24014035 17.2516491,9.06077193" id="Fill-174" fill="#303030"></path>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
		}
	},
	faceHappy: {
		markup: `
			<svg id="faceHappy" __width__ __height__ viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<desc>Created with Sketch.</desc>
				<g id="ic_Happy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="Group-74">
						<path d="M1.39615415e-14,11.9630877 C1.39615415e-14,5.35621053 5.35592982,-1.27648379e-13 11.9629474,-1.27648379e-13 C18.5699649,-1.27648379e-13 23.9258947,5.35621053 23.9258947,11.9630877 C23.9258947,18.5701053 18.5699649,23.9260351 11.9629474,23.9260351 C5.35592982,23.9260351 1.39615415e-14,18.5701053 1.39615415e-14,11.9630877" id="Fill-170" fill="#FFD05D"></path>
						<path d="M8.43705263,9.06077193 C8.43705263,9.88140351 8.04238596,10.5465263 7.55550877,10.5465263 C7.06877193,10.5465263 6.67410526,9.88140351 6.67410526,9.06077193 C6.67410526,8.24014035 7.06877193,7.57501754 7.55550877,7.57501754 C8.04238596,7.57501754 8.43705263,8.24014035 8.43705263,9.06077193" id="Fill-173" fill="#303030"></path>
						<path d="M17.2516491,9.06077193 C17.2516491,9.88140351 16.8569825,10.5465263 16.3702456,10.5465263 C15.8833684,10.5465263 15.4887018,9.88140351 15.4887018,9.06077193 C15.4887018,8.24014035 15.8833684,7.57501754 16.3702456,7.57501754 C16.8569825,7.57501754 17.2516491,8.24014035 17.2516491,9.06077193" id="Fill-174" fill="#303030"></path>
						<path d="M3.92435088,13.0945965 C4.37992982,17.1316491 7.80421053,20.2693333 11.9629474,20.2693333 C16.1216842,20.2693333 19.5459649,17.1316491 20.0015439,13.0945965 L3.92435088,13.0945965" id="Fill-175" fill="#695342"></path>
						<path d="M6.41024561,18.0597895 C7.85908772,19.4286316 9.81207018,20.2693333 11.9629474,20.2693333 C14.0209123,20.2693333 15.898386,19.5000702 17.3260351,18.234386 L17.2516491,18.0606316 C11.8534737,15.4282105 6.48364912,18.024 6.41024561,18.0597895" id="Fill-176" fill="#F06669"></path>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
		}
	},
	faceAngry: {
		markup: `
			<svg id="faceAngry" __width__ __height__ viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<g id="ic_Angry" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="Group-76">
						<path d="M1.59560474e-14,11.9630877 C1.59560474e-14,5.35607018 5.35578947,-1.35626403e-13 11.9635088,-1.35626403e-13 C18.5698246,-1.35626403e-13 23.925614,5.35607018 23.925614,11.9630877 C23.925614,18.5701053 18.5698246,23.9260351 11.9635088,23.9260351 C5.35578947,23.9260351 1.59560474e-14,18.5701053 1.59560474e-14,11.9630877" id="Fill-120" fill="#F16D24"></path>
						<path d="M8.43789474,9.73684211 C8.43789474,10.5573333 8.04210526,11.2225965 7.55508772,11.2225965 C7.06947368,11.2225965 6.67368421,10.5573333 6.67368421,9.73684211 C6.67368421,8.91635088 7.06947368,8.25094737 7.55508772,8.25094737 C8.04210526,8.25094737 8.43789474,8.91635088 8.43789474,9.73684211" id="Fill-123" fill="#303030"></path>
						<path d="M17.2519298,9.73684211 C17.2519298,10.5573333 16.8575439,11.2225965 16.3705263,11.2225965 C15.8835088,11.2225965 15.4891228,10.5573333 15.4891228,9.73684211 C15.4891228,8.91635088 15.8835088,8.25094737 16.3705263,8.25094737 C16.8575439,8.25094737 17.2519298,8.91635088 17.2519298,9.73684211" id="Fill-124" fill="#303030"></path>
						<path d="M16.8659649,17.2797193 C17.1747368,17.5790877 17.6687719,17.248 17.5087719,16.8491228 C16.6245614,14.6407018 14.4659649,13.0804211 11.9410526,13.0804211 C9.45964912,13.0804211 7.33052632,14.5890526 6.41964912,16.7390877 C6.25263158,17.1313684 6.75087719,17.4710175 7.05684211,17.1744561 C8.80701754,15.4770526 12.5249123,13.061614 16.8659649,17.2797193" id="Fill-125" fill="#5E4939"></path>
						<polyline id="Fill-126" fill="#303030" points="10.0407018 7.66919298 9.23789474 8.47129825 6.56140351 5.79466667 7.36421053 4.99270175 10.0407018 7.66919298"></polyline>
						<polyline id="Fill-127" fill="#303030" points="14.6877193 8.47129825 13.8863158 7.66919298 16.562807 4.99270175 17.3642105 5.79466667 14.6877193 8.47129825"></polyline>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
		}
	},
	delete: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 16 16">
			<defs>
				<path id="__uuida__" d="M4 12.667C4 13.4 4.6 14 5.333 14h5.334C11.4 14 12 13.4 12 12.667v-8H4v8zm8.667-10h-2.334L9.667 2H6.333l-.666.667H3.333V4h9.334V2.667z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g transform="translate(-516 -192) translate(275 110) translate(15 74) translate(226 8)">
								<mask id="__uuidb__" fill="#fff">
									<use xlink:href="#__uuida__"/>
								</mask>
								<g __fill__ mask="url(#__uuidb__)">
									<path d="M0 0H33V33H0z" transform="translate(-9 -9)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
			</svg>
		`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003E7B',
		}
	},
	edit: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 16 11">
		<defs>
			<path id="__uuida__" d="M2 9.5V12h2.5l7.373-7.373-2.5-2.5L2 9.5zm11.807-6.807c.26-.26.26-.68 0-.94l-1.56-1.56c-.26-.26-.68-.26-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-1124 -454) translate(40 327) translate(15 107) translate(1068 20) translate(1)">
										<mask id="__uuidb__" fill="#fff">
											<use xlink:href="#__uuida__"/>
										</mask>
										<g __fill__ mask="url(#__uuidb__)">
											<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -10.667)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003E7B',
		}
	},
	female: {
		markup: `
			<svg __width__ __height__ viewBox="0 0 21 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<g id="Screen-Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="11_Member-details_both-saving-and-balance-Copy" transform="translate(-377.000000, -174.000000)" __fill__ fill-rule="nonzero" __stroke__ stroke-width="0.5">
						<g id="Group-24" transform="translate(286.000000, 162.000000)">
							<g id="Group-7-+-Group-7-Copy-3-+-Group-6-+-Group-6-Copy-+-Group-6-Copy-2-Mask">
								<g id="Group-6" transform="translate(76.000000, 13.000000)">
									<g id="woman" transform="translate(16.000000, 0.000000)">
										<path d="M18.7148758,24.1683191 L18.7148758,26.8572917 C18.7148758,27.1086805 18.5111254,27.3125 18.259822,27.3125 C18.0085185,27.3125 17.8047682,27.1086805 17.8047682,26.8572917 L17.8047682,24.1683191 C17.8047682,22.0747022 16.1111149,20.380303 14.0179812,20.3803599 C13.0276136,20.3803599 12.129053,19.8756477 11.6142734,19.030212 C11.4835023,18.8155243 11.5515328,18.5354574 11.7661476,18.4046419 C11.9807054,18.2737695 12.2607342,18.3418801 12.3915052,18.5565677 C12.739792,19.1284801 13.3478008,19.4698863 14.0179812,19.4698863 C16.6138924,19.4698863 18.7148758,21.5712418 18.7148758,24.1683191 L18.7148758,24.1683191 Z M11.1228722,20.6434134 L9.50003661,21.9001867 L6.74081798,19.7632681 C7.3364265,19.2846734 7.72157265,18.5885461 7.7839719,17.7979061 C8.32850063,17.9582533 8.9043712,18.0446859 9.50009349,18.0446859 C12.8561152,18.0446859 15.5864379,15.3134359 15.5864379,11.9562745 C15.5864379,11.920882 15.5872342,8.76913333 15.5849589,8.73385469 C15.5694871,8.48758698 15.364201,8.30749518 15.1313841,8.30749518 C15.0534561,8.30749518 14.492773,8.41845221 13.9439212,8.08814167 C13.0879651,7.57301654 13.0835852,6.44387227 13.083642,6.43254896 C13.0858604,6.06269219 12.6677798,5.84441979 12.3656809,6.05819701 C10.4913144,7.3855276 8.29658999,8.28558828 5.91341643,8.61931289 C5.66455889,8.65419323 5.49101275,8.88424414 5.52588125,9.1332431 C5.55773501,9.36084727 5.7526118,9.52540508 5.97598633,9.52540508 C6.0476573,9.52540508 7.5231692,9.34474427 9.20044057,8.73533411 C10.2810795,8.34271693 11.3164976,7.83037995 12.2872979,7.20850846 C12.6227294,8.46750091 13.5633825,9.16789583 14.6763872,9.23111289 L14.6763872,11.9562745 C14.6763872,14.8114549 12.3543615,17.1342693 9.50015037,17.1342693 C6.64593926,17.1342693 4.32391356,14.8114549 4.32391356,11.9562745 L4.32391356,8.76276042 C4.32391356,8.51137161 4.12016322,8.30755208 3.86885977,8.30755208 C3.61755632,8.30755208 3.41380598,8.51137161 3.41380598,8.76276042 L3.41380598,11.9563314 C3.41380598,14.3770155 4.83346003,16.4721118 6.8835911,17.4526875 L6.8835911,17.5727487 C6.8835911,18.6220608 6.03355063,19.4698863 4.98220574,19.4698863 C4.40650582,19.4698863 3.83928127,19.5740721 3.30271598,19.7792573 L3.00892188,19.5453371 C0.703448756,17.7097664 0.271659595,14.4693659 1.84392731,12.1084848 C2.51399401,11.1023036 2.90187048,9.89884661 2.90187048,8.61123294 L2.90187048,6.1455401 C2.90187048,3.25889336 5.24943607,0.910416667 8.13498901,0.910416667 L10.8653117,0.910416667 C13.7508647,0.910416667 16.0984303,3.25877956 16.0984303,6.1453125 L16.0984303,8.61100534 C16.0984303,9.86345417 16.4625302,11.0703253 17.1513678,12.1010876 C18.4111842,13.986276 18.4086814,16.460504 17.1069432,18.3500738 C16.9643407,18.5570798 17.0164444,18.8405608 17.2233801,18.9832117 C17.4303158,19.1258057 17.7136437,19.0736844 17.8562462,18.8666784 C19.3716321,16.6671686 19.3733955,13.7880328 17.9079516,11.5951236 C17.3195102,10.7145799 17.008481,9.68273646 17.008481,8.61100534 L17.008481,6.1453125 C17.008481,2.75679857 14.2526183,0 10.8652548,0 L8.13493213,0 C4.74756863,0 1.99170602,2.75691237 1.99170602,6.1455401 L1.99170602,8.61100534 C1.99170602,9.6796069 1.6786859,10.7144661 1.08637652,11.6038294 C-0.748343466,14.3590917 -0.228387634,18.1063667 2.41325647,20.2340673 C1.11555684,21.0856483 0.285254327,22.5318452 0.285254327,24.1683191 L0.285254327,26.8572917 C0.285254327,27.1086805 0.489004659,27.3125 0.740308112,27.3125 C0.991611565,27.3125 1.1953619,27.1086805 1.1953619,26.8572917 L1.1953619,24.1683191 C1.1953619,22.0746453 2.88901521,20.380303 4.98214886,20.3803599 C5.28373575,20.3803599 5.58168222,20.3325061 5.86739912,20.2382211 L9.22148681,22.8358105 C9.3855337,22.9628137 9.61465328,22.9628137 9.77864329,22.8358105 L11.6800286,21.3632685 C11.8787734,21.2093512 11.9151208,20.9234803 11.7612557,20.7246681 C11.6074476,20.5259697 11.3216738,20.4894961 11.1228722,20.6434134 L11.1228722,20.6434134 Z" id="Shape"></path>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 21,
			height: 29,
			fill: '#000000',
			stroke: '#000000',
		},
	},
	male: {
		markup: `
			<svg __width__ __height__ viewBox="0 0 21 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<g id="Screen-Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="11_Member-details_both-saving-and-balance-Copy" transform="translate(-306.000000, -173.000000)" __fill__ fill-rule="nonzero" __stroke__ stroke-width="0.5">
						<g id="Group-24" transform="translate(286.000000, 162.000000)">
							<g id="Group-7-+-Group-7-Copy-3-+-Group-6-+-Group-6-Copy-+-Group-6-Copy-2-Mask">
								<g id="Group-7" transform="translate(0.000000, 12.000000)">
									<g id="man" transform="translate(21.000000, 0.000000)">
										<path d="M18,24.4231388 L18,27.1400603 C18,27.394062 17.8009994,27.6 17.5555542,27.6 C17.310109,27.6 17.1111084,27.394062 17.1111084,27.1400603 L17.1111084,24.4231388 C17.1111084,22.3077035 15.4569366,20.5957503 13.412597,20.5958078 C12.4453162,20.5958078 11.5677024,20.0858497 11.0648675,19.2316266 C10.9372004,19.0147075 11.0035895,18.7316721 11.2132568,18.5995544 C11.4228686,18.4673792 11.6963139,18.5361402 11.8240365,18.7531168 C12.1641487,19.3309736 12.7579838,19.6759284 13.412597,19.6759284 C15.9479937,19.6758134 18,21.7991251 18,24.4231388 L18,24.4231388 Z M10.2440872,19.8126455 C10.2963651,20.0608404 10.1443091,20.3058733 9.90447501,20.3599737 C8.73480474,20.6236917 7.54518995,20.3596863 6.59802036,19.6906464 C5.6603508,20.7305127 4.4215692,20.5958078 4.58740305,20.5958078 C2.54323007,20.5957503 0.888891632,22.307531 0.888891632,24.4231388 L0.888891632,27.1400603 C0.888891632,27.394062 0.689891018,27.6 0.444445816,27.6 C0.199000614,27.6 0,27.394062 0,27.1400603 L0,24.4231388 C0,21.7994126 2.05161744,19.6759284 4.58729194,19.6759284 C5.61296177,19.6759284 6.44446433,18.8207279 6.44446433,17.7590146 L6.44446433,17.6378779 C4.5045139,16.6779262 3.14284303,14.6606881 3.05984278,12.3116034 C2.26150698,12.1129669 1.66667181,11.3734988 1.66667181,10.4936916 L1.66667181,8.10930655 C1.64239396,6.94220949 1.80983892,4.01912003 3.86934528,1.96468424 C6.41240868,-0.572228327 10.4906435,-0.411076944 13.4894305,1.08286479 C13.7817092,1.22860819 13.8260982,1.63726464 13.5833753,1.84889441 C15.1025466,2.23236916 16.4125507,3.19881752 17.2541644,4.58197127 C17.2976089,4.65320444 17.3771647,4.76502728 17.3563869,4.9434264 C17.343498,5.05444436 17.3115534,5.14838705 17.2288865,5.23520067 C16.6872182,5.80368618 16.3889395,6.55700996 16.3889395,7.3564427 L16.3889395,10.4938066 C16.3889395,10.7478083 16.1899389,10.9537463 15.9444937,10.9537463 C15.6990485,10.9537463 15.5000478,10.7478083 15.5000478,10.4938066 L15.5000478,7.3564427 C15.5000478,6.43443602 15.8044377,5.5592857 16.3634949,4.85626783 C15.5113812,3.59511309 14.1819327,2.78400937 12.6783725,2.61739621 L11.8972034,2.53081255 C11.4404242,2.48021918 11.3508128,1.82900202 11.7753141,1.64818821 L12.130593,1.49681055 C7.50357871,-0.172483209 2.55550789,1.68228124 2.55550789,8.10430471 L2.55550789,10.4936916 C2.55550789,10.8586538 2.75861963,11.1758397 3.05550943,11.3351513 L3.05550943,8.35341956 C3.05550943,6.57816719 4.4511804,5.13384145 6.16663014,5.13384145 L11.8333143,5.13384145 C13.548764,5.13384145 14.944435,6.5780522 14.944435,8.35324708 L14.944435,12.1191761 C14.944435,16.1191569 11.1673122,19.1574038 7.32385594,17.9864548 C7.29885586,18.3146218 7.21991117,18.6312903 7.09129966,18.9256517 C7.83896864,19.4569971 8.78313822,19.671329 9.71519665,19.4611365 C9.95503073,19.4070936 10.1918092,19.5644505 10.2440872,19.8126455 L10.2440872,19.8126455 Z M8.99997222,17.3160351 C11.7876475,17.3160351 14.0555434,14.9690776 14.0555434,12.0842207 L14.0555434,8.35324708 C14.0555434,7.08530823 13.0586514,6.05372091 11.8333143,6.05372091 L6.16663014,6.05372091 C4.94129303,6.05372091 3.94440106,7.08536573 3.94440106,8.35341956 L3.94440106,12.0842207 C3.94440106,14.9690776 6.21229695,17.3160351 8.99997222,17.3160351 Z M13.4999861,25.2428089 L12.1666487,25.2428089 C11.9212035,25.2428089 11.7222028,25.4487469 11.7222028,25.7027486 C11.7222028,25.9567503 11.9212035,26.1626883 12.1666487,26.1626883 L13.4999861,26.1626883 C13.7454313,26.1626883 13.9444319,25.9567503 13.9444319,25.7027486 C13.9444319,25.4487469 13.7454313,25.2428089 13.4999861,25.2428089 Z" id="Shape"></path>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 21,
			height: 29,
			fill: '#000000',
			stroke: '#000000',
		},
	},
	switchMember: {
		markup: `
			<svg __width__ __height__ viewBox="-0.7 0 30 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
				<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="Switch-Member">
						<g id="Group-9">
							<g id="admin" transform="translate(0, 0)" fill-rule="nonzero">
								<path d="M24.75,20.5125 C23.3850375,20.5125 22.275,19.4024625 22.275,18.0375 C22.275,16.6725375 23.3850375,15.5625 24.75,15.5625 C26.1149625,15.5625 27.225,16.6725375 27.225,18.0375 C27.225,19.4024625 26.1149625,20.5125 24.75,20.5125 Z" id="Path" fill="#003E7B"></path>
								<path d="M28.771875,26.7 C28.25955,26.7 27.84375,26.2842 27.84375,25.771875 L27.84375,25.153125 C27.84375,24.3004875 27.1495125,23.60625 26.296875,23.60625 L23.203125,23.60625 C22.3504875,23.60625 21.65625,24.3004875 21.65625,25.153125 L21.65625,25.771875 C21.65625,26.2842 21.24045,26.7 20.728125,26.7 C20.2158,26.7 19.8,26.2842 19.8,25.771875 L19.8,25.153125 C19.8,23.2758375 21.3258375,21.75 23.203125,21.75 L26.296875,21.75 C28.1741625,21.75 29.7,23.2758375 29.7,25.153125 L29.7,25.771875 C29.7,26.2842 29.2842,26.7 28.771875,26.7 Z" id="Path" fill="#003E7B"></path>
								<path d="M9.01875,22.28175 C8.96782059,22.28175 8.91689118,22.2764449 8.86702279,22.2668956 C8.77789632,22.2499191 0,20.4366199 0,10.5350934 L0,3.97899265 C0,3.65007353 0.201595588,3.35616838 0.508233088,3.23733309 L8.73121103,0.0542448529 C8.91583015,-0.0168441176 9.12060882,-0.0168441176 9.30522794,0.0542448529 L17.5282059,3.23733309 C17.8359044,3.35616838 18.0375,3.65007353 18.0375,3.97899265 L18.0375,10.5350934 C18.0375,20.4366199 9.25960368,22.2499191 9.17047721,22.2679566 C9.12060882,22.2764449 9.06967941,22.28175 9.01875,22.28175 L9.01875,22.28175 Z" id="Shape" stroke="#003E7B" stroke-width="2"></path>
								<polygon id="Path" __fill__ transform="translate(9.341879, 10.635373) rotate(-45.000000) translate(-9.341879, -10.635373) " points="12.8251539 10.9270653 7.58775457 10.9785337 7.61101854 8.61120512 5.89822285 8.62803693 5.85860488 12.6595407 12.8087999 12.5912405"></polygon>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 21,
			height: 29,
			fill: '#003E7B',
		},
	},
	other: {
		markup: `
		<svg __width__ __height__ viewBox="3 2 10 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<!-- Generator: sketchtool 58 (101010) - https://sketch.com -->
			<defs>
				<path d="M8,3.93333333 C8.77333333,3.93333333 9.4,4.56 9.4,5.33333333 C9.4,6.10666667 8.77333333,6.73333333 8,6.73333333 C7.22666667,6.73333333 6.6,6.10666667 6.6,5.33333333 C6.6,4.56 7.22666667,3.93333333 8,3.93333333 L8,3.93333333 Z M8,9.93333333 C9.98,9.93333333 12.0666667,10.9066667 12.0666667,11.3333333 L12.0666667,12.0666667 L3.93333333,12.0666667 L3.93333333,11.3333333 C3.93333333,10.9066667 6.02,9.93333333 8,9.93333333 L8,9.93333333 Z M8,2.66666667 C6.52666667,2.66666667 5.33333333,3.86 5.33333333,5.33333333 C5.33333333,6.80666667 6.52666667,8 8,8 C9.47333333,8 10.6666667,6.80666667 10.6666667,5.33333333 C10.6666667,3.86 9.47333333,2.66666667 8,2.66666667 L8,2.66666667 Z M8,8.66666667 C6.22,8.66666667 2.66666667,9.56 2.66666667,11.3333333 L2.66666667,13.3333333 L13.3333333,13.3333333 L13.3333333,11.3333333 C13.3333333,9.56 9.78,8.66666667 8,8.66666667 L8,8.66666667 Z" id="path-1"></path>
			</defs>
			<g id="Screen-Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="11_Member-details_both-saving-and-balance" transform="translate(-79.000000, -1723.000000)">
					<g id="Security-Settings" transform="translate(40.000000, 1640.000000)">
						<g id="Group-31-Copy-12">
							<g id="Group-28" transform="translate(20.000000, 67.000000)">
								<g id="ic_person_outline" transform="translate(19.000000, 16.000000)">
									<mask id="mask-2" fill="white">
										<use xlink:href="#path-1"></use>
									</mask>
									<use id="Mask" stroke="#FFFFFF" xlink:href="#path-1"></use>
									<g id="Colors/Black" mask="url(#mask-2)" __fill__>
										<g transform="translate(-9.000000, -9.000000)" id="Black">
											<rect x="0" y="0" width="33" height="33"></rect>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
		`,
		defaultStyles: {
			width: 21,
			height: 29,
			fill: '#000000',
		},
	},
	checkedContent: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 20 20">
			<defs>
				<path id="a0irwe8rfa" d="M15.833 1.667H12.35C12 .7 11.083 0 10 0 8.917 0 8 .7 7.65 1.667H4.167c-.917 0-1.667.75-1.667 1.666v13.334c0 .916.75 1.666 1.667 1.666h11.666c.917 0 1.667-.75 1.667-1.666V3.333c0-.916-.75-1.666-1.667-1.666zm-5.833 0c.458 0 .833.375.833.833 0 .458-.375.833-.833.833-.458 0-.833-.375-.833-.833 0-.458.375-.833.833-.833zM5.833 3.333v2.5h8.334v-2.5h1.666v13.334H4.167V3.333h1.666zm7.024 3.974l-3.71 3.709-1.676-1.677-1.212 1.213 2.855 2.855 4.921-4.922-1.178-1.178z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g transform="translate(-972 -222) translate(961 222) translate(11)">
							<mask id="h0yyn10nab" fill="#fff">
								<use xlink:href="#a0irwe8rfa"/>
							</mask>
							<g __fill__ mask="url(#h0yyn10nab)">
								<path d="M0 0H41.667V41.667H0z" transform="translate(-10.833 -10.833)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003e7b',
		},
	},
	checkmark: {
		markup: `
			<svg __width__ __height__  viewBox="0 -46 417.81333 417" xmlns="http://www.w3.org/2000/svg">
				<path __fill__ d="m159.988281 318.582031c-3.988281 4.011719-9.429687 6.25-15.082031 6.25s-11.09375-2.238281-15.082031-6.25l-120.449219-120.46875c-12.5-12.5-12.5-32.769531 0-45.246093l15.082031-15.085938c12.503907-12.5 32.75-12.5 45.25 0l75.199219 75.203125 203.199219-203.203125c12.503906-12.5 32.769531-12.5 45.25 0l15.082031 15.085938c12.5 12.5 12.5 32.765624 0 45.246093zm0 0" />
			</svg>
		`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#000000',
		}
	},
	cross: {
		markup: `
			<svg id="cross" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
				<g>
					<g>
						<path __fill__ d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872
							c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872
							c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052
							L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116
							c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952
							c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116
							c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"/>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#000000',
		}
	},
	arrow: {
		markup: `
		<svg id='arrow' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 18 18">
			<defs>
				<path id="z5g2kgh3ta" d="M7.5 4.5L6.442 5.558 9.877 9 6.442 12.443 7.5 13.5 12 9z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g transform="translate(-625 -195) translate(286 162) translate(336 30) translate(3 3)">
								<mask id="x3crrk6pjb" fill="#fff">
									<use xlink:href="#z5g2kgh3ta"/>
								</mask>
								<g __fill__ mask="url(#x3crrk6pjb)">
									<path d="M0 0H37.5V37.5H0z" transform="translate(-9.75 -9.75)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#003e7b',
		}
	},
	individual: {
		markup: `
			<svg id="individual" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 -1 18 18">
				<defs>
					<path id="rscrbok4va" d="M6 6c1.657 0 3-1.343 3-3S7.657 0 6 0 3 1.343 3 3s1.343 3 3 3zm0 1.5c-2.002 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g transform="translate(-218 -1236) translate(40 851) translate(35 383) translate(143 2)">
											<mask id="1cb38q1c5b" fill="#fff">
												<use xlink:href="#rscrbok4va"/>
											</mask>
											<g __fill__ mask="url(#1cb38q1c5b)">
												<path d="M0 0H38V38H0z" transform="translate(-13 -13)"/>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#000000',
		}
	},
	family: {
		markup: `
			<svg id="family" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 -1 18 18">
				<defs>
					<path id="kdhv69dtja" d="M11.375 6c1.035 0 1.867-.84 1.867-1.875 0-1.035-.832-1.875-1.867-1.875-1.035 0-1.875.84-1.875 1.875C9.5 5.16 10.34 6 11.375 6zM5.75 5.25c1.245 0 2.242-1.005 2.242-2.25S6.995.75 5.75.75 3.5 1.755 3.5 3s1.005 2.25 2.25 2.25zm5.625 2.25c-1.373 0-4.125.69-4.125 2.063v1.687h8.25V9.562c0-1.372-2.752-2.062-4.125-2.062zM5.75 6.75C4.003 6.75.5 7.628.5 9.375v1.875h5.25V9.562c0-.637.247-1.754 1.777-2.602-.652-.135-1.282-.21-1.777-.21z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g transform="translate(-400 -1236) translate(40 851) translate(35 383) translate(325 2)">
											<mask id="bnmckax97b" fill="#fff">
												<use xlink:href="#kdhv69dtja"/>
											</mask>
											<g __fill__ mask="url(#bnmckax97b)">
												<path d="M0 0H38V38H0z" transform="translate(-11 -13)"/>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#000000',
		}
	},
	rightArrow: {
		markup: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" __height__ __width__ viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 129 129"> <g> <path d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"/> </g> </svg> ',
		defaultStyles: {
			width: 12,
			height: 12
		}
	},
	leftArrow: {
		markup: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 129 129"> <g> <path d="m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z"/> </g> </svg>'
	},
	rightDoubleArrow: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="12" width="12" version="1.1" id="Capa_1" x="0px" y="0px" width="612.02px" height="612.02px" viewBox="0 0 612.02 612.02" style="enable-background:new 0 0 612.02 612.02;" xml:space="preserve"> <g> <g id="_x35__11_"> <g> <path d="M596.96,269.674L342.381,15.094c-20.079-20.079-52.644-20.079-72.723,0c-20.079,20.079-20.079,52.644,0,72.723 L487.852,306.01L269.658,524.202c-20.079,20.079-20.079,52.644,0,72.723s52.644,20.079,72.723,0L596.96,342.346 C617.039,322.317,617.039,289.753,596.96,269.674z M290.858,254.258L88.744,41.238c-20.309-21.378-53.204-21.378-73.513,0 s-20.309,56.058,0,77.462l165.371,174.289L15.231,467.278c-20.309,21.379-20.309,56.083,0,77.462s53.204,21.379,73.513,0 L290.858,331.72C311.167,310.342,311.167,275.662,290.858,254.258z"/> </g> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
	},
	leftDoubleArrow: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="12" width="12" version="1.1" id="Capa_1" x="0px" y="0px" width="612px" height="612px" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;" xml:space="preserve"> <g> <g id="_x34__11_"> <g> <path d="M124.172,305.975L342.365,87.781c20.079-20.079,20.079-52.644,0-72.722c-20.079-20.079-52.644-20.079-72.723,0 L15.062,269.639c-20.079,20.079-20.079,52.644,0,72.723l254.58,254.58c20.079,20.078,52.644,20.078,72.723,0 c20.079-20.079,20.079-52.644,0-72.723L124.172,305.975z M431.395,305.694l165.371-165.982c20.308-20.359,20.308-53.408,0-73.768 c-20.309-20.359-53.204-20.359-73.513,0L321.139,268.823c-20.309,20.359-17.047,35.266,3.032,55.345L523.253,545.47 c20.309,20.359,53.204,20.359,73.513,0c20.308-20.359,20.308-53.408,0-73.768L431.395,305.694z"/> </g> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
		defaultStyles: {
			transform: 'rotate(180deg)'
		}
	},
	warning: {
		markup: `
			<svg id="warning" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
				<g>
					<g>
						<path __fill__ d="M500.974,365.071L327.473,64.556C312.758,39.075,285.371,23.245,256,23.245c-29.371,0-56.758,15.83-71.473,41.313
							L11.026,365.071C3.812,377.565,0,391.806,0,406.255c0,45.49,37.01,82.5,82.5,82.5h347c45.49,0,82.5-37.01,82.5-82.5
							C512,391.806,508.187,377.565,500.974,365.071z M429.5,473.755h-347c-37.22,0-67.5-30.28-67.5-67.5
							c0-11.82,3.118-23.468,9.017-33.685L197.518,72.057C209.561,51.201,231.97,38.245,256,38.245c24.03,0,46.439,12.956,58.482,33.813
							l173.501,300.514c5.898,10.217,9.017,21.864,9.017,33.685C497,443.475,466.72,473.755,429.5,473.755z"/>
					</g>
				</g>
				<g>
					<g>
						<path __fill__ d="M466.333,385.069l-173.5-300.511C285.241,71.411,271.128,63.244,256,63.244s-29.241,8.166-36.832,21.313l-79.251,137.267
							c-2.071,3.587-0.842,8.174,2.745,10.245c3.588,2.069,8.174,0.841,10.245-2.745l79.251-137.267
							c4.92-8.52,14.056-13.813,23.842-13.813s18.923,5.294,23.843,13.814l173.5,300.512c2.427,4.203,3.657,8.808,3.657,13.686
							c0,15.163-12.337,27.5-27.5,27.5h-347c-15.163,0-27.5-12.337-27.5-27.5c0-4.878,1.23-9.482,3.657-13.686l79.25-137.267
							c2.071-3.587,0.842-8.174-2.745-10.245c-3.59-2.071-8.175-0.843-10.245,2.745L45.667,385.07C41.906,391.583,40,398.71,40,406.255
							c0,23.435,19.065,42.5,42.5,42.5h347c23.435,0,42.5-19.065,42.5-42.5C472,398.71,470.094,391.582,466.333,385.069z"/>
					</g>
				</g>
				<g>
					<g>
						<path __fill__ d="M256,128.755c-17.921,0-32.5,14.579-32.5,32.5v135c0,17.921,14.579,32.5,32.5,32.5s32.5-14.579,32.5-32.5v-135
							C288.5,143.334,273.921,128.755,256,128.755z M273.5,296.255c0,9.649-7.851,17.5-17.5,17.5s-17.5-7.851-17.5-17.5v-135
							c0-9.649,7.851-17.5,17.5-17.5s17.5,7.851,17.5,17.5V296.255z"/>
					</g>
				</g>
				<g>
					<g>
						<path __fill__ d="M256,343.755c-17.921,0-32.5,14.579-32.5,32.5c0,17.921,14.579,32.5,32.5,32.5s32.5-14.579,32.5-32.5
							C288.5,358.334,273.921,343.755,256,343.755z M256,393.755c-9.649,0-17.5-7.851-17.5-17.5s7.851-17.5,17.5-17.5
							s17.5,7.851,17.5,17.5S265.649,393.755,256,393.755z"/>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#e51a1a'
		}
	},
	danger: {
		markup: `
			<svg id="danger" __width__ __height__ viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<defs>
					<path d="M17.3333333,9.33333333 L14.6666667,9.33333333 L14.6666667,14.6666667 L9.33333333,14.6666667 L9.33333333,17.3333333 L14.6666667,17.3333333 L14.6666667,22.6666667 L17.3333333,22.6666667 L17.3333333,17.3333333 L22.6666667,17.3333333 L22.6666667,14.6666667 L17.3333333,14.6666667 L17.3333333,9.33333333 L17.3333333,9.33333333 Z M16,2.66666667 C8.65333333,2.66666667 2.66666667,8.65333333 2.66666667,16 C2.66666667,23.3466667 8.65333333,29.3333333 16,29.3333333 C23.3466667,29.3333333 29.3333333,23.3466667 29.3333333,16 C29.3333333,8.65333333 23.3466667,2.66666667 16,2.66666667 L16,2.66666667 Z M16,26.6666667 C10.12,26.6666667 5.33333333,21.88 5.33333333,16 C5.33333333,10.12 10.12,5.33333333 16,5.33333333 C21.88,5.33333333 26.6666667,10.12 26.6666667,16 C26.6666667,21.88 21.88,26.6666667 16,26.6666667 L16,26.6666667 Z" id="__uuidb__"></path>
				</defs>
				<g id="Screen-Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="86_Communication-Settings_delete-phone-confirmation" transform="translate(-510.000000, -404.000000)">
						<g id="Group-25" transform="translate(490.000000, 350.000000)">
							<g id="Rectangle">
								<g id="ic_control_point">
									<g transform="translate(43.000000, 77.000000) rotate(-315.000000) translate(-43.000000, -77.000000) translate(27.000000, 61.000000)">
										<mask id="__uuida__" fill="white">
											<use xlink:href="#__uuidb__"></use>
										</mask>
										<g id="Mask"></g>
										<g id="Colors/Black-Copy-4" mask="url(#__uuida__)" __fill__>
											<g transform="translate(-17.333333, -17.333333)" id="Black">
												<rect x="0" y="0" width="66.6666667" height="66.6666667"></rect>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#e51a1a'
		}
	},
	settings: {
		markup: `
			<svg id="settings" xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="-2 0 511 512">
				<path __fill__ d="m500.628906 311.332031-27.960937-16.144531c-30.160157-17.414062-30.1875-60.949219 0-78.375l27.960937-16.144531c7.171875-4.144531 9.628906-13.316407 5.488282-20.488281l-60.242188-104.355469c-4.136719-7.167969-13.316406-9.632813-20.492188-5.492188l-27.960937 16.144531c-30.15625 17.410157-67.863281-4.324218-67.863281-39.1875v-32.289062c0-8.285156-6.714844-15-15-15h-120.488282c-8.28125 0-15 6.714844-15 15v32.289062c0 34.828126-37.671874 56.617188-67.863281 39.1875l-27.960937-16.144531c-7.167969-4.140625-16.347656-1.683593-20.492188 5.492188l-60.242187 104.355469c-4.140625 7.171874-1.683594 16.347656 5.488281 20.488281l27.960938 16.144531c30.160156 17.414062 30.1875 60.949219 0 78.375l-27.957032 16.144531c-7.175781 4.144531-9.632812 13.316407-5.492187 20.488281l60.242187 104.355469c4.136719 7.167969 13.316406 9.636719 20.492188 5.492188l27.960937-16.144531c30.152344-17.414063 67.863281 4.320312 67.863281 39.1875v32.289062c0 8.285156 6.714844 15 15 15h120.484376c8.285156 0 15-6.714844 15-15v-32.289062c0-34.820313 37.671874-56.621094 67.867187-39.1875l27.960937 16.144531c7.167969 4.140625 16.347657 1.683593 20.488282-5.492188l60.246094-104.355469c4.140624-7.171874 1.683593-16.34375-5.488282-20.488281zm-73.238281 96.855469-14.96875-8.644531c-50.160156-28.964844-112.863281 7.195312-112.863281 65.167969v17.289062h-90.488282v-17.289062c0-57.921876-62.664062-94.15625-112.863281-65.167969l-14.96875 8.644531-45.246093-78.375 14.96875-8.644531c50.15625-28.957031 50.207031-101.347657.003906-130.335938l-14.972656-8.644531 45.246093-78.375 14.96875 8.644531c50.160157 28.964844 112.863281-7.195312 112.863281-65.167969v-17.289062h90.488282v17.289062c0 57.921876 62.660156 94.15625 112.863281 65.167969l14.96875-8.644531 45.246094 78.375-14.96875 8.644531c-50.15625 28.957031-50.207031 101.347657-.003907 130.335938l14.972657 8.644531zm0 0" />
				
				<path __fill__ d="m254.316406 151c-57.894531 0-104.992187 47.101562-104.992187 105s47.097656 105 104.992187 105c57.890625 0 104.988282-47.101562 104.988282-105s-47.097657-105-104.988282-105zm0 180c-41.351562 0-74.992187-33.644531-74.992187-75s33.640625-75 74.992187-75c41.347656 0 74.988282 33.644531 74.988282 75s-33.640626 75-74.988282 75zm0 0" />
			</svg>
		`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#000000'
		}
	},
	logout: {
		markup: `
			<svg version="1.1" id="logout" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  __width__ __height__ x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
				<g>
					<g>
						<path __fill__ d="M336.709,74.843c-10.322-3.944-21.88,1.219-25.825,11.537c-3.945,10.316,1.22,21.879,11.536,25.824
							C393.115,139.239,442,207.384,442,286c0,102.561-83.439,186-186,186S70,388.561,70,286c0-78.659,48.908-146.766,119.573-173.793
							c10.317-3.946,15.481-15.509,11.536-25.825c-3.947-10.317-15.512-15.48-25.825-11.536C89.185,107.777,30,190.692,30,286
							c0,124.922,101.09,226,226,226c124.922,0,226-101.09,226-226C482,190.65,422.778,107.759,336.709,74.843z"/>
					</g>
				</g>
				<g>
					<g>
						<path __fill__ d="M256,0c-11.046,0-20,8.954-20,20v195.851c0,11.046,8.954,20,20,20s20-8.955,20-20V20C276,8.954,267.046,0,256,0z"/>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#000000'
		}
	},
	tabs: {
		markup: `
			<svg id="tabs" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
				<g>
					<g>
						<g>
							<path __fill__ d="M224,0H0v512h512V64H224V0z M480,480H32V192h448V480z M480,96v64H32V32h160v64H480z"/>
							<rect __fill__ x="64" y="64" width="32" height="32"/>
							<rect __fill__ x="128" y="64" width="32" height="32"/>
							<rect __fill__ x="256" width="256" height="32"/>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#000000'
		}
	},
	hollowSuccessCheck: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="167" height="166" viewBox="0 0 167 166">
			<defs>
				<path id="k9ry9qvk3a" d="M106.712 60.646L75.928 91.431 62.013 77.516 51.946 87.583l23.696 23.697 40.852-40.852-9.782-9.782zM83 13.833C44.89 13.833 13.833 44.89 13.833 83c0 38.11 31.056 69.167 69.167 69.167 38.11 0 69.167-31.056 69.167-69.167 0-38.11-31.056-69.167-69.167-69.167zm0 124.5c-30.502 0-55.333-24.83-55.333-55.333 0-30.502 24.83-55.333 55.333-55.333 30.502 0 55.333 24.83 55.333 55.333 0 30.502-24.83 55.333-55.333 55.333z"/>
			</defs>
			<g fill="none" fill-rule="evenodd" opacity=".498">
				<g>
					<g transform="translate(-636 -371) translate(637 371)">
						<mask id="ioyuoter6b" fill="#fff">
							<use xlink:href="#k9ry9qvk3a"/>
						</mask>
						<use stroke="#FFF" stroke-width="2" xlink:href="#k9ry9qvk3a"/>
						<g fill="#30DFA2" mask="url(#ioyuoter6b)">
							<path d="M0 0H345.833V345.833H0z" transform="translate(-89.917 -89.917)"/>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	hollowErrorCross: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="196" height="196" viewBox="0 0 196 196">
			<defs>
				<path id="cn9od3ns3a" d="M76.08 34.58H62.25v27.67H34.58v13.83h27.67v27.67h13.83V76.08h27.67V62.25H76.08V34.58zM69.165 0C31.052 0 0 31.052 0 69.165c0 38.113 31.052 69.165 69.165 69.165 38.113 0 69.165-31.052 69.165-69.165C138.33 31.052 107.278 0 69.165 0zm0 124.5c-30.503 0-55.335-24.832-55.335-55.335S38.662 13.83 69.165 13.83 124.5 38.662 124.5 69.165 99.668 124.5 69.165 124.5z"/>
			</defs>
			<g fill="none" fill-rule="evenodd" opacity=".5">
				<g>
					<g transform="translate(-610 -297) rotate(45 -4.604 1002.907)">
						<mask id="eabb5wx23b" fill="#fff">
							<use xlink:href="#cn9od3ns3a"/>
						</mask>
						<g fill="#E51A1A" fill-rule="nonzero" mask="url(#eabb5wx23b)">
							<path d="M0 0L345.835 0 345.835 345.835 0 345.835z" transform="translate(-103.75 -103.75)"/>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	transferCall: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="16" viewBox="0 0 17 16">
			<defs>
				<path id="o29elhy2ta" d="M5 2c.367 0 .667.3.667.667 0 .833.133 1.633.38 2.38.073.233.02.493-.167.68L4.413 7.193c.96 1.887 2.507 3.427 4.394 4.394l1.466-1.467c.18-.18.447-.24.68-.16.747.247 1.554.38 2.38.38.367 0 .667.3.667.667v2.326c0 .367-.3.667-.667.667C7.073 14 2 8.927 2 2.667 2 2.3 2.3 2 2.667 2H5zm3.675.31l.651.013.07 3.508 2.584.051-1.082-1.081.453-.453 1.886 1.885-1.812 1.812-.471-.472 1.04-1.039-3.236-.065-.083-4.16z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-186 -118) translate(40 110) translate(142 5) translate(5 3)">
									<mask id="fd9b94r87b" fill="#fff">
										<use xlink:href="#o29elhy2ta"/>
									</mask>
									<g fill="#003E7B" mask="url(#fd9b94r87b)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -8.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
		`
	},
	cart: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19" height="18" viewBox="0 0 19 18">
			<defs>
				<path id="o2evt7arja" d="M5.25 13.5c-.825 0-1.493.675-1.493 1.5s.668 1.5 1.493 1.5c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5zm7.5 0c-.825 0-1.492.675-1.492 1.5s.667 1.5 1.492 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm-7.372-2.438l.022-.09.675-1.222h5.587c.563 0 1.058-.307 1.313-.773L15.87 3.72 14.565 3h-.008l-.825 1.5-2.07 3.75H6.397L6.3 8.047 4.62 4.5 3.908 3l-.705-1.5H.75V3h1.5l2.7 5.693-1.013 1.837c-.12.21-.187.458-.187.72 0 .825.675 1.5 1.5 1.5h9v-1.5H5.565c-.098 0-.188-.082-.188-.188z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-1281 -445) translate(40 327) translate(15 110) translate(1227 8)">
									<mask id="h6ugj2bzib" fill="#fff">
										<use xlink:href="#o2evt7arja"/>
									</mask>
									<g fill="#003E7B" mask="url(#h6ugj2bzib)">
										<path d="M0 0H37.5V37.5H0z" transform="translate(-9.75 -9.75)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	cancelOrder: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 21 20">
			<defs>
				<path id="y1ed28mjia" d="M7.643 5.464L6.464 6.643 8.821 9l-2.357 2.357 1.179 1.179L10 10.179l2.357 2.357 1.179-1.179L11.179 9l2.357-2.357-1.179-1.179L10 7.821 7.643 5.464zM10 .667C5.408.667 1.667 4.408 1.667 9c0 4.592 3.741 8.333 8.333 8.333 4.592 0 8.333-3.741 8.333-8.333 0-4.592-3.741-8.333-8.333-8.333zm0 15c-3.675 0-6.667-2.992-6.667-6.667S6.325 2.333 10 2.333 16.667 5.325 16.667 9 13.675 15.667 10 15.667z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g transform="translate(-1316 -222) translate(1292 223) rotate(90 23 22)">
							<mask id="g7p5xv0zsb" fill="#fff">
								<use xlink:href="#y1ed28mjia"/>
							</mask>
							<g __fill__ mask="url(#g7p5xv0zsb)">
								<path d="M0 0H41.667V41.667H0z" transform="translate(-10.833 -11.833)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 21,
			height: 20,
			fill: '#003E7B',
		}
	},
	reorder: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 21 20">
			<defs>
				<path id="4kuq16bb0a" d="M6.117 5.342l-5.4 5.408 5.408 5.4 5.408-5.4-5.416-5.408zM3.075 10.75l3.05-3.05 3.042 3.05-3.05 3.05-3.042-3.05zm13.058-5.217c-1.458-1.466-3.383-2.2-5.3-2.2v-2.7L7.3 4.167 10.833 7.7V5c1.492 0 2.984.567 4.125 1.708 2.275 2.275 2.275 5.975 0 8.25-1.141 1.142-2.633 1.709-4.125 1.709-.808 0-1.616-.175-2.366-.509L7.225 17.4c1.125.617 2.367.933 3.608.933 1.917 0 3.842-.733 5.3-2.2 2.934-2.925 2.934-7.675 0-10.6z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g transform="translate(-1111 -222) translate(1097 222) translate(14)">
							<mask id="3yrrisjrpb" fill="#fff">
								<use xlink:href="#4kuq16bb0a"/>
							</mask>
							<g __fill__ mask="url(#3yrrisjrpb)">
								<path d="M0 0H41.667V41.667H0z" transform="translate(-10.833 -10.833)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 21,
			height: 20,
			fill: '#003E7B'
		}
	},
	payBalance: {
		markup: `
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 100 66"><path d="M51.5 13.4c-20.3 3.9-21.2 4.2-22 6.6-.7 2.2 3.3 24 4.7 25.7.6.7 2.1 1.3 3.4 1.3 1.5 0 2.4.6 2.4 1.5 0 3.5 4.3 3.9 17.2 1.6 6.8-1.3 12.7-2.7 13.2-3.2 1.5-1.4-1.5-1.1-14.7 1.2-7.4 1.4-12.2 1.8-12.8 1.2-.7-.7-5-20-4.9-22.3.1-2.2 4-3.4 20.6-6.5L77.5 17l1.8 2.1c.9 1.2 1.7 3.2 1.7 4.5 0 1.3.5 2.4 1 2.4.6 0 1-1.3 1-2.9 0-2.9-3.3-8.1-5.2-8.1-.6 0-2.1-1.1-3.4-2.5-1.3-1.4-3.1-2.5-4.1-2.4-1 0-9.4 1.5-18.8 3.3zm21.4.3c.9 1.6-.7 2.1-16.7 5-22.1 4.1-21.4 3.4-18.7 17.6 1.8 9.5 1.8 8.7 0 8.7-2 0-2.1-.4-4.4-13-1.6-8.3-1.7-10.8-.7-11.8.6-.6 9.3-2.7 19.1-4.6 21.9-4.1 20.2-4 21.4-1.9z"/><path d="M57.4 25c-3.2 1.3-5.4 5-5.4 9.1 0 4.6 4.5 8.9 9.2 8.9 4.3 0 8.8-4.8 8.8-9.4 0-6.4-6.9-11.1-12.6-8.6zm8.9 4.2c2.6 3 2.2 7.3-.9 9.7C63.9 40.1 62 41 61 41c-3.3 0-7-3.9-7-7.4 0-6.8 7.8-9.5 12.3-4.4z"/><path d="M58.4 31.2c-.4.6 0 1.6.9 2.3 1.8 1.3 2.4 3 .7 2-.5-.3-1-.2-1 .4 0 1.5 1.6 2.2 3.4 1.5 2.1-.8 2-3-.1-4.3-1.1-.6-1.3-1.1-.5-1.1 1.8 0 .5-2-1.3-2-.8 0-1.7.5-2.1 1.2zM82.4 31.7c1.8 9.3 1.8 10.1-.1 11.1-1 .5-3.5 1.2-5.5 1.6-2.1.4-3.8 1.2-3.8 1.8 0 1 4.5.6 9.3-.8 3.6-1.1 4.4-6.5 2.1-14.7-.9-2.8-2.6-1.9-2 1zM25.5 35.9c-.3.5-.1 1.2.5 1.6 1.2.7 3-.2 3-1.6 0-1.2-2.7-1.2-3.5 0zM16.3 37.7c-1.3.2-2.3.9-2.3 1.5 0 1.3 6.9.3 8.4-1.2 1-1-1.6-1.2-6.1-.3zM21.3 42.8c-2.9.8-5.3 1.9-5.3 2.3 0 1.2 1.2 1.1 6.6-.2 4.3-1.1 6.2-2.4 4.7-3.2-.5-.2-3.2.3-6 1.1zM25.2 48.8c-1.9.6-2.9 1.7-1.9 2.4.8.5 7.7-1.5 7.7-2.2 0-1.1-2.3-1.1-5.8-.2zM15.5 52.1c-.4.6-.5 1.2-.2 1.5.7.7 3.7-.7 3.7-1.7 0-1.3-2.7-1.1-3.5.2z"/></svg>
		`,
		defaultStyles: {
			width: 15,
			height: 15,
			fill: '#000000'
		}
	},
	savingsUpTo: {
		markup: `
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 72 72"><path d="M35.2 13.2c-1.9 1.9-1.5 10.5.5 11.7 1.6.8 1.5 1.1-.7 2.9-1.4 1.2-2.1 2.4-1.6 2.9.5.4 1.1.2 1.3-.5.3-.9 3.7-1.2 11.9-1.2H58v2.5C58 34 58 34 48 34c-6 0-10 .4-10 1s4 1 10 1h10v18.2l-9-.4c-5-.1-9 0-9 .4 0 .5 4.1.8 9.1.8 6.8 0 9 .3 8.7 1.2-.3.9-3.6 1.4-10.6 1.6-13.2.4-13.4 2.2-.3 2.2 13.5 0 13.1.5 13.1-17 0-13-.1-14-2.1-15.4-2-1.3-2-1.6-.6-3 1.7-1.7 2-8.1.6-10.9-.8-1.4-2.5-1.7-11.2-1.7-6.7 0-10.7.4-11.5 1.2zM57 18.5V23H36v-9h21v4.5zM54 26c0 .6-3.3 1-8 1s-8-.4-8-1 3.3-1 8-1 8 .4 8 1zM15.2 18.6c-1.2 1.3-1.1 1.8.4 3.5 1.8 2 1.8 2 3.8-.1 2-2 2-2 .1-3.5-2.5-1.8-2.7-1.8-4.3.1zM18 20c0 .5-.5 1-1.1 1-.5 0-.7-.5-.4-1 .3-.6.8-1 1.1-1 .2 0 .4.4.4 1zM24.3 23.4l-2.1 2.2 2.5 2.2 2.5 2.2 2.3-2.2 2.3-2.2-2.1-2.3c-2.6-2.7-2.6-2.7-5.4.1zm4 1.2c.3.3.3 1.2 0 2-.4 1.1-.9 1.2-1.9.3-.8-.6-1.1-1.5-.8-2 .6-1 1.8-1.2 2.7-.3z"/><path d="M25 35c-1.1 1.1-2 2.9-2 4 0 1.5-.7 2-2.6 2-1.5 0-3.8 1.2-5.5 2.9-4 4-4 9.1-.1 13.1 2.7 2.7 3.4 2.8 10.9 2.8 11.1 0 12.2-1.1 12.4-13.1.1-7.9-.1-9.1-2.2-11.3-2.8-3-8.1-3.2-10.9-.4zm10.5 2.3c.8 1.2 1.5 3.4 1.5 4.9 0 2.6-.3 2.8-3.7 2.8-2.5-.1-4.8-.9-6.7-2.4-2.4-2-2.7-2.6-1.6-4.5 2.2-4.3 7.8-4.6 10.5-.8zm-7.7 8c1 1.3 1.5 3.8 1.3 7.2-.1 1.5-1.2.9-5.6-3.5-4.6-4.5-5.2-5.6-3.8-6.1 2.1-.7 6.7.7 8.1 2.4zm-.4 10.8c-.5.8-11.4-10.3-11.4-11.7 0-.4 2.7 1.8 6 5.1 3.2 3.2 5.7 6.2 5.4 6.6zM37 47c0 .5-1.3 1-2.9 1-1.7 0-3.3-.5-3.6-1-.4-.6.8-1 2.9-1 2 0 3.6.4 3.6 1zM21.9 57.8c-4.4.5-7.9-3-7.9-7.7v-3.5l5.5 5.4 5.6 5.5-3.2.3zm15.1-6c0 3.2-2.9 6.2-6.1 6.2-2.9 0-3-.1-1.5-2.2.9-1.2 1.6-3 1.6-4 0-1.3.8-1.8 3-1.8s3 .5 3 1.8zM40 39c0 .6 3 1 7 1h7v6l-7-.3c-3.8-.2-7 0-7 .5 0 .4 3.6.8 8 .8h8v-9h-8c-4.7 0-8 .4-8 1z"/></svg>
		`,
		defaultStyles: {
			width: 15,
			height: 15,
			fill: '#000000'
		}
	},
	usernameInfo: {
		markup: `
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 58 56"><path d="M25.2 18.6c-2.8 1.9-3 7.4-.4 9.7 3.7 3.4 11 1.3 11.3-3.1.5-7-5.3-10.6-10.9-6.6zm7.7 3.2c1.3 2.4-.4 5.2-3.3 5.2-2.6 0-4-2.3-3.1-5.1.8-2.4 5.1-2.5 6.4-.1zM20 34.9c-3.7 1.9-5.7 5.7-4.7 8.5C15.8 44.8 18 45 30 45h14v-2.6c0-6.3-4.7-9.4-14.2-9.4-4.3 0-7.5.6-9.8 1.9zm16.9 2.2c1.7.6 3.1 1.7 3.1 2.5 0 1.1-2.2 1.4-10.5 1.4-8.4 0-10.5-.3-10.5-1.4 0-3.1 11.6-4.7 17.9-2.5z" class="selected" fill="#4a4a4a" fill-opacity="1" /></svg>
		`,
		defaultStyles: {
			width: 15,
			height: 15,
		}
	},
	emailInfo: {
		markup: `
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 210 186"><path d="M59.4 59.9c-2.3 1-4.4 2.6-4.7 3.6-1.2 3-.8 69.4.4 71.7 2.4 4.5 5.2 4.8 49.3 4.8 35.9 0 42.1-.2 45.6-1.6 2.8-1.1 4.2-2.4 4.8-4.3.9-3.4.9-66.8 0-70.2-1.5-5.2-2.8-5.4-48.8-5.6-39.8-.3-42.8-.2-46.6 1.6zm84.4 9.3c.2 1.1-1.7 2.8-6.3 5.5-3.7 2.1-7.7 4.5-8.9 5.3-8.6 5.8-10.9 7.2-12.4 7.8-.9.3-3.2 1.6-5.1 2.9-5.6 3.8-7.5 3.8-12.6.4-2.5-1.7-4.8-3.1-5.1-3.1-.2 0-4.4-2.6-9.2-5.7-4.8-3.2-10.3-6.6-12.2-7.6-4.7-2.5-7.4-5.2-6.6-6.6.5-.8 11.8-1 39.4-.9 35.2.3 38.7.5 39 2zM75.5 84.8c5 3.2 9.7 6.1 10.5 6.5.8.4 5 2.9 9.3 5.7 4.3 2.7 8.6 5 9.5 5 1.5 0 6.2-2.8 24.7-14.6 12.6-8.1 13.6-8.6 16.1-8l2.4.6v24.3c0 17.6-.3 24.6-1.2 25.5-1.7 1.7-82.9 1.7-84.6 0-1.3-1.3-1.8-44.1-.6-48.6 1-3.5 4.2-2.7 13.9 3.6z" class="selected" fill="#4a4a4a" fill-opacity="1" /></svg>
		`,
		defaultStyles: {
			width: 15,
			height: 15,
			fill: '#000000'
		}
	},
	editEmail: {
		markup: `
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 168 156"><path d="M107.5 39.3c-2.5 2.4-4.5 5-4.5 5.7 0 1.7 15.2 17 16.8 17 2 0 9.2-7.1 9.8-9.7.6-2.1-.5-3.6-6.7-9.9-4-4.1-8.1-7.4-9.1-7.4s-3.8 1.9-6.3 4.3zM65.7 80.8L38 108.6V127h18.5l27.9-27.9c19.9-19.9 27.6-28.3 27-29.2-3.2-5.4-15-16.9-17.3-16.9-.4 0-13.1 12.5-28.4 27.8z" class="selected" fill="#003e7b" fill-opacity="1" /></svg>
		`,
		defaultStyles: {
			width: 15,
			height: 15,
			fill: '#000000'
		}
	},
	backArrow: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32px" height="30px" viewBox="0 0 32 30" version="1.1">
		<desc>Created with Sketch.</desc>
		<defs>
			<path d="M17.692515,7 L26,15.5 L17.692515,24 L15.740256,22.0025 L20.806,16.807 L6,16.8070303 L6,14.0550914 L20.673,14.055 L15.740256,8.9975 L17.692515,7 Z" id="path-1"/>
		</defs>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<mask id="mask-2" fill="white">
				<use xlink:href="#path-1"/>
			</mask>
			<use id="Combined-Shape" fill="#003E7B" transform="translate(16.000000, 15.500000) rotate(-180.000000) translate(-16.000000, -15.500000) " xlink:href="#path-1"/>
		</g>
	</svg>`
	},
	checkedCircle: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 20 20">
			<defs>
				<path id="tn444ltnfa" d="M12.857 6.307l-3.71 3.709-1.676-1.677L6.26 9.552l2.855 2.855 4.921-4.922-1.178-1.178zM10 .667C5.408.667 1.667 4.408 1.667 9c0 4.592 3.741 8.333 8.333 8.333 4.592 0 8.333-3.741 8.333-8.333 0-4.592-3.741-8.333-8.333-8.333zm0 15c-3.675 0-6.667-2.992-6.667-6.667S6.325 2.333 10 2.333 16.667 5.325 16.667 9 13.675 15.667 10 15.667z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g transform="translate(-1207 -223) translate(1174 223) translate(33)">
							<mask id="5o5xzxqfqb" fill="#fff">
								<use xlink:href="#tn444ltnfa"/>
							</mask>
							<use stroke="#FFF" stroke-width="2" xlink:href="#tn444ltnfa"/>
							<g __fill__ mask="url(#5o5xzxqfqb)">
								<path d="M0 0H41.667V41.667H0z" transform="translate(-10.833 -11.833)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 20,
			height: 20,
			fill: '#003e7b',
		}
	},
	viewMore: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="17" viewBox="0 0 18 17">
			<defs>
				<path id="jw2n4bd33a" d="M9.264 7.066c0-.587.475-1.062 1.062-1.062.587 0 1.063.475 1.063 1.062 0 .587-.476 1.063-1.063 1.063s-1.062-.476-1.062-1.063zm-3.188 0c0-.587.476-1.062 1.063-1.062.586 0 1.062.475 1.062 1.062 0 .587-.476 1.063-1.062 1.063-.587 0-1.063-.476-1.063-1.063zm-3.187 0c0-.587.475-1.062 1.062-1.062.587 0 1.063.475 1.063 1.062 0 .587-.476 1.063-1.063 1.063S2.89 7.653 2.89 7.066zM7.083 0C3.18 0 0 3.18 0 7.083s3.18 7.084 7.083 7.084 7.084-3.18 7.084-7.084C14.167 3.18 10.987 0 7.083 0zm0 12.75c-3.123 0-5.666-2.543-5.666-5.667 0-3.123 2.543-5.666 5.666-5.666 3.124 0 5.667 2.543 5.667 5.666 0 3.124-2.543 5.667-5.667 5.667z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g>
									<g>
										<g>
											<g transform="translate(-1313 -453) translate(40 327) translate(15 107) translate(1255 19) translate(4) translate(1.417 .417)">
												<mask id="ypwdikgpcb" fill="#fff">
													<use xlink:href="#jw2n4bd33a"/>
												</mask>
												<g __fill__ mask="url(#ypwdikgpcb)">
													<path d="M0 0H35.417V35.417H0z" transform="translate(-10.625 -10.625)"/>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003e7b',
		}
	},
	statusError: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 32 32">
			<defs>
				<path id="n8j72pq1wa" d="M10.394 2.271c.943-1.623 3.024-2.174 4.648-1.23.51.296.934.72 1.23 1.23l9.858 16.96c.944 1.623.393 3.704-1.23 4.648-.52.301-1.109.46-1.71.46H3.477c-1.878 0-3.4-1.522-3.4-3.4 0-.6.159-1.19.46-1.709zm3.143 1.144c-.268-.096-.574.009-.722.263l-9.858 16.96c-.053.091-.081.195-.081.301 0 .331.268.6.6.6H23.19c.106 0 .21-.028.301-.081.287-.167.384-.534.218-.82l-9.858-16.96c-.052-.09-.127-.165-.217-.217zm-.204 14.25c.737 0 1.334.597 1.334 1.334 0 .736-.597 1.333-1.334 1.333-.736 0-1.333-.597-1.333-1.333 0-.737.597-1.334 1.333-1.334zm0-10.092c.768 0 1.334.726 1.334 1.622v6.09c0 .895-.566 1.622-1.334 1.622-.767 0-1.333-.727-1.333-1.622v-6.09c0-.896.566-1.622 1.333-1.622z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-495 -391) translate(470 329) translate(25 62) translate(2.667 2.667)">
									<mask id="hcgu5hdskb" fill="#fff">
										<use xlink:href="#n8j72pq1wa"/>
									</mask>
									<use __fill__ fill-rule="nonzero" xlink:href="#n8j72pq1wa"/>
									<g fill="#89BBE8" mask="url(#hcgu5hdskb)">
										<path d="M0 0H66.667V66.667H0z" transform="translate(-20 -20)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	defaultStyles: {
		width: 32,
		height: 32,
		fill: '#979797',
	},
	cancelledStatus: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 46 46">
		<defs>
			<path id="omg0u551za" d="M17.333 9.333h-2.666v5.334H9.333v2.666h5.334v5.334h2.666v-5.334h5.334v-2.666h-5.334V9.333zM16 2.667C8.653 2.667 2.667 8.653 2.667 16S8.653 29.333 16 29.333 29.333 23.347 29.333 16 23.347 2.667 16 2.667zm0 24C10.12 26.667 5.333 21.88 5.333 16S10.12 5.333 16 5.333 26.667 10.12 26.667 16 21.88 26.667 16 26.667z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g transform="translate(-510 -424) translate(490 350) rotate(45 -68.276 89.092)">
							<mask id="mfl7ch492b" fill="#fff">
								<use xlink:href="#omg0u551za"/>
							</mask>
							<g fill="#E51A1A" mask="url(#mfl7ch492b)">
								<path d="M0 0H66.667V66.667H0z" transform="translate(-17.333 -17.333)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	warningBlue: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 33 32">
			<defs>
				<path id="ajq4r2bs4a" d="M10.394 2.271c.943-1.623 3.024-2.174 4.648-1.23.51.296.934.72 1.23 1.23l9.858 16.96c.944 1.623.393 3.704-1.23 4.648-.52.301-1.109.46-1.71.46H3.477c-1.878 0-3.4-1.522-3.4-3.4 0-.6.159-1.19.46-1.709zm3.143 1.144c-.268-.096-.574.009-.722.263l-9.858 16.96c-.053.091-.081.195-.081.301 0 .331.268.6.6.6H23.19c.106 0 .21-.028.301-.081.287-.167.384-.534.218-.82l-9.858-16.96c-.052-.09-.127-.165-.217-.217zm-.204 14.25c.737 0 1.334.597 1.334 1.334 0 .736-.597 1.333-1.334 1.333-.736 0-1.333-.597-1.333-1.333 0-.737.597-1.334 1.333-1.334zm0-10.092c.768 0 1.334.726 1.334 1.622v6.09c0 .895-.566 1.622-1.334 1.622-.767 0-1.333-.727-1.333-1.622v-6.09c0-.896.566-1.622 1.333-1.622z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-518 -432) translate(490 350) translate(29 82) translate(2.667 2.667)">
									<mask id="13xdpyyz9b" fill="#fff">
										<use xlink:href="#ajq4r2bs4a"/>
									</mask>
									<use fill="#979797" fill-rule="nonzero" xlink:href="#ajq4r2bs4a"/>
									<g __fill__ mask="url(#13xdpyyz9b)">
										<path d="M0 0H66.667V66.667H0z" transform="translate(-20 -20)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 33,
			height: 32,
			fill: '#89BBE8',
		}
	},
	callerIconPharmacy: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 14 14">
				<defs>
					<path id="splcj0enja" d="M5.833 1.167c1.611 0 2.917 1.306 2.917 2.916v5.834c0 1.61-1.306 2.916-2.917 2.916-1.61 0-2.916-1.306-2.916-2.916V4.083c0-1.61 1.306-2.916 2.916-2.916zm2.628 5.541H3.276v.9h5.185v-.9z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g transform="translate(-52 -214) translate(40 162) translate(12 52) translate(.167)">
											<mask id="idp64tclvb" fill="#fff">
												<use xlink:href="#splcj0enja"/>
											</mask>
											<use fill="#2D2D2D" fill-rule="nonzero" transform="rotate(-30 5.833 7)" xlink:href="#splcj0enja"/>
											<g fill="#000" mask="url(#idp64tclvb)">
												<path d="M0 0H29.167V29.167H0z" transform="translate(-8.75 -7)"/>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 14,
			height: 14,
		}
	},
	callerIconMember: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 14 14">
				<defs>
					<path id="5efecslbba" d="M10.833 0c1.105 0 2 .895 2 2v8.833c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0h8.833zM6.708 7.802c-1.46 0-4.375.733-4.375 2.188v1.093h8.75V9.99c0-1.455-2.915-2.188-4.375-2.188zm0-5.469c-1.208 0-2.187.98-2.187 2.188 0 1.208.979 2.187 2.187 2.187 1.209 0 2.188-.979 2.188-2.187 0-1.209-.98-2.188-2.188-2.188z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g transform="translate(-51 -214) translate(40 162) translate(11 52) translate(.583 .583)">
											<mask id="yj69z4qztb" fill="#fff">
												<use xlink:href="#5efecslbba"/>
											</mask>
											<use fill="#D8D8D8" xlink:href="#5efecslbba"/>
											<g fill="#4A4A4A" mask="url(#yj69z4qztb)">
												<path d="M0 0H29.167V29.167H0z" transform="translate(-8.167 -8.167)"/>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 14,
			height: 14,
		}
	},
	callerIconClient: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 14 14">
				<defs>
					<path id="lwye3kr6sa" d="M10.083.75H1.917C1.275.75.756 1.275.756 1.917L.75 10.083c0 .642.525 1.167 1.167 1.167h8.166c.642 0 1.167-.525 1.167-1.167V1.917c0-.642-.525-1.167-1.167-1.167zM9.5 7.167H7.167V9.5H4.833V7.167H2.5V4.833h2.333V2.5h2.334v2.333H9.5v2.334z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-52 -215) translate(40 162) translate(12 53)">
										<mask id="igze6lzczb" fill="#fff">
											<use xlink:href="#lwye3kr6sa"/>
										</mask>
										<g fill="#000" mask="url(#igze6lzczb)">
											<path d="M0 0H29.167V29.167H0z" transform="translate(-8.583 -8.583)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 14,
			height: 14,
		}
	},
	pill: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 16 16">
			<defs>
				<path id="lxz67omwma" d="M6.667 1.333C8.507 1.333 10 2.826 10 4.667v6.666c0 1.841-1.492 3.334-3.333 3.334-1.841 0-3.334-1.493-3.334-3.334V4.667c0-1.841 1.493-3.334 3.334-3.334zM9.67 7.667H3.744v1.029H9.67v-1.03z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-888 -264) translate(40 256) translate(831 8) translate(17) translate(1.333)">
										<mask id="f05ycfd6xb" fill="#fff">
											<use xlink:href="#lxz67omwma"/>
										</mask>
										<use __fill__ fill-rule="nonzero" transform="rotate(-30 6.667 8)" xlink:href="#lxz67omwma"/>
										<g __fill__ mask="url(#f05ycfd6xb)">
											<path d="M0 0H33.333V33.333H0z" transform="translate(-10 -8)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003E7B',
		}
	},
	idCard: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
		<defs>
				<path id="ftnm1ipjxa" d="M6.667 13.333H3.333v1.334h3.334V16l2-2-2-2v1.333zm2.666 0v1.334h3.334v-1.334H9.333zM8 5.333c.733 0 1.333-.6 1.333-1.333S8.733 2.667 8 2.667 6.673 3.267 6.673 4 7.267 5.333 8 5.333zM11.333 0H4.667c-.734 0-1.334.6-1.334 1.333v9.334c0 .733.6 1.333 1.334 1.333h6.666c.734 0 1.334-.6 1.334-1.333V1.333C12.667.6 12.067 0 11.333 0zM4.667 1.333h6.666v7c0-1.113-2.22-1.666-3.333-1.666s-3.333.553-3.333 1.666v-7z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-85 -249) translate(40 241) translate(35 8) translate(10)">
									<mask id="s48z7akt4b" fill="#fff">
										<use xlink:href="#ftnm1ipjxa"/>
									</mask>
									<g __fill__ mask="url(#s48z7akt4b)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -8.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	notesAdd: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
			<defs>
				<path id="hfuxuzldqa" d="M9.333.333H4c-.733 0-1.327.6-1.327 1.334l-.006 10.666c0 .734.593 1.334 1.326 1.334H12c.733 0 1.333-.6 1.333-1.334v-8l-4-4zm1.334 9.334h-2v2H7.333v-2h-2V8.333h2v-2h1.334v2h2v1.334zM8.667 5V1.333L12.333 5H8.667z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-185 -250) translate(40 241) translate(120 9) translate(25)">
									<mask id="sgguh4saib" fill="#fff">
										<use xlink:href="#hfuxuzldqa"/>
									</mask>
									<g __fill__ mask="url(#sgguh4saib)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -9.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	priorAuthorization: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
		<defs>
			<path id="8njs25tjha" d="M13.333 8.333c-.833 0-1.633-.133-2.38-.38-.233-.073-.493-.02-.68.16L8.807 9.58c-1.887-.96-3.434-2.5-4.394-4.387L5.88 3.72c.187-.18.24-.44.167-.673C5.8 2.3 5.667 1.5 5.667.667 5.667.3 5.367 0 5 0H2.667C2.3 0 2 .3 2 .667 2 6.927 7.073 12 13.333 12c.367 0 .667-.3.667-.667V9c0-.367-.3-.667-.667-.667zM8 0v6.667l2-2h4V0H8z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-296 -251) translate(40 241) translate(235 10) translate(21)">
									<mask id="14987iyznb" fill="#fff">
										<use xlink:href="#8njs25tjha"/>
									</mask>
									<g __fill__ mask="url(#14987iyznb)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -10.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	priceTag: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
			<defs>
				<path id="ekjbzsv6ca" d="M14.273 6.72l-6-6C8.033.48 7.7.333 7.333.333H2.667c-.734 0-1.334.6-1.334 1.334v4.666c0 .367.147.7.394.947l6 6c.24.24.573.387.94.387.366 0 .7-.147.94-.394l4.666-4.666c.247-.24.394-.574.394-.94 0-.367-.154-.707-.394-.947zM3.667 3.667c-.554 0-1-.447-1-1 0-.554.446-1 1-1 .553 0 1 .446 1 1 0 .553-.447 1-1 1z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-405 -250) translate(40 241) translate(345 9) translate(20)">
									<mask id="ahftur45gb" fill="#fff">
										<use xlink:href="#ekjbzsv6ca"/>
									</mask>
									<g __fill__ mask="url(#ahftur45gb)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -9.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	mail: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
			<defs>
				<path id="e1jywh657a" d="M13.333.667H2.667c-.734 0-1.327.6-1.327 1.333l-.007 8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V2c0-.733-.6-1.333-1.334-1.333zm0 2.666L8 6.667 2.667 3.333V2L8 5.333 13.333 2v1.333z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-506 -251) translate(40 241) translate(451 10) translate(15)">
									<mask id="wxjkynmzpb" fill="#fff">
										<use xlink:href="#e1jywh657a"/>
									</mask>
									<g __fill__ mask="url(#wxjkynmzpb)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -10.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	userProfile: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 16 16">
		<defs>
				<path id="szzbar3bda" d="M12.667 0c1.104 0 2 .895 2 2v10.667c0 1.104-.896 2-2 2H2c-1.105 0-2-.896-2-2V2C0 .895.895 0 2 0h10.667zm-5 8.917c-1.67 0-5 .837-5 2.5v1.25h10v-1.25c0-1.663-3.332-2.5-5-2.5zm0-6.25c-1.382 0-2.5 1.118-2.5 2.5 0 1.38 1.118 2.5 2.5 2.5 1.38 0 2.5-1.12 2.5-2.5 0-1.382-1.12-2.5-2.5-2.5z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-596 -249) translate(40 241) translate(536 8) translate(20) translate(.667 .667)">
										<mask id="ctsm946jzb" fill="#fff">
											<use xlink:href="#szzbar3bda"/>
										</mask>
										<use fill="#D8D8D8" xlink:href="#szzbar3bda"/>
										<g __fill__ mask="url(#ctsm946jzb)">
											<path d="M0 0H33.333V33.333H0z" transform="translate(-9.333 -9.333)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	creditAdd: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#003e7b"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"/></svg>`,
		defaultStyles: {
			width: 19,
			height: 18,
			fill: '#003E7B'
		}
	},
	deactivateMember: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 19 18">
			<defs>
				<path id="94gly15i4a" d="M11.25 6c1.658 0 3-1.343 3-3s-1.342-3-3-3-3 1.343-3 3 1.342 3 3 3zm-6.44-.75l1.592-1.591-1.061-1.06-1.591 1.59L2.159 2.6l-1.06 1.06 1.59 1.591L1.1 6.841l1.06 1.06 1.591-1.59L5.341 7.9l1.06-1.06-1.59-1.591zm6.44 2.25c-2.002 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-693 -251) translate(40 241) translate(632 10) translate(21)">
									<mask id="xxjspp8qrb" fill="#fff">
										<use xlink:href="#94gly15i4a"/>
									</mask>
									<g __fill__ mask="url(#xxjspp8qrb)">
										<path d="M0 0H37.5V37.5H0z" transform="translate(-9.75 -12.75)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 19,
			height: 18,
			fill: '#003E7B'
		}
	},
	manualOrder: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
			<defs>
				<path id="n5q6zydaga" d="M12.667 1.667H9.88C9.6.893 8.867.333 8 .333s-1.6.56-1.88 1.334H3.333C2.6 1.667 2 2.267 2 3v9.333c0 .734.6 1.334 1.333 1.334h9.334c.733 0 1.333-.6 1.333-1.334V3c0-.733-.6-1.333-1.333-1.333zM8 1.667c.367 0 .667.3.667.666C8.667 2.7 8.367 3 8 3c-.367 0-.667-.3-.667-.667 0-.366.3-.666.667-.666zM9.333 11H4.667V9.667h4.666V11zm2-2.667H4.667V7h6.666v1.333zm0-2.666H4.667V4.333h6.666v1.334z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-792 -250) translate(40 241) translate(729 9) translate(23)">
									<mask id="nn7r0494ob" fill="#fff">
										<use xlink:href="#n5q6zydaga"/>
									</mask>
									<g __fill__ mask="url(#nn7r0494ob)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -9.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	website: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 19 18">
			<defs>
				<path id="4cn68qh6na" d="M15 0H3c-.825 0-1.492.675-1.492 1.5l-.008 9c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-9C16.5.675 15.825 0 15 0zm-3.75 10.5H3v-3h8.25v3zm0-3.75H3v-3h8.25v3zM15 10.5h-3V3.75h3v6.75z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-986 -251) translate(40 241) translate(920 10) translate(26)">
									<mask id="8dmf9wwxpb" fill="#fff">
										<use xlink:href="#4cn68qh6na"/>
									</mask>
									<g __fill__ mask="url(#8dmf9wwxpb)">
										<path d="M0 0H37.5V37.5H0z" transform="translate(-9.75 -12.75)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 19,
			height: 18,
			fill: '#003E7B'
		}
	},
	slimPhone: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
		<defs>
				<path id="xrg0itli4a" d="M4.413 5.193C5.373 7.08 6.92 8.62 8.807 9.587l1.466-1.467c.18-.18.447-.24.68-.16.747.247 1.554.38 2.38.38.367 0 .667.3.667.667v2.326c0 .367-.3.667-.667.667C7.073 12 2 6.927 2 .667 2 .3 2.3 0 2.667 0H5c.367 0 .667.3.667.667 0 .833.133 1.633.38 2.38.073.233.02.493-.167.68L4.413 5.193z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-1215 -251) translate(40 241) translate(1146 10) translate(29)">
									<mask id="j8l16v7uob" fill="#fff">
										<use xlink:href="#xrg0itli4a"/>
									</mask>
									<g __fill__ mask="url(#j8l16v7uob)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -10.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	drug: {
		markup: `
			<svg __width__ __height__ viewBox="0 0 30 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
				<title>icon 2</title>
				<desc>Created with Sketch.</desc>
				<g id="icon-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="Group" transform="translate(2.000000, 2.000000)" fill-rule="nonzero">
						<polygon id="Path" fill="#FFFDFA" transform="translate(5.396906, 21.598256) rotate(-45.000000) translate(-5.396906, -21.598256) " points="4.49704216 16.7310601 6.29677034 16.7310601 6.29677034 26.4654524 4.49704216 26.4654524"></polygon>
						<g fill="#000000">
							<path d="M15.75,18.9 L15.75,19.8 L24.3,19.8 C24.5485281,19.8 24.75,19.5985281 24.75,19.35 L24.75,15.3 C24.75,15.0514719 24.5485281,14.85 24.3,14.85 L15.75,14.85 L15.75,15.75 L23.85,15.75 L23.85,18.9 L15.75,18.9 Z" id="Path"></path>
							<path d="M26.1,23.4 L15.75,23.4 L15.75,24.3 L26.1,24.3 C26.0988809,25.2936486 25.2936486,26.0988809 24.3,26.1 L14.4,26.1 C14.2789466,26.100047 14.1581919,26.087987 14.0395388,26.064 L13.8604613,26.946 C14.0380569,26.9819462 14.218803,27.0000001 14.4,27.0000001 L24.3,27.0000001 C25.790471,26.9983168 26.9983168,25.790471 27,24.3 L27,15.75 L26.1,15.75 L26.1,23.4 Z" id="Path"></path>
							<path d="M24.75,8.55 L24.75,7.2 L25.0875,7.2 C25.6464313,7.19938 26.09938,6.74643129 26.1,6.1875 L26.1,1.575 C26.0990266,0.705555027 25.394445,0.000973383979 24.525,-3.55271368e-15 L16.2,-3.55271368e-15 L16.2,0.9 L24.525,0.9 C24.8976162,0.900424677 25.1995753,1.20238384 25.2,1.575 L25.2,6.1875 C25.199938,6.24960633 25.1496063,6.29993799 25.0875,6.3 L13.6125,6.3 C13.5503937,6.29993799 13.500062,6.24960633 13.5,6.1875 L13.5,1.575 C13.5004247,1.20238384 13.8023838,0.900424677 14.175,0.9 L17.4891892,0.9 L17.4891892,-3.55271368e-15 L14.175,-3.55271368e-15 C13.305555,0.000973383979 12.6009734,0.705555027 12.6,1.575 L12.6,6.1875 C12.60062,6.74643129 13.0535687,7.19938 13.6125,7.2 L13.95,7.2 L13.95,8.55 L13.8375,8.55 C12.6575478,8.55134223 11.7013422,9.50754776 11.7,10.6875 L11.7,10.8 L12.6,10.8 L12.6,10.6875 C12.6007688,10.0043663 13.1543663,9.45076878 13.8375,9.45 L24.8625,9.45 C25.5456337,9.45076878 26.0992312,10.0043663 26.1,10.6875 L26.1,12.6 L14.85,12.6 L14.85,13.5 L26.1,13.5 L26.1,17.0391892 L27,17.0391892 L27,10.6875 C26.9986578,9.50754776 26.0424522,8.55134223 24.8625,8.55 L24.75,8.55 Z M14.85,8.55 L14.85,7.2 L23.85,7.2 L23.85,8.55 L14.85,8.55 Z" id="Shape"></path>
							<path d="M14.85,16.0875 C14.8472597,13.6654866 12.8845134,11.7027403 10.4625,11.7 L10.2375,11.7 C8.15376079,11.7042506 5.91934996,13.2017701 6.02073813,16.2864972 L6.90277188,16.4655184 C6.90277188,13.8259873 8.58141206,12.6031301 10.2375,12.6 L10.4625,12.6 C12.3876935,12.6021699 13.9478301,14.1623065 13.95,16.0875 L13.95,18.45 L9.79054054,18.45 L9.79054054,19.35 L13.95,19.35 L13.95,20.25 L10.2405405,20.25 L10.2405405,21.15 L13.95,21.15 L13.95,22.6125 C13.9478301,24.5376935 12.3876935,26.0978301 10.4625,26.1 L10.2375,26.1 C9.8650662,26.1004224 9.49497331,26.0411306 9.14131125,25.9243819 C8.84967715,25.7569892 8.65987734,25.6742565 8.57191181,25.6761836 C8.01995819,25.6882759 7.74433894,26.1164892 7.70975315,26.2210506 C7.68980191,26.2813681 8.07278045,26.467291 8.85868875,26.7788194 C9.30351877,26.9257586 9.7690294,27.0004331 10.2375,27.0000362 L10.4625,27.0000362 C12.8845134,26.9972597 14.8472597,25.0345134 14.85,22.6125 L14.85,16.0875 Z" id="Path"></path>
							<path d="M10.8,21.6 C10.8,18.6176624 8.38233765,16.2 5.4,16.2 C2.41766235,16.2 -1.42108547e-14,18.6176624 -1.42108547e-14,21.6 C-1.42108547e-14,24.5823376 2.41766235,27 5.4,27 C8.38094081,26.9966304 10.7966304,24.5809408 10.8,21.6 Z M9.38957625,23.6804006 L3.31961625,17.6104125 C4.71442435,16.8825525 6.38812316,16.9361838 7.73347127,17.751848 C9.07881939,18.5675123 9.9003499,20.026701 9.90000669,21.5999982 C9.9008875,22.3245746 9.72572265,23.0385169 9.38957625,23.6804006 Z M4.36818937,21.2046019 L3.73181062,21.8409862 L7.48038375,25.5895875 C5.73811761,26.4987522 3.60735087,26.1718733 2.21773951,24.7822503 C0.828128147,23.3926274 0.501267059,21.2618579 1.41044625,19.5195994 L3.73181063,21.8409862 L4.368195,21.2046075 L1.91712375,18.7535306 C2.10766323,18.5208365 2.32085165,18.3076499 2.5535475,18.1171125 L8.88287625,24.4464637 C8.69233835,24.679161 8.4791498,24.8923496 8.2464525,25.0828875 L4.36818937,21.2046019 Z" id="Shape"></path>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 30,
			height: 31,
		}
	},
	claimant: {
		markup: `
			<svg __width__ __height__ viewBox="0 0 25 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
				<title>icon</title>
				<desc>Created with Sketch.</desc>
				<g id="icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					<g id="doctor" transform="translate(2.000000, 1.000000)" fill="#000000" fill-rule="nonzero">
						<circle id="Oval" cx="13.0273438" cy="10.1953125" r="1"></circle>
						<circle id="Oval" cx="8.49609375" cy="10.1953125" r="1"></circle>
						<path d="M10.7617188,15.859375 C11.7200215,15.859375 12.5785801,15.2524141 12.8980898,14.3489961 C13.0023652,14.0540684 12.8478496,13.7304238 12.5529219,13.6261484 C12.2581641,13.5219863 11.9344063,13.6763887 11.8300742,13.9713164 C11.6703477,14.423082 11.2409551,14.7265625 10.7617188,14.7265625 C10.2824824,14.7265625 9.85308984,14.423082 9.69336328,13.9713164 C9.58908789,13.6763887 9.26544336,13.5219863 8.97051563,13.6261484 C8.67558789,13.7304238 8.52107227,14.0540684 8.62534766,14.3489961 C8.94485742,15.2524141 9.80341602,15.859375 10.7617188,15.859375 Z" id="Path"></path>
						<path d="M8.97460937,27.8671875 C8.6617832,27.8671875 8.40820312,28.1208242 8.40820312,28.4335938 C8.40820312,28.7463633 8.6617832,29 8.97460937,29 L20.9570312,29 C21.2698574,29 21.5234375,28.7463633 21.5234375,28.4335938 L21.5234375,23.7539453 C21.5234375,21.2152559 19.6549766,19.0661406 17.1467031,18.7078887 L14.8709961,18.3828281 C14.2545195,18.2942422 13.7492852,17.8301289 13.6239395,17.2061191 C14.8177539,16.4208535 15.9062168,15.1583906 16.7361152,13.59375 L16.9921875,13.59375 C18.2414531,13.59375 19.2578125,12.5773906 19.2578125,11.328125 C19.2578125,10.4813477 18.7745547,9.71256445 18.0400391,9.32780469 C18.0400391,9.32780469 18.125,7.37149414 18.125,7.36328125 C18.125,3.30311133 14.821832,0 10.7617188,0 C6.70160547,0 3.3984375,3.30311133 3.3984375,7.36328125 C3.3984375,7.37149414 3.39860742,7.37970703 3.39894727,7.38791992 L3.4833418,9.32780469 C2.74888281,9.71256445 2.265625,10.4813477 2.265625,11.328125 C2.265625,12.5773906 3.28198438,13.59375 4.53125,13.59375 L4.78732227,13.59375 C5.61727734,15.1585039 6.70579688,16.4209668 7.89949805,17.2061191 C7.77494531,17.8256543 7.27180664,18.2937891 6.65289453,18.3827715 L4.37696094,18.7078887 C1.86421289,19.066707 0,21.2195039 0,23.7539453 L0,28.4335938 C0,28.7463633 0.253580078,29 0.56640625,29 L13.8769531,29 C14.1897793,29 14.4433594,28.7463633 14.4433594,28.4335938 C14.4433594,28.1208242 14.1897793,27.8671875 13.8769531,27.8671875 L11.328125,27.8671875 L11.328125,23.4212949 L14.4944492,19.4628516 C14.5656465,19.4791641 14.6375234,19.4937207 14.7105332,19.5041426 L15.859375,19.6682871 L16.9921875,19.8302793 C18.9300332,20.1100273 20.390625,21.795709 20.390625,23.7539453 L20.390625,27.8671875 L8.97460937,27.8671875 Z M10.7617188,22.3158965 L8.07672656,18.9592031 C8.47066211,18.6461504 8.76474023,18.2267266 8.92491992,17.7512285 C9.52938867,17.9991445 10.1445625,18.125 10.7617188,18.125 C11.378875,18.125 11.9939922,17.9990879 12.5984609,17.7512852 C12.7587539,18.2271797 13.0528887,18.6468301 13.4465977,18.9596563 L10.7617188,22.3158965 Z M10.7617188,1.1328125 C14.1932344,1.1328125 16.9857305,3.92117383 16.9921875,7.3512168 L16.9218965,8.9661543 C16.3031543,8.74117773 15.859375,8.14673437 15.859375,7.45220703 L15.859375,7.36328125 C15.859375,7.05051172 15.6057949,6.796875 15.2929688,6.796875 L13.2958203,6.796875 C11.948623,6.796875 10.7376465,6.04870898 10.1355,4.84435937 C10.0180273,4.60941406 9.75430859,4.48616406 9.49874609,4.54637305 C9.24312695,4.60675195 9.0625,4.83495703 9.0625,5.09765625 C9.0625,6.03460547 8.30023047,6.796875 7.36328125,6.796875 L6.23046875,6.796875 C5.91764258,6.796875 5.6640625,7.05051172 5.6640625,7.36328125 L5.6640625,7.45220703 C5.6640625,8.14707422 5.21977344,8.74180078 4.60171094,8.96649414 L4.53125,7.3512168 C4.53770703,3.92117383 7.33020313,1.1328125 10.7617188,1.1328125 Z M5.64083984,12.7758027 C5.54523047,12.582998 5.34857422,12.4609375 5.13333984,12.4609375 L4.53125,12.4609375 C3.90661719,12.4609375 3.3984375,11.9527578 3.3984375,11.328125 C3.3984375,10.426123 4.25807227,10.2521797 4.375375,10.1758848 C5.57791211,10.0343965 6.54641016,9.11024805 6.75513086,7.9296875 L7.36328125,7.9296875 C8.44421094,7.9296875 9.38569141,7.32091406 9.86283203,6.42825781 C10.7313594,7.37523242 11.9630664,7.9296875 13.2958203,7.9296875 L14.7683066,7.9296875 C14.9769141,9.10939844 15.9445059,10.0331504 17.147666,10.1756016 C17.2617969,10.2500273 18.125,10.4301445 18.125,11.328125 C18.125,11.9527578 17.6168203,12.4609375 16.9921875,12.4609375 L16.3900977,12.4609375 C16.1748633,12.4609375 15.978207,12.5829414 15.8825977,12.7758027 C14.8858926,14.7866016 13.007916,16.9921875 10.7617187,16.9921875 C8.52203516,16.9921875 6.65272461,14.8173008 5.64083984,12.7758027 Z M1.1328125,27.8671875 L1.1328125,23.7539453 C1.1328125,21.7957656 2.59329102,20.1101973 4.53125,19.8303359 L5.6640625,19.6683437 L6.81330078,19.5041426 C6.88614062,19.4936641 6.95784766,19.4792207 7.02881836,19.4629648 L10.1953125,23.4212949 L10.1953125,27.8671875 L1.1328125,27.8671875 Z" id="Shape"></path>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 25,
			height: 31,
		}
	},
	add: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 32 32">
				<defs>
					<path id="0c3thtr66a" d="M17.25 2.412L15.588 0.75 9 7.338 2.412 0.75 0.75 2.412 7.338 9 0.75 15.588 2.412 17.25 9 10.662 15.588 17.25 17.25 15.588 10.662 9z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g>
										<g transform="translate(-157 -1802) translate(40 1701) translate(20 67) translate(100 33) rotate(45 6.172 15.828)">
											<mask id="p5rdc5rfzb" fill="#fff">
												<use xlink:href="#0c3thtr66a"/>
											</mask>
											<g fill="#003E7B" mask="url(#p5rdc5rfzb)">
												<path d="M0 0H45.833V45.833H0z" transform="translate(-13.917 -13.917)"/>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 32,
			height: 32,
		}
	},
	patient: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
		<g fill="none" fill-rule="evenodd">
			<g fill="#000" fill-rule="nonzero">
				<g>
					<g transform="translate(-100 -442) translate(70 420) translate(30 22)">
						<path d="M27.453 24.719h-1.696c-.218-1.07-1.062-1.915-2.132-2.133v-3.883c0-1.32-.94-2.425-2.188-2.68v-5.851h.547c.302 0 .547.245.547.547 0 .904.736 1.64 1.64 1.64.906 0 1.642-.736 1.642-1.64-.051-2.298-1.855-3.828-3.829-3.828h-3.336c-.302 0-.546.245-.546.546 0 .302.244.547.546.547h3.336c1.508 0 2.735 1.227 2.735 2.735 0 .301-.246.547-.547.547-.302 0-.547-.246-.547-.547-.095-1.122-.875-1.64-1.64-1.64H20.89c-.302 0-.547.244-.547.546v6.344H19.25V9.625c0-.302-.245-.547-.547-.547h-8.312c-.302 0-.547.245-.547.547v2.134c-.36-.073-.726-.122-1.094-.146V4.922c0-1.508-1.227-2.734-2.734-2.734H1.64c-.302 0-.547-.246-.547-.547 0-.302.245-.547.547-.547h4.375c2.11 0 3.828 1.717 3.828 3.828v2.516c0 .301.245.546.547.546h3.336c.302 0 .546-.245.546-.546 0-.302-.244-.547-.546-.547h-2.79V4.92C10.938 2.209 8.73 0 6.016 0H1.64C.736 0 0 .736 0 1.64c0 .905.736 1.641 1.64 1.641h4.376c.904 0 1.64.736 1.64 1.64v6.691C3.432 11.888 0 15.396 0 19.797 0 24.332 3.67 28 8.203 28c4.404 0 7.909-3.435 8.185-7.656h6.143v2.242c-1.246.254-2.187 1.36-2.187 2.68 0 1.507 1.226 2.734 2.734 2.734 1.32 0 2.425-.94 2.68-2.188h1.695c.302 0 .547-.244.547-.546 0-.302-.245-.547-.547-.547zm-9.297-14.547v5.797H15.46c-.96-1.818-2.575-3.217-4.523-3.907v-1.89h7.22zm-7.273 9.078c-.07-.344-.205-.669-.399-.96l3.118-3.118c.41.479.755 1.007 1.027 1.578.375.791.597 1.63.663 2.5h-4.41zm-9.768 1.094h4.408c.07.343.205.669.399.96l-3.118 3.119c-.988-1.15-1.575-2.568-1.69-4.08zm1.689-5.173l3.118 3.118c-.194.292-.33.617-.399.961H1.115c.114-1.512.7-2.929 1.689-4.079zm5.4 2.985c.437 0 .848.171 1.159.482.31.31.48.721.48 1.159 0 .438-.17.85-.48 1.16-.31.31-.722.48-1.16.48-.437 0-.85-.17-1.16-.481-.31-.31-.48-.721-.48-1.16 0-.437.17-.848.481-1.159.31-.31.722-.48 1.16-.48zm-1.509 3.922c.293.194.618.329.961.399v4.408c-1.512-.114-2.929-.7-4.079-1.689l3.119-3.118zm2.055.399c.344-.07.669-.205.96-.399l3.119 3.118c-1.15.988-2.567 1.575-4.079 1.69v-4.41zm4.078-8.079l-3.117 3.118c-.292-.194-.618-.33-.961-.399V12.71c1.526.116 2.938.713 4.078 1.69zm-5.172 2.72c-.343.069-.669.204-.96.398l-3.119-3.118c1.15-.989 2.568-1.575 4.08-1.69v4.41zm5.946 7.305l-3.118-3.118c.194-.293.33-.618.399-.962h4.409c-.115 1.513-.701 2.93-1.69 4.08zm2.786-5.173c-.05-.752-.2-1.483-.449-2.188h4.952c.904 0 1.64.736 1.64 1.641v.547h-6.143zm6.69 7.656c-.905 0-1.64-.736-1.64-1.64 0-.905.735-1.641 1.64-1.641.905 0 1.64.736 1.64 1.64 0 .905-.735 1.641-1.64 1.641z"/>
						<circle cx="16.188" cy="7.438" r="1"/>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	doctor: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="29" viewBox="0 0 22 29">
		<g fill="none" fill-rule="evenodd">
			<g fill="#000" fill-rule="nonzero">
				<g>
					<g transform="translate(-755 -441) translate(725 420) translate(30 21)">
						<circle cx="13.027" cy="10.195" r="1"/>
						<circle cx="8.496" cy="10.195" r="1"/>
						<path d="M10.762 15.86c.958 0 1.817-.608 2.136-1.511.104-.295-.05-.619-.345-.723-.295-.104-.619.05-.723.345-.16.452-.589.756-1.068.756-.48 0-.909-.304-1.069-.756-.104-.295-.428-.449-.722-.345-.295.104-.45.428-.346.723.32.903 1.178 1.51 2.137 1.51z"/>
						<circle cx="16.426" cy="28.434" r="1"/>
						<path d="M18.975 27.867c-.313 0-.567.254-.567.567 0 .312.254.566.567.566h1.982c.313 0 .566-.254.566-.566v-4.68c0-2.539-1.868-4.688-4.376-5.046l-2.276-.325c-.616-.089-1.122-.553-1.247-1.177 1.194-.785 2.282-2.048 3.112-3.612h.256c1.25 0 2.266-1.017 2.266-2.266 0-.847-.483-1.615-1.218-2l.085-1.965c0-4.06-3.303-7.363-7.363-7.363-4.06 0-7.364 3.303-7.364 7.363v.025l.085 1.94c-.734.385-1.217 1.153-1.217 2 0 1.25 1.016 2.266 2.265 2.266h.256c.83 1.565 1.919 2.827 3.112 3.612-.124.62-.627 1.088-1.246 1.177l-2.276.325C1.864 19.067 0 21.22 0 23.754v4.68c0 .312.254.566.566.566h13.311c.313 0 .566-.254.566-.566 0-.313-.253-.567-.566-.567h-2.549v-4.446l3.166-3.958c.072.016.144.03.217.041l1.148.164v3.765c-.659.234-1.132.864-1.132 1.602 0 .937.762 1.7 1.699 1.7s1.699-.763 1.699-1.7c0-.738-.474-1.368-1.133-1.602V19.83c1.938.28 3.399 1.966 3.399 3.924v4.113h-1.416zm-8.213-5.551l-2.685-3.357c.394-.313.688-.732.848-1.208.604.248 1.22.374 1.837.374s1.232-.126 1.836-.374c.16.476.455.896.849 1.209l-2.685 3.356zm0-21.183c3.431 0 6.224 2.788 6.23 6.218l-.07 1.615c-.619-.225-1.063-.82-1.063-1.514v-.089c0-.312-.253-.566-.566-.566h-1.997c-1.347 0-2.558-.748-3.16-1.953-.118-.235-.382-.358-.637-.298-.256.06-.437.289-.437.552 0 .937-.762 1.699-1.699 1.699H6.23c-.312 0-.566.254-.566.566v.09c0 .694-.444 1.289-1.062 1.513l-.07-1.615c.006-3.43 2.798-6.218 6.23-6.218zM5.64 12.776c-.096-.193-.292-.315-.508-.315h-.602c-.624 0-1.133-.508-1.133-1.133 0-.902.86-1.076.977-1.152 1.203-.142 2.171-1.066 2.38-2.246h.608c1.081 0 2.023-.61 2.5-1.502.868.947 2.1 1.502 3.433 1.502h1.472c.209 1.18 1.177 2.103 2.38 2.246.114.074.977.254.977 1.152 0 .625-.508 1.133-1.133 1.133h-.602c-.215 0-.412.122-.507.315-.997 2.01-2.875 4.216-5.121 4.216-2.24 0-4.11-2.175-5.121-4.216zM1.133 27.867v-4.113c0-1.958 1.46-3.644 3.398-3.924v1.75c-1.29.264-2.265 1.408-2.265 2.775v1.813c0 .313.253.566.566.566h1.133c.313 0 .566-.253.566-.566 0-.313-.253-.566-.566-.566h-.567v-1.247c0-.936.763-1.699 1.7-1.699.937 0 1.699.763 1.699 1.7v1.246H6.23c-.312 0-.566.253-.566.566 0 .313.254.566.566.566h1.133c.313 0 .567-.253.567-.566v-1.813c0-1.367-.975-2.511-2.266-2.775v-1.912l1.15-.164c.072-.01.144-.025.215-.041l3.166 3.958v4.446H1.133zm15.293-2.265c-.313 0-.567-.255-.567-.567 0-.312.254-.566.567-.566.312 0 .566.254.566.566 0 .312-.254.567-.566.567z"/>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	address: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28" viewBox="0 0 28 28">
		<defs>
			<path id="ftpf3k1h2a" d="M14 2.333c-4.515 0-8.167 3.652-8.167 8.167C5.833 16.625 14 25.667 14 25.667s8.167-9.042 8.167-15.167c0-4.515-3.652-8.167-8.167-8.167zm0 11.084c-1.61 0-2.917-1.307-2.917-2.917 0-1.61 1.307-2.917 2.917-2.917 1.61 0 2.917 1.307 2.917 2.917 0 1.61-1.307 2.917-2.917 2.917z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g transform="translate(-70 -220) translate(40 200) translate(30 20)">
							<mask id="5hc632gshb" fill="#fff">
								<use xlink:href="#ftpf3k1h2a"/>
							</mask>
							<g fill="#000" mask="url(#5hc632gshb)">
								<path d="M0 0H58.333V58.333H0z" transform="translate(-15.167 -15.167)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	paymentCard: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 28 28">
		<defs>
			<path id="6yv8jn7poa" d="M23.333 4.667H4.667C3.372 4.667 2.345 5.705 2.345 7l-.012 14c0 1.295 1.039 2.333 2.334 2.333h18.666c1.295 0 2.334-1.038 2.334-2.333V7c0-1.295-1.039-2.333-2.334-2.333zm0 16.333H4.667v-7h18.666v7zm0-11.667H4.667V7h18.666v2.333z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g transform="translate(-70 -867) translate(40 200) translate(30 667)">
							<mask id="7t1optinnb" fill="#fff">
								<use xlink:href="#6yv8jn7poa"/>
							</mask>
							<g __fill__ mask="url(#7t1optinnb)">
								<path d="M0 0H58.333V58.333H0z" transform="translate(-15.167 -15.167)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`,
	defaultStyles: {
		fill: '#000',
		width: 28,
		height: 28
	}
	},
	flagError: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__  viewBox="0 0 14 14">
		<defs>
			<path id="399jn8idta" d="M7.583 5.833H6.417v4.084h1.166V5.833zm0-1.75V5.25H6.417V4.083h1.166zM7 1.167C3.786 1.167 1.167 3.786 1.167 7S3.786 12.833 7 12.833 12.833 10.214 12.833 7 10.214 1.167 7 1.167zm0 10.5c-2.572 0-4.667-2.095-4.667-4.667 0-2.572 2.095-4.667 4.667-4.667 2.572 0 4.667 2.095 4.667 4.667 0 2.572-2.095 4.667-4.667 4.667z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g transform="translate(-77 -565) translate(40 200) translate(28 361) translate(9 4)">
							<mask id="isvy488r4b" fill="#fff" >
								<use xlink:href="#399jn8idta"/>
							</mask>
							<g __fill__ mask="url(#isvy488r4b)">
								<path d="M0 0H29.167V29.167H0z" transform="translate(-7.583 -7.583)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`,
	defaultStyles: {
		width: 14,
		height: 14,
		fill: '#E51A1A'
	}
	},
	shippingOption: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28" viewBox="0 0 28 28">
		<defs>
			<path id="7ncqn8t86a" d="M23.333 9.333h-3.5V4.667H3.5c-1.283 0-2.333 1.05-2.333 2.333v12.833H3.5c0 1.937 1.563 3.5 3.5 3.5s3.5-1.563 3.5-3.5h7c0 1.937 1.563 3.5 3.5 3.5s3.5-1.563 3.5-3.5h2.333V14l-3.5-4.667zM7 21.583c-.968 0-1.75-.781-1.75-1.75 0-.968.782-1.75 1.75-1.75s1.75.782 1.75 1.75c0 .969-.782 1.75-1.75 1.75zm15.75-10.5L25.037 14h-5.204v-2.917h2.917zM21 21.583c-.968 0-1.75-.781-1.75-1.75 0-.968.782-1.75 1.75-1.75s1.75.782 1.75 1.75c0 .969-.782 1.75-1.75 1.75z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g transform="translate(-70 -461) translate(40 200) translate(30 261)">
							<mask id="mhv5apeoab" fill="#fff">
								<use xlink:href="#7ncqn8t86a"/>
							</mask>
							<g fill="#000" mask="url(#mhv5apeoab)">
								<path d="M0 0H58.333V58.333H0z" transform="translate(-15.167 -15.167)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	visaCard: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="12" viewBox="0 0 36 12">
		<g fill="none" fill-rule="evenodd">
			<g fill="#9FA3A7">
				<g>
					<g>
						<path d="M323.295 799.627s-.268-1.312-.355-1.712l-3.732-.005c-.114.308-.614 1.717-.614 1.717h-3.06l4.328-10.47c.306-.744.828-.947 1.526-.947h2.252l2.36 11.417h-2.705zm-1.504-7.353l-.197-.985c-.148.429-.404 1.121-.387 1.09l-1.16 3.194h2.418l-.674-3.299zm-6.28-1.45c-.539-.231-1.23-.454-2.183-.437-1.14 0-1.669.507-1.669.982-.006.535.618.888 1.637 1.416 1.68.816 2.457 1.805 2.447 3.104-.023 2.372-2.012 3.903-5.075 3.903-1.308-.015-2.566-.29-3.247-.61l.409-2.557.375.182c.957.426 1.577.6 2.744.6.838 0 1.736-.35 1.744-1.116.005-.5-.376-.857-1.51-1.417-1.106-.547-2.571-1.462-2.555-3.104.017-2.22 2.046-3.77 4.926-3.77 1.13 0 2.035.248 2.612.48l-.395 2.476-.26-.132zm-12.83 8.799l1.823-11.424h2.915l-1.824 11.424h-2.913zm-7.028-.01l-2.592-9.922c-.895-.53-1.918-.958-3.061-1.253l.037-.238h4.7c.633.025 1.145.24 1.32.964l1.023 5.25.304 1.583 2.854-7.79h3.087l-4.589 11.402-3.083.004z" transform="translate(-330 -988) translate(40 200)"/>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	masterCard: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" width="31" height="19" viewBox="0 0 31 19">
		<g fill="none" fill-rule="evenodd">
			<g fill="#9FA3A7">
				<g>
					<g>
						<path d="M614.064 794.776c.17 0 .188.016.216.022.019.163-.103.93-.7.93-.306 0-.384-.228-.384-.366 0-.266.147-.586.868-.586zm-16.009 0c.169 0 .184.016.213.022.018.163-.103.93-.697.93-.307 0-.388-.228-.388-.366 0-.266.147-.586.872-.586zm8.466 6.134h-.004c-.005.007-.015.013-.021.02 1.647 1.469 3.828 2.365 6.225 2.365 5.125-.003 9.275-4.098 9.275-9.15v-.003c0-5.05-4.153-9.145-9.278-9.145-2.394 0-4.578.897-6.222 2.366-1.647-1.47-3.828-2.362-6.219-2.362h-.06c-5.094.03-9.218 4.115-9.218 9.144 0 5.05 4.156 9.147 9.278 9.147 2.39 0 4.572-.893 6.219-2.363l.025-.019zm-11.735-4.433l.563-3.497-1.268 3.497h-.682l-.087-3.497-.604 3.497h-.953l.791-4.64h1.44l.053 2.847.973-2.846h1.562l-.778 4.64h-1.01zm3.369-.006l.034-.373c-.015 0-.318.447-1.015.447-.362 0-.954-.194-.954-1.05 0-1.083.897-1.443 1.754-1.443.135 0 .422.025.422.025s.034-.068.034-.246c0-.297-.269-.336-.637-.336-.647 0-1.076.172-1.076.172l.144-.84s.52-.214 1.194-.214c.35 0 1.36.037 1.36 1.174l-.391 2.68h-.87v.004zm3.675-1.183c0 1.294-1.269 1.238-1.493 1.238-.828 0-1.085-.114-1.107-.12l.131-.85c0-.01.416.148.879.148.265 0 .608-.025.608-.34 0-.47-1.233-.357-1.233-1.472 0-.983.74-1.272 1.471-1.272.562 0 .91.077.91.077l-.122.859s-.538-.043-.675-.043c-.353 0-.544.074-.544.318 0 .486 1.175.246 1.175 1.457zm1.528.338c.088 0 .188-.03.257-.03l-.126.829c-.1.027-.38.126-.74.129-.46.003-.788-.253-.788-.826 0-.388.563-3.57.585-3.59h.988l-.1.567h.49l-.125.918h-.522l-.278 1.69c-.022.132.016.313.36.313zm2.172-3.028c1.085 0 1.41.783 1.41 1.424 0 .258-.132.89-.132.89h-2.006s-.185.779.876.779c.496 0 1.049-.24 1.049-.24l-.175.94s-.318.16-1.043.16c-.785 0-1.707-.33-1.707-1.704 0-1.193.734-2.249 1.728-2.249zm2.397 3.885h-1.016l.62-3.774h.917l-.087.545s.325-.594.77-.594c.127 0 .19.011.19.011-.131.266-.247.506-.369 1.132-.684-.24-.738 1.069-1.025 2.68zm3.862-.058s-.53.132-.865.132c-1.178 0-1.775-.801-1.775-2.015 0-1.833 1.11-2.81 2.247-2.81.515 0 1.112.24 1.112.24l-.16 1.033s-.405-.28-.905-.28c-.672 0-1.275.633-1.275 1.783 0 .564.28 1.094.981 1.094.334 0 .816-.24.816-.24l-.176 1.063zm2.379.046l.031-.373c-.016 0-.315.447-1.013.447-.365 0-.953-.194-.953-1.05 0-1.083.897-1.443 1.75-1.443.135 0 .425.025.425.025s.035-.068.035-.246c0-.297-.269-.336-.638-.336-.65 0-1.075.172-1.075.172l.14-.84s.523-.214 1.197-.214c.35 0 1.36.037 1.357 1.174l-.387 2.68c0 .004-.87.004-.87.004zm2.05.012h-1.013l.616-3.774h.922l-.09.545s.327-.594.771-.594c.128 0 .19.011.19.011-.13.266-.246.506-.368 1.132-.684-.24-.738 1.069-1.028 2.68zm3.54-3.337l.213-1.303.99-.002-.756 4.63h-.96l.044-.346s-.328.408-.921.408c-.819 0-1.222-.783-1.222-1.58 0-1.237.753-2.316 1.66-2.316.58.004.953.51.953.51zm-13.769.993h-1.097c0-.066.104-.67.641-.67.56 0 .456.62.456.67zm12.985-.561c.356 0 .538.24.538.807 0 .511-.257 1.202-.791 1.202-.356 0-.525-.296-.525-.758 0-.756.343-1.251.778-1.251z" transform="translate(-631 -985) translate(40 200)"/>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	rxRefill: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
		<defs>
			<path id="fdr83s55na" d="M8 10.56L10.667 8h-2V2.24H7.333V8h-2L8 10.56zm6-8.32h-4v1.274h4v8.979H2v-8.98h4V2.24H2c-.733 0-1.333.576-1.333 1.28v8.96c0 .704.6 1.28 1.333 1.28h12c.733 0 1.333-.576 1.333-1.28V3.52c0-.704-.6-1.28-1.333-1.28z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-1233 -534) translate(40 327) translate(25 202) translate(1166) translate(3 5)">
									<mask id="yjbrftvhkb" fill="#fff">
										<use xlink:href="#fdr83s55na"/>
									</mask>
									<g __fill__ mask="url(#yjbrftvhkb)">
										<path d="M0 0H33.333V32H0z" transform="translate(-8.667 -8.32)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`,
		defaultStyles: {
			width: 17,
			height: 16,
			fill: '#003E7B'
		}
	},
	location: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 19 18">
				<defs>
					<path id="nd836ok0ra" d="M6 .5C3.098.5.75 2.848.75 5.75.75 9.688 6 15.5 6 15.5s5.25-5.813 5.25-9.75C11.25 2.848 8.902.5 6 .5zm0 7.125c-1.035 0-1.875-.84-1.875-1.875 0-1.035.84-1.875 1.875-1.875 1.035 0 1.875.84 1.875 1.875 0 1.035-.84 1.875-1.875 1.875z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-543 -609) translate(40 454) translate(480 120) translate(23 35)">
										<mask id="1ok8zgm6xb" fill="#fff">
											<use xlink:href="#nd836ok0ra"/>
										</mask>
										<g fill="#000" mask="url(#1ok8zgm6xb)">
											<path d="M0 0H37.5V37.5H0z" transform="translate(-12.75 -10.75)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 19,
			height: 18,
		}
	},
	distance: {
		markup: `
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 19 18">
				<defs>
					<path id="fqigiinpla" d="M4.125 11.25c.207 0 .375.168.375.375v3.389h9.44c.203 0 .368.165.368.368 0 .203-.165.368-.368.368H3.75v-4.125c0-.207.168-.375.375-.375zM14.25 7.5c1.244 0 2.25 1.056 2.25 2.363 0 1.771-2.25 4.387-2.25 4.387S12 11.634 12 9.863C12 8.556 13.006 7.5 14.25 7.5zm0 1.558c-.414 0-.75.349-.75.779 0 .43.336.778.75.778s.75-.349.75-.778c0-.43-.336-.78-.75-.78zM4.125.75C5.991.75 7.5 2.276 7.5 4.162c0 2.56-3.375 6.338-3.375 6.338S.75 6.722.75 4.162C.75 2.276 2.26.75 4.125.75zm0 2.25C3.504 3 3 3.504 3 4.125S3.504 5.25 4.125 5.25 5.25 4.746 5.25 4.125 4.746 3 4.125 3z"/>
				</defs>
				<g fill="none" fill-rule="evenodd">
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-672 -633) translate(40 454) translate(480 120) translate(152 59)">
										<mask id="xf5evilxhb" fill="#fff">
											<use xlink:href="#fqigiinpla"/>
										</mask>
										<g fill="#000" mask="url(#xf5evilxhb)">
											<path d="M0 0H37.5V37.5H0z" transform="translate(-10.5 -9.75)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		`,
		defaultStyles: {
			width: 19,
			height: 18,
		}
	},
	basicInfo: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21" height="17" viewBox="0 0 21 17">
		<defs>
			<path id="pts6sd4kua" d="M16.286 1.417H3.714c-.864 0-1.571.797-1.571 1.77v10.626c0 .973.707 1.77 1.571 1.77h12.572c.864 0 1.571-.797 1.571-1.77V3.187c0-.973-.707-1.77-1.571-1.77zM12.857 6.02c0 1.366-1.122 2.479-2.5 2.479s-2.5-1.113-2.5-2.48c0-1.365 1.122-2.478 2.5-2.478s2.5 1.113 2.5 2.479zM5.39 13.199v-1.328c0-1.478 3.33-2.213 5-2.213s5 .735 5 2.213V13.2h-10z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g transform="translate(-70 -258) translate(70 258)">
					<mask id="fg70dcegcb" fill="#fff">
						<use xlink:href="#pts6sd4kua"/>
					</mask>
					<g fill="#000" mask="url(#fg70dcegcb)">
						<path d="M0 0H35.714V35.417H0z" transform="translate(-7.857 -9.208)"/>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	document: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="24" viewBox="0 0 25 24">
		<defs>
			<path id="pp12ynbola" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g transform="translate(-70 -763) translate(70 763)">
					<mask id="3caveffmwb" fill="#fff">
						<use xlink:href="#pp12ynbola"/>
					</mask>
					<g fill="#000" mask="url(#3caveffmwb)">
						<path d="M0 0H50V50H0z" transform="translate(-13 -13)"/>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	hospital: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
		<defs>
			<path id="kgqw1nw3va" d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g transform="translate(-70 -259) translate(70 259)">
					<mask id="fzg7shyzcb" fill="#fff">
						<use xlink:href="#kgqw1nw3va"/>
					</mask>
					<g fill="#000" mask="url(#fzg7shyzcb)">
						<path d="M0 0H50V50H0z" transform="translate(-13 -13)"/>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	medicalPlus: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
		<defs>
			<path id="ddjljpx7fa" d="M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-7.012 3.61v3.014h3.015v1.97h-3.015v3.015h-1.97v-3.014H8.002v-1.971h3.014v-3.015h1.971zM14 5v2h-4V5h4z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g transform="translate(-70 -610) translate(70 610)">
					<mask id="hfqtzxo38b" fill="#fff">
						<use xlink:href="#ddjljpx7fa"/>
					</mask>
					<g fill="#000" mask="url(#hfqtzxo38b)">
						<path d="M0 0H50V50H0z" transform="translate(-13 -13)"/>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	lock: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
		<defs>
			<path id="zcrurogp1a" d="M8 11.333c.733 0 1.333-.6 1.333-1.333S8.733 8.667 8 8.667s-1.333.6-1.333 1.333.6 1.333 1.333 1.333zm4-6h-.667V4C11.333 2.16 9.84.667 8 .667S4.667 2.16 4.667 4v1.333H4c-.733 0-1.333.6-1.333 1.334v6.666c0 .734.6 1.334 1.333 1.334h8c.733 0 1.333-.6 1.333-1.334V6.667c0-.734-.6-1.334-1.333-1.334zM5.933 4c0-1.14.927-2.067 2.067-2.067 1.14 0 2.067.927 2.067 2.067v1.333H5.933V4zM12 13.333H4V6.667h8v6.666z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g transform="translate(-337 -1784) translate(40 1701) translate(277 67) translate(20 16)">
								<mask id="204o7hhlqb" fill="#fff">
									<use xlink:href="#zcrurogp1a"/>
								</mask>
								<g fill="#4A4A4A" mask="url(#204o7hhlqb)">
									<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -8.667)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	mailOutLine: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
		<defs>
			<path id="djzxpx68ua" d="M13.333 2.667H2.667c-.734 0-1.327.6-1.327 1.333l-.007 8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V4c0-.733-.6-1.333-1.334-1.333zm0 9.333H2.667V5.333L8 8.667l5.333-3.334V12zM8 7.333L2.667 4h10.666L8 7.333z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g transform="translate(-594 -1784) translate(40 1701) translate(534 67) translate(20 16)">
								<mask id="4uttklflab" fill="#fff">
									<use xlink:href="#djzxpx68ua"/>
								</mask>
								<g fill="#4A4A4A" mask="url(#4uttklflab)">
									<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -8.667)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	amexCard: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46px" height="19px" viewBox="0 0 46 19" version="1.1">
			<g id="Amex" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="American_Express_logo" transform="translate(2.000000, -12.000000)" fill="#90959B" fill-rule="nonzero">
					<path d="M40.4232872,29.2265043 C41.186034,29.2199362 41.8455532,28.7739617 41.8455532,28.7739617 L41.8455532,41.8975468 L0.0504148936,41.8975468 L0.0504148936,20.6282702 L1.98610851,20.6282702 L2.39933191,19.5938936 L3.50908511,19.5938936 L3.92525745,20.6282702 L19.6711617,20.6282702 L19.6711617,19.5938936 L20.5115936,20.6282702 L24.7460574,20.6282702 L24.7460574,19.8999872 C24.7460574,19.8999872 25.4645553,20.6282702 26.5885319,20.6282702 L29.3969915,20.6282702 L29.8066702,19.5938936 L30.9199681,19.5938936 L31.3364234,20.6282702 L35.4776681,20.6282702 L35.4776681,19.4646021 L36.2211277,20.6282702 L39.0656447,20.6282702 L39.0656447,14.0664702 L36.2211277,14.0664702 L36.2211277,15.2263851 L35.4453489,14.0664702 L32.6266723,14.0664702 L32.6266723,16.1028894 L31.7528787,14.0836128 L26.8471149,14.0664702 C25.5408702,14.0664702 24.7460426,14.8099298 24.7460426,14.8099298 L24.7460426,14.0664702 L9.62644468,14.0664702 L9.1133,15.5453021 L8.58399574,14.0664702 L5.21580426,14.0664702 L5.21580426,16.1125255 L4.32665532,14.0664702 L1.61714894,14.0664702 L0.0504148936,17.7191 L0.0504148936,0.102438298 L41.8455532,0.102438298 L41.8455532,22.6646894 L16.6269957,22.6646894 L15.8569213,23.6364383 L15.1115106,22.6646894 L8.16377234,22.6646894 L8.16377234,29.2265043 L15.067917,29.2265043 L15.8236936,28.2339191 L16.5680468,29.2265043 L20.7378723,29.2265043 L20.7378723,27.707266 L21.6752766,27.707266 C22.4886021,27.707266 22.8648,27.4607915 22.8648,27.4607915 L22.8648,29.2265043 L25.6188234,29.2265043 L25.6188234,28.1921277 L26.4592553,29.2265043 L40.4232872,29.2265043 Z M1.43428511,19.7886723 L0.7805,19.7886723 L0.058487234,19.7886723 L0.660144681,18.3898043 L2.17168298,14.8753872 L2.17168298,14.8753872 L3.77374468,14.8753872 L5.88491489,19.7886723 L4.47880851,19.7886723 L4.09091915,18.8048 L1.8242,18.8048 L1.43428511,19.7886723 Z M2.26058298,17.7381191 L3.64445319,17.7381191 L2.9535234,16.0188745 L2.26058298,17.7381191 Z M12.1719723,19.7878383 L12.1719723,14.8745681 L10.2325255,14.8745681 L9.12260851,18.0496043 L7.98546596,14.8818362 L6.03038085,14.8745681 L6.03038085,19.7878383 L7.25870213,19.7878383 L7.25870213,16.1675426 L8.56438085,19.7878383 L9.64160638,19.7878383 L10.9436511,16.1675426 L10.9436511,19.7878383 L12.1719723,19.7878383 Z M17.0206043,15.9735979 L17.0206043,14.8745681 L13.0124043,14.8745681 L13.0124043,19.7878532 L17.0206043,19.7878532 L17.0206043,18.7211574 L14.2536532,18.7211574 L14.2536532,17.8484064 L16.9559511,17.8484064 L16.9559511,16.8140298 L14.2536532,16.8140298 L14.2536532,15.9735979 L17.0206043,15.9735979 L17.0206043,15.9735979 Z M20.8348447,17.978517 L22.4510553,19.7886723 L20.9500021,19.7886723 L19.4772319,18.0431702 L18.9600511,18.0431702 L18.9600511,19.7886723 L17.7317298,19.7886723 L17.7317298,14.8753872 L17.7317298,14.8753872 L20.4651404,14.8753872 C21.3708511,14.8753872 22.1823596,15.4354468 22.1823596,16.4693766 C22.1823596,17.3532383 21.4981468,17.9225468 20.8348447,17.978517 Z M20.9459511,16.4916128 C20.9459511,16.2378851 20.7009362,15.9744319 20.364117,15.9744319 L18.9600362,15.9744319 L18.9600362,17.0088085 L20.3823021,17.0088085 C20.6284936,17.0087936 20.9459511,16.8180362 20.9459511,16.4916128 Z M22.683783,14.874583 L22.683783,19.7878532 L23.9379596,19.7878532 L23.9379596,14.874583 L22.683783,14.874583 L22.683783,14.874583 Z M24.5359681,17.3514064 C24.5359681,18.7559043 25.3312426,19.7878383 26.6410766,19.7878383 L26.9117979,19.7878383 L27.4289787,18.7146787 L27.1057426,18.7146787 C26.3234702,18.7146787 25.7804489,18.3150383 25.7804489,17.3635298 C25.7804489,16.5622681 26.2553319,16.0382362 26.9268106,16.0382362 L28.3340638,16.0382362 L28.3340638,14.8745681 L26.9764511,14.8745681 C25.3223213,14.8745681 24.5359681,15.9122362 24.5359681,17.3514064 Z M27.4713957,19.7886723 L29.5845766,14.8753872 L29.5845766,14.8753872 L31.1866383,14.8753872 L33.2978085,19.7886723 L31.8917021,19.7886723 L31.5038128,18.8048 L29.2370787,18.8048 L28.8471638,19.7886723 L27.4713957,19.7886723 L27.4713957,19.7886723 Z M29.6734766,17.7381191 L31.0573468,17.7381191 L30.366417,16.0188745 L29.6734766,17.7381191 Z M36.7140766,19.7878383 L38.2252426,19.7878383 L38.2252426,14.8745681 L36.9969213,14.8745681 L36.9969213,17.9615234 L35.002934,14.8745681 L33.4412787,14.8745681 L33.4412787,19.7878383 L34.6696,19.7878383 L34.6696,16.6200702 L36.7140766,19.7878383 Z M13.0124043,24.5718319 L13.0124043,23.4728021 L9.00420426,23.4728021 L9.00420426,28.3860872 L13.0124043,28.3860872 L13.0124043,27.3193915 L10.2454532,27.3193915 L10.2454532,26.4466404 L12.9477511,26.4466404 L12.9477511,25.4122638 L10.2454532,25.4122638 L10.2454532,24.5718468 L13.0124043,24.5718468 L13.0124043,24.5718319 Z M32.6525574,24.5718319 L32.6525574,23.4728021 L28.6443574,23.4728021 L28.6443574,28.3860872 L32.6525574,28.3860872 L32.6525574,27.3193915 L29.8856064,27.3193915 L29.8856064,26.4466404 L32.5749766,26.4466404 L32.5749766,25.4122638 L29.8856064,25.4122638 L29.8856064,24.5718468 L32.6525574,24.5718468 L32.6525574,24.5718319 Z M17.0529234,23.4727872 L15.8589468,25.0102106 L14.6690064,23.4727872 L13.1214851,23.4727872 L15.1195234,25.9597383 L13.1679532,28.3860723 L14.6932532,28.3860723 L15.8205511,26.8728809 L16.9759383,28.3860723 L18.5232213,28.3860723 L16.5680617,25.9294298 L18.5398277,23.4727872 L17.0529234,23.4727872 L17.0529234,23.4727872 Z M21.382334,23.4736213 C22.4956319,23.4736213 23.1460213,24.1911511 23.1460213,25.1262021 C23.1460213,26.2549298 22.3167596,26.835334 21.222734,26.835334 L19.9297745,26.835334 L19.9297745,28.3868915 L18.669134,28.3868915 L18.669134,23.4736213 L21.382334,23.4736213 L21.382334,23.4736213 Z M21.2914234,24.5847745 L19.9297745,24.5847745 L19.9297745,25.7161234 L21.2873872,25.7161234 C21.6461447,25.7161234 21.8975043,25.4783617 21.8975043,25.1504489 C21.8975043,24.8013872 21.6448638,24.5847745 21.2914234,24.5847745 Z M26.7824915,26.575917 L28.3987021,28.3860723 L26.8976489,28.3860723 L25.4248787,26.6405702 L24.9076979,26.6405702 L24.9076979,28.3860723 L23.6793766,28.3860723 L23.6793766,23.4728021 L26.4127872,23.4728021 C27.3184979,23.4728021 28.1300064,24.0328617 28.1300064,25.0667915 C28.1300064,25.9506383 27.4457936,26.5199319 26.7824915,26.575917 Z M26.8935979,25.0889979 C26.8935979,24.8352851 26.648583,24.571817 26.3117638,24.571817 L24.907683,24.571817 L24.907683,25.6061787 L26.3299489,25.6061787 C26.5761404,25.6061936 26.8935979,25.4154362 26.8935979,25.0889979 Z M35.6797149,27.3193766 L33.2214638,27.3193766 L33.2214638,28.3860723 L35.8393149,28.3860723 C36.9209043,28.3860723 37.4413915,27.6820064 37.4413915,26.8223915 C37.4413915,26.0228277 36.9743128,25.4122489 35.8979213,25.4122489 L34.7342532,25.4122489 C34.4321511,25.4122489 34.2817106,25.1876383 34.2817106,24.9839532 C34.2817106,24.7857936 34.4034362,24.5782809 34.7988915,24.5782809 L36.8676298,24.5782809 L37.3848255,23.4728021 L34.9928362,23.4728021 C33.5579553,23.4728021 33.0654979,24.2325255 33.0654979,25.0203234 C33.0654979,25.9035745 33.6032617,26.4918723 34.5688596,26.4918723 L35.6797149,26.4918723 C36.0439532,26.4918723 36.2009319,26.7006957 36.2009319,26.9072404 C36.2009319,27.1228106 36.0434468,27.3193766 35.6797149,27.3193766 Z M41.8455532,26.2304447 C41.6551532,25.7407277 41.1947766,25.4122489 40.4061149,25.4122489 L40.0871085,25.4122489 L39.2424468,25.4122489 C38.9403447,25.4122489 38.7899043,25.1876383 38.7899043,24.9839532 C38.7899043,24.7857936 38.9116298,24.5782809 39.3070851,24.5782809 L40.6208362,24.5782809 L41.3758234,24.5782809 L41.8455383,23.5742574 L41.8930043,23.4727872 L41.8455383,23.4727872 L41.3283574,23.4727872 L39.5010298,23.4727872 C38.0661638,23.4727872 37.5737064,24.2325106 37.5737064,25.0203085 C37.5737064,25.9035596 38.1114702,26.4918574 39.0770681,26.4918574 L40.1879234,26.4918574 C40.1942085,26.4918574 40.1992723,26.4930191 40.2054383,26.4931532 C40.5563915,26.5001681 40.7091553,26.7042553 40.7091553,26.9072255 C40.7091553,26.9805021 40.689317,27.0508745 40.6510106,27.1127872 C40.576617,27.2330085 40.4280234,27.3193617 40.1879234,27.3193617 L37.7296723,27.3193617 L37.7296723,28.3860574 L40.3475085,28.3860574 C40.7693553,28.3860574 41.1046851,28.2779298 41.358234,28.0962723 C41.587983,27.9316681 41.750234,27.7065213 41.8455532,27.4436787 C41.9147638,27.2528766 41.9495851,27.0429064 41.9495851,26.8223766 C41.9495851,26.6086532 41.915017,26.4091234 41.8455532,26.2304447 Z" id="blue"/>
				</g>
			</g>
		</svg>`
	},
	discoverCard: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52px" height="22px" viewBox="0 0 52 22" version="1.1">
		<defs>
			<linearGradient x1="85.9469773%" y1="100%" x2="17.2424154%" y2="0%" id="linearGradient-1">
				<stop stop-color="#E4E4E4" offset="0%"/>
				<stop stop-color="#9D9D9D" offset="100%"/>
			</linearGradient>
		</defs>
		<g id="Discover" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g id="Discover-02" style="mix-blend-mode: normal;" transform="translate(4.000000, 7.000000)" fill-rule="nonzero">
				<path d="M2.125,0.2375 L0.0625,0.2375 L0.0625,7.4625 L2.125,7.4625 C3.2125,7.4625 4.0125,7.2 4.7,6.625 C5.525,5.9375 6.0125,4.9125 6.0125,3.85 C6,1.725 4.4125,0.2375 2.125,0.2375 Z M3.775,5.6625 C3.3375,6.0625 2.7625,6.2375 1.85,6.2375 L1.475,6.2375 L1.475,1.4625 L1.85,1.4625 C2.7625,1.4625 3.3125,1.625 3.775,2.05 C4.2625,2.4875 4.55,3.15 4.55,3.85 C4.55,4.5375 4.2625,5.225 3.775,5.6625 Z" id="Shape" fill="#90959B"/>
				<rect id="XMLID_422_" fill="#90959B" x="6.65" y="0.2375" width="1.4125" height="7.225"/>
				<path d="M11.5,3.0125 C10.65,2.7 10.4125,2.4875 10.4125,2.1 C10.4125,1.65 10.85,1.3 11.4625,1.3 C11.8875,1.3 12.225,1.475 12.6,1.8875 L13.3375,0.925 C12.7375,0.4 12.0125,0.125 11.2125,0.125 C9.9375,0.125 8.9625,1.0125 8.9625,2.1875 C8.9625,3.1875 9.4125,3.6875 10.7375,4.1625 C11.2875,4.3625 11.575,4.4875 11.7125,4.575 C12,4.7625 12.1375,5.025 12.1375,5.325 C12.1375,5.9125 11.675,6.3375 11.05,6.3375 C10.375,6.3375 9.8375,6 9.5125,5.375 L8.6,6.25 C9.25,7.2 10.025,7.625 11.1,7.625 C12.5625,7.625 13.5875,6.65 13.5875,5.25 C13.5875,4.1125 13.1125,3.6 11.5,3.0125 Z" id="XMLID_421_" fill="#90959B"/>
				<path d="M14.025,3.85 C14.025,5.975 15.6875,7.6125 17.8375,7.6125 C18.4375,7.6125 18.9625,7.4875 19.6,7.1875 L19.6,5.525 C19.0375,6.0875 18.5375,6.3125 17.9,6.3125 C16.4875,6.3125 15.475,5.2875 15.475,3.825 C15.475,2.4375 16.5125,1.35 17.8375,1.35 C18.5125,1.35 19.0125,1.5875 19.6,2.1625 L19.6,0.5 C18.9875,0.1875 18.475,0.0625 17.8625,0.0625 C15.7375,0.075 14.025,1.75 14.025,3.85 Z" id="XMLID_420_" fill="#90959B"/>
				<polygon id="XMLID_419_" fill="#90959B" points="30.7625 5.0875 28.8375 0.2375 27.3 0.2375 30.375 7.65 31.125 7.65 34.25 0.2375 32.725 0.2375"/>
				<polygon id="XMLID_418_" fill="#90959B" points="34.8875 7.4625 38.875 7.4625 38.875 6.2375 36.2875 6.2375 36.2875 4.2875 38.775 4.2875 38.775 3.0625 36.2875 3.0625 36.2875 1.4625 38.875 1.4625 38.875 0.2375 34.8875 0.2375"/>
				<path d="M44.45,2.375 C44.45,1.025 43.525,0.2375 41.9,0.2375 L39.8125,0.2375 L39.8125,7.4625 L41.225,7.4625 L41.225,4.5625 L41.4125,4.5625 L43.3625,7.4625 L45.1,7.4625 L42.825,4.425 C43.8625,4.2 44.45,3.475 44.45,2.375 Z M41.625,3.5625 L41.2125,3.5625 L41.2125,1.375 L41.65,1.375 C42.525,1.375 43,1.7375 43,2.45 C43,3.175 42.525,3.5625 41.625,3.5625 Z" id="Shape" fill="#90959B"/>
				<circle id="XMLID_414_" fill="url(#linearGradient-1)" cx="23.9" cy="3.875" r="3.8375"/>
				<g id="XMLID_430_" transform="translate(44.500000, 0.000000)" fill="#7A7A7A">
					<path d="M0.85,0.5125 C0.85,0.3875 0.7625,0.3125 0.6125,0.3125 L0.4125,0.3125 L0.4125,0.95 L0.5625,0.95 L0.5625,0.7 L0.7375,0.95 L0.925,0.95 L0.7125,0.6875 C0.8,0.6625 0.85,0.6 0.85,0.5125 Z M0.5875,0.6 L0.5625,0.6 L0.5625,0.4375 L0.5875,0.4375 C0.6625,0.4375 0.7,0.4625 0.7,0.525 C0.7,0.575 0.6625,0.6 0.5875,0.6 Z" id="Shape"/>
					<path d="M0.6375,0.075 C0.325,0.075 0.0875,0.325 0.0875,0.625 C0.0875,0.9375 0.3375,1.175 0.6375,1.175 C0.9375,1.175 1.1875,0.925 1.1875,0.625 C1.1875,0.325 0.9375,0.075 0.6375,0.075 Z M0.6375,1.0875 C0.4,1.0875 0.2,0.8875 0.2,0.6375 C0.2,0.3875 0.4,0.1875 0.6375,0.1875 C0.875,0.1875 1.075,0.4 1.075,0.6375 C1.075,0.8875 0.875,1.0875 0.6375,1.0875 Z" id="Shape"/>
				</g>
			</g>
		</g>
	</svg>`
	},
	disable: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="16" viewBox="0 0 17 16">
		<defs>
			<path id="13ivaywufa" d="M7.333 6.333H4.667v1.334h6.666V6.333h-4zm.667-6C4.327.333 1.333 3.327 1.333 7c0 3.673 2.994 6.667 6.667 6.667 3.673 0 6.667-2.994 6.667-6.667C14.667 3.327 11.673.333 8 .333zm0 12C5.06 12.333 2.667 9.94 2.667 7 2.667 4.06 5.06 1.667 8 1.667c2.94 0 5.333 2.393 5.333 5.333 0 2.94-2.393 5.333-5.333 5.333z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-1305 -529) translate(40 327) translate(25 202) translate(1166) translate(75)">
									<mask id="3bn1lrf8wb" fill="#fff">
										<use xlink:href="#13ivaywufa"/>
									</mask>
									<use stroke="#FFF" stroke-width="2" xlink:href="#13ivaywufa"/>
									<g fill="#003E7B" mask="url(#3bn1lrf8wb)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -9.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	enable: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="16" viewBox="0 0 17 16">
			<defs>
				<path id="5nv91rcmfa" d="M10.286 4.845L7.318 7.813 5.978 6.47l-.971.97L7.29 9.727l3.937-3.938-.942-.943zM8 .333C4.327.333 1.333 3.327 1.333 7c0 3.673 2.994 6.667 6.667 6.667 3.673 0 6.667-2.994 6.667-6.667C14.667 3.327 11.673.333 8 .333zm0 12C5.06 12.333 2.667 9.94 2.667 7 2.667 4.06 5.06 1.667 8 1.667c2.94 0 5.333 2.393 5.333 5.333 0 2.94-2.393 5.333-5.333 5.333z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g>
									<g transform="translate(-1305 -641) translate(40 327) translate(25 314) translate(1166) translate(75)">
										<mask id="iw3y07j86b" fill="#fff">
											<use xlink:href="#5nv91rcmfa"/>
										</mask>
										<use stroke="#FFF" stroke-width="2" xlink:href="#5nv91rcmfa"/>
										<g fill="#003E7B" mask="url(#iw3y07j86b)">
											<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -9.667)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	checkUser: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18">
		<defs>
			<path id="0eml846kba" d="M11.25 6c1.658 0 3-1.343 3-3s-1.342-3-3-3-3 1.343-3 3 1.342 3 3 3zm-4.11-.861l-1.061-1.06-2.329 2.36-1.321-1.3-1.06 1.06L2.688 7.5 3.75 8.56 7.14 5.14zM11.25 7.5c-2.002 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g transform="translate(-693 -266) translate(40 256) translate(632 10) translate(21)">
								<mask id="9k03oct61b" fill="#fff">
									<use xlink:href="#0eml846kba"/>
								</mask>
								<g fill="#003E7B" mask="url(#9k03oct61b)">
									<path d="M0 0H37.5V37.5H0z" transform="translate(-9.75 -12)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	reactivateUser: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18">
		<defs>
			<path id="tf0pchijga" d="M4.508 3.003c1.55 0 2.684 1.198 2.684 2.679 0 1.481-1.258 2.57-2.808 2.57V6.899c1.142.052 1.563-.681 1.563-1.27 0-.59-.342-1.333-1.439-1.333-.848 0-1.192.76-1.192 1.387h.561L2.576 6.967 1.37 5.682h.6c0-1.481.987-2.68 2.537-2.68zM11.25 0c1.658 0 3 1.343 3 3s-1.342 3-3 3-3-1.343-3-3 1.342-3 3-3zm0 7.5c-2.002 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g transform="translate(-693 -266) translate(40 256) translate(632 10) translate(21)">
								<mask id="z99gjzeihb" fill="#fff">
									<use xlink:href="#tf0pchijga"/>
								</mask>
								<g fill="#003E7B" mask="url(#z99gjzeihb)">
									<path d="M0 0H37.5V37.5H0z" transform="translate(-9.75 -12)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	whiteLabel: {
		markup:
		`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
			<defs>
				<path id="0cf15tlyva" d="M7.4 8.5L12.17.24C11.47.09 10.75 0 10 0 7.6 0 5.4.85 3.68 2.25L7.34 8.6l.06-.1zM19.54 7c-.92-2.92-3.15-5.26-6-6.34L9.88 7h9.66zm.26 1h-7.49l.29.5 4.76 8.25C19 14.97 20 12.61 20 10c0-.69-.07-1.35-.2-2zM6.54 10l-3.9-6.75C1.01 5.03 0 7.39 0 10c0 .69.07 1.35.2 2h7.49l-1.15-2zM.46 13c.92 2.92 3.15 5.26 6 6.34L10.12 13H.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-62 -344) translate(40 319) translate(22 25)">
									<mask id="waml78vdab" fill="#fff">
										<use xlink:href="#0cf15tlyva"/>
									</mask>
									<g fill="#000" mask="url(#waml78vdab)">
										<path d="M0 0H50V50H0z" transform="translate(-15 -15)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	contactInformation: {
		markup:
		`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
			<defs>
				<path id="f8pbrwkmoa" d="M18.333.5H1.667C.75.5 0 1.25 0 2.167v11.666C0 14.75.75 15.5 1.667 15.5h16.666c.917 0 1.659-.75 1.659-1.667L20 2.167C20 1.25 19.25.5 18.333.5zM6.667 3c1.383 0 2.5 1.117 2.5 2.5S8.05 8 6.667 8c-1.384 0-2.5-1.117-2.5-2.5S5.283 3 6.667 3zm5 10h-10v-.833c0-1.667 3.333-2.584 5-2.584 1.666 0 5 .917 5 2.584V13zm3.208-3.333h1.367l1.258 1.666-1.658 1.659c-1.092-.817-1.9-1.984-2.275-3.325-.15-.534-.234-1.092-.234-1.667s.084-1.133.234-1.667c.375-1.35 1.183-2.508 2.275-3.325L17.5 4.667l-1.258 1.666h-1.367c-.183.525-.292 1.084-.292 1.667s.109 1.142.292 1.667z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-62 -429) translate(40 319) translate(22 110)">
									<mask id="uqj8kkhssb" fill="#fff">
										<use xlink:href="#f8pbrwkmoa"/>
									</mask>
									<g fill="#000" mask="url(#uqj8kkhssb)">
										<path d="M0 0H41.667V41.667H0z" transform="translate(-10.833 -12.833)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	splashPageContent: {
		markup:
		`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
			<defs>
				<path id="tv2s44buna" d="M18 16V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM5.5 10.5L8 13.51 11.5 9l4.5 6H2l3.5-4.5z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-63 -510) translate(40 319) translate(23 191)">
									<mask id="4nvwta46eb" fill="#fff">
										<use xlink:href="#tv2s44buna"/>
									</mask>
									<g fill="#000" mask="url(#4nvwta46eb)">
										<path d="M0 0H50V50H0z" transform="translate(-16 -16)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	more: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="17" viewBox="0 0 17 17">
			<defs>
				<path id="v9jzdmj6ea" d="M9.264 7.066c0-.587.475-1.062 1.062-1.062.587 0 1.063.475 1.063 1.062 0 .587-.476 1.063-1.063 1.063s-1.062-.476-1.062-1.063zm-3.188 0c0-.587.476-1.062 1.063-1.062.586 0 1.062.475 1.062 1.062 0 .587-.476 1.063-1.062 1.063-.587 0-1.063-.476-1.063-1.063zm-3.187 0c0-.587.475-1.062 1.062-1.062.587 0 1.063.475 1.063 1.062 0 .587-.476 1.063-1.063 1.063S2.89 7.653 2.89 7.066zM7.083 0C3.18 0 0 3.18 0 7.083s3.18 7.084 7.083 7.084 7.084-3.18 7.084-7.084C14.167 3.18 10.987 0 7.083 0zm0 12.75c-3.123 0-5.666-2.543-5.666-5.667 0-3.123 2.543-5.666 5.666-5.666 3.124 0 5.667 2.543 5.667 5.666 0 3.124-2.543 5.667-5.667 5.667z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g>
									<g>
										<g>
											<g>
												<g transform="translate(-1315 -499) translate(40 327) translate(15 156) translate(1256 16) translate(4) translate(1.417 .417)">
													<mask id="1k5twxzbnb" fill="#fff">
														<use xlink:href="#v9jzdmj6ea"/>
													</mask>
													<g fill="#003E7B" mask="url(#1k5twxzbnb)">
														<path d="M0 0H35.417V35.417H0z" transform="translate(-10.625 -10.625)"/>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
		`
	},
	orderCancelled: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 31 22">
		<g fill="none" fill-rule="evenodd">
			<path fill="#FFDD35" d="M15.481 0L30.963 22 0 22z"></path>
			<text fill="#1D2A34" font-family="Montserrat-Bold, Montserrat" font-size="10" font-weight="bold">
				<tspan x="11.31" y="17">X</tspan>
			</text>
		</g>
	</svg>`
	},
	orderOnHold: {
		markup: `<svg role="img" width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 23"><g fill="none" fill-rule="evenodd"><path fill="#FF2E2E" d="M15.481 0L30.963 22 0 22z" transform="translate(0 .777)">
		</path><text fill="#FFF" font-family="Montserrat-Bold, Montserrat" font-size="15" font-weight="bold" transform="translate(0 .777)"><tspan x="13.065" y="18">!</tspan></text></g></svg>`
	},
	mic: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
		<defs>
			<path id="ikkye8bfua" d="M8 8.333c1.107 0 1.993-.893 1.993-2l.007-4c0-1.106-.893-2-2-2s-2 .894-2 2v4c0 1.107.893 2 2 2zm3.533-2c0 2-1.693 3.4-3.533 3.4-1.84 0-3.533-1.4-3.533-3.4H3.333c0 2.274 1.814 4.154 4 4.48V13h1.334v-2.187c2.186-.32 4-2.2 4-4.48h-1.134z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-1292 -1617) translate(40 1298) translate(34 143) translate(1204 176) translate(14)">
									<mask id="w887r0wc8b" fill="#fff">
										<use xlink:href="#ikkye8bfua"/>
									</mask>
									<g fill="#003E7B" mask="url(#w887r0wc8b)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -9.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	calendar: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="21" viewBox="0 0 20 21">
		<defs>
			<path id="usxi03htka" d="M7.5 9.167H5.833v1.666H7.5V9.167zm3.333 0H9.167v1.666h1.666V9.167zm3.334 0H12.5v1.666h1.667V9.167zm1.666-5.834H15V1.667h-1.667v1.666H6.667V1.667H5v1.666h-.833c-.925 0-1.659.75-1.659 1.667L2.5 16.667c0 .916.742 1.666 1.667 1.666h11.666c.917 0 1.667-.75 1.667-1.666V5c0-.917-.75-1.667-1.667-1.667zm0 13.334H4.167V7.5h11.666v9.167z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g transform="translate(-670 -420) translate(415 279) translate(30 106) translate(225 35.957)">
							<mask id="zdzsx6dhlb" fill="#fff">
								<use xlink:href="#usxi03htka"/>
							</mask>
							<g fill="#003E7B" mask="url(#zdzsx6dhlb)">
								<path d="M0 0H41.667V41.667H0z" transform="translate(-10.833 -10.833)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	fileDownload: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<path id="jxf1l8fqta" d="M11.2 1.6H4.8c-.88 0-1.592.72-1.592 1.6L3.2 16c0 .88.712 1.6 1.592 1.6H14.4c.88 0 1.6-.72 1.6-1.6V6.4l-4.8-4.8zm1.6 12.8H6.4v-1.6h6.4v1.6zm0-3.2H6.4V9.6h6.4v1.6zm-2.4-4V2.8l4.4 4.4h-4.4z"/>
		</defs>
		<g fill="none" fill-rule="evenodd" opacity=".505">
			<g>
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-133 -440) translate(40 322) translate(20 20) translate(0 50) translate(0 26) translate(73 22)">
									<mask id="59ge418q5b" fill="#fff">
										<use xlink:href="#jxf1l8fqta"/>
									</mask>
									<g fill="#000" mask="url(#59ge418q5b)">
										<path d="M0 0H40V40H0z" transform="translate(-10.4 -10.4)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	userId: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 18 18">
			<defs>
				<path id="m2daou1dba" d="M9 6c1.658 0 3-1.343 3-3s-1.342-3-3-3C7.343 0 6 1.343 6 3s1.343 3 3 3zm0 1.5c-2.003 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g transform="translate(-1125 -266) translate(40 256) translate(1077 10) translate(8)">
								<mask id="zpl2dbojjb" fill="#fff">
									<use xlink:href="#m2daou1dba"/>
								</mask>
								<g __fill__ mask="url(#zpl2dbojjb)">
									<path d="M0 0H37.5V37.5H0z" transform="translate(-9.75 -12.75)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#003E7B'
		}
	},
	personalId: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 18 18">
			<defs>
				<path id="m2daou1dba" d="M9 6c1.658 0 3-1.343 3-3s-1.342-3-3-3C7.343 0 6 1.343 6 3s1.343 3 3 3zm0 1.5c-2.003 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g transform="translate(-1125 -266) translate(40 256) translate(1077 10) translate(8)">
								<mask id="zpl2dbojjb" fill="#fff">
									<use xlink:href="#m2daou1dba"/>
								</mask>
								<g __fill__ mask="url(#zpl2dbojjb)">
									<path d="M0 0H37.5V37.5H0z" transform="translate(-9.75 -12.75)"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 18,
			height: 18,
			fill: '#003E7B'
		}
	},
	hollowPhone: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
		<defs>
			<path id="uddj5qucja" d="M5.568 6.972c.631.898 1.431 1.673 2.354 2.28l.742-.741c.507-.507 1.245-.702 1.916-.522l.36.11c.474.136.97.216 1.474.236l.37.008c1.049.061 1.883.933 1.883 1.997v2.327c0 1.103-.897 2-2 2C5.67 14.667 0 8.997 0 2 0 .897.897 0 2 0h2.333c1.103 0 2 .897 2 2 0 .678.107 1.337.319 1.98.223.71.041 1.486-.496 2.023l-.743.743.155.226zm-1.821-.445L5.213 5.06c.187-.187.24-.447.167-.68C5.133 3.633 5 2.833 5 2c0-.367-.3-.667-.667-.667H2c-.367 0-.667.3-.667.667 0 6.26 5.074 11.333 11.334 11.333.366 0 .666-.3.666-.666V10.34c0-.367-.3-.667-.666-.667-.827 0-1.634-.133-2.38-.38-.234-.08-.5-.02-.68.16L8.14 10.92c-1.887-.967-3.433-2.507-4.393-4.393z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-1302 -952) translate(40 748) translate(1246 204) translate(16) translate(.667 .667)">
									<mask id="ijgeueqvsb" fill="#fff">
										<use xlink:href="#uddj5qucja"/>
									</mask>
									<use fill="#2D2D2D" fill-rule="nonzero" xlink:href="#uddj5qucja"/>
									<g fill="#003E7B" mask="url(#ijgeueqvsb)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-9.333 -9.333)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	businessProcess: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 17 16">
		<defs>
			<path id="59habie53a" d="M12.667 1.667H9.88C9.6.893 8.867.333 8 .333s-1.6.56-1.88 1.334H3.333C2.6 1.667 2 2.267 2 3v9.333c0 .734.6 1.334 1.333 1.334h9.334c.733 0 1.333-.6 1.333-1.334V3c0-.733-.6-1.333-1.333-1.333zM8 1.667c.367 0 .667.3.667.666C8.667 2.7 8.367 3 8 3c-.367 0-.667-.3-.667-.667 0-.366.3-.666.667-.666zM9.333 11H4.667V9.667h4.666V11zm2-2.667H4.667V7h6.666v1.333zm0-2.666H4.667V4.333h6.666v1.334z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g transform="translate(-641 -265) translate(40 256) translate(589 9) translate(13)">
							<mask id="3fqu0wo5gb" fill="#fff">
								<use xlink:href="#59habie53a"/>
							</mask>
							<g __fill__ mask="url(#3fqu0wo5gb)">
								<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -9.667)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`,
	defaultStyles: {
		width: 17,
		height: 16,
		fill: '#003E7B'
	}
	},
	info: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 14 14">
		<defs>
			<path id="uqja3unzaa" d="M7.583 5.833H6.417v4.084h1.166V5.833zm0-1.75V5.25H6.417V4.083h1.166zM7 1.167C3.786 1.167 1.167 3.786 1.167 7S3.786 12.833 7 12.833 12.833 10.214 12.833 7 10.214 1.167 7 1.167zm0 10.5c-2.572 0-4.667-2.095-4.667-4.667 0-2.572 2.095-4.667 4.667-4.667 2.572 0 4.667 2.095 4.667 4.667 0 2.572-2.095 4.667-4.667 4.667z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g>
						<g transform="translate(-337 -454) translate(298 30) translate(30 419) translate(9 5)">
							<mask id="pc18r18cxb" fill="#fff">
								<use xlink:href="#uqja3unzaa"/>
							</mask>
							<g fill="#003E7B" mask="url(#pc18r18cxb)">
								<path d="M0 0H29.167V29.167H0z" transform="translate(-7.583 -7.583)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`,
	defaultStyles: {
		width: 14,
		height: 14
	}
	},
	infoRed: {
		markup: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14">
		<defs>
			<path id="wa3i0kd6pa" d="M7.583 5.833H6.417v4.084h1.166V5.833zm0-1.75V5.25H6.417V4.083h1.166zM7 1.167C3.786 1.167 1.167 3.786 1.167 7S3.786 12.833 7 12.833 12.833 10.214 12.833 7 10.214 1.167 7 1.167zm0 10.5c-2.572 0-4.667-2.095-4.667-4.667 0-2.572 2.095-4.667 4.667-4.667 2.572 0 4.667 2.095 4.667 4.667 0 2.572-2.095 4.667-4.667 4.667z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g>
				<g>
					<g transform="translate(-234 -460) translate(214 439) translate(20 21)">
						<mask id="o15ka8ybpb" fill="#fff">
							<use xlink:href="#wa3i0kd6pa"/>
						</mask>
						<g fill="#E51A1A" mask="url(#o15ka8ybpb)">
							<path d="M0 0H29.167V29.167H0z" transform="translate(-7.583 -7.583)"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`
	},
	coverage: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
			<defs>
				<path id="ind9pcptva" d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g transform="translate(-70 -220) translate(70 220)">
						<mask id="xxzbtz44mb" fill="#fff">
							<use xlink:href="#ind9pcptva"/>
						</mask>
						<g fill="#000" mask="url(#xxzbtz44mb)">
							<path d="M0 0H50V50H0z" transform="translate(-13 -13)"/>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	email: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
			<defs>
				<path id="ebjviuwefa" d="M13.333 2.667H2.667c-.734 0-1.327.6-1.327 1.333l-.007 8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V4c0-.733-.6-1.333-1.334-1.333zm0 2.666L8 8.667 2.667 5.333V4L8 7.333 13.333 4v1.333z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g transform="translate(-337 -1834) translate(40 1701) translate(277 92) translate(20 41)">
									<mask id="lsecbgyznb" fill="#fff">
										<use xlink:href="#ebjviuwefa"/>
									</mask>
									<g fill="#003E7B" mask="url(#lsecbgyznb)">
										<path d="M0 0H33.333V33.333H0z" transform="translate(-8.667 -8.667)"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`
	},
	activateCheck: {
		markup: `
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 14 14">
			<defs>
				<path id="ngt4av45ka" d="M9 5.115L6.404 7.71 5.23 6.537l-.849.85 1.998 1.998L9.825 5.94 9 5.115zM7 1.167C3.786 1.167 1.167 3.786 1.167 7S3.786 12.833 7 12.833 12.833 10.214 12.833 7 10.214 1.167 7 1.167zm0 10.5c-2.572 0-4.667-2.095-4.667-4.667 0-2.572 2.095-4.667 4.667-4.667 2.572 0 4.667 2.095 4.667 4.667 0 2.572-2.095 4.667-4.667 4.667z"/>
			</defs>
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g transform="translate(-974.000000, -487.000000) translate(820.000000, 398.000000) translate(154.000000, 89.000000)">
							<mask id="7bed1sygpb" fill="#fff">
								<use xlink:href="#ngt4av45ka"/>
							</mask>
							<g __fill__ mask="url(#7bed1sygpb)">
								<path d="M0 0H29.167V29.167H0z" transform="translate(-7.583333, -7.583333)"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#003E7B'
		}
	},
	inactivateCheck: {
		markup: `<?xml version="1.0"?>
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" __width__ __height__ x="0" y="0" viewBox="0 0 65.518 65.518" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
		<g xmlns="http://www.w3.org/2000/svg">
			<path d="M32.759,0C14.696,0,0,14.695,0,32.759s14.695,32.759,32.759,32.759s32.759-14.695,32.759-32.759S50.822,0,32.759,0z    M6,32.759C6,18.004,18.004,6,32.759,6c6.648,0,12.734,2.443,17.419,6.472L12.472,50.178C8.443,45.493,6,39.407,6,32.759z    M32.759,59.518c-5.948,0-11.447-1.953-15.895-5.248l37.405-37.405c3.295,4.448,5.248,9.947,5.248,15.895   C59.518,47.514,47.514,59.518,32.759,59.518z" __fill__ data-original="#000000" style="" class=""/>
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		<g xmlns="http://www.w3.org/2000/svg">
		</g>
		</g></svg>`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#003E7B'
		}
	},
	serviceNow: {
		markup: `<?xml version="1.0"?>
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" __width__ __height__ x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><g><g xmlns="http://www.w3.org/2000/svg"><path d="m136.794 74.723v-74.723h-.015l-74.707 74.707v.016z" fill="#003e7b" data-original="#000000" style=""/><g><path d="m140.807 237.693h68.326v129.336h-68.326z" fill="#003e7b" data-original="#000000" style=""/><path d="m166.794 0v104.723h-104.722v407.277h387.856v-512zm72.339 397.029h-128.326v-189.336h128.326zm162.994 0h-130.193v-30h130.193zm0-63.734h-130.193v-30h130.193zm0-63.734h-130.193v-30h130.193z" fill="#003e7b" data-original="#000000" style=""/></g></g></g></svg>`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#003E7B'
		}
	},
	remove: {
		markup: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 190 190"><circle fill=none stroke="#1c4279" stroke-miterlimit="10" stroke-width="5px" cx="95" cy="95.14" r="91.67"/><rect fill="#1d427a" x="84.85" y="43.21" width="20.3" height="103.55" transform="translate(-39.34 95) rotate(-45)"/><rect fill="#1d427a" x="43.22" y="84.86" width="103.55" height="20.3" transform="translate(-39.36 95) rotate(-45)"/></svg>',
		defaultStyles: {
			width: 14,
			height: 14
		}
	},
	editRow: {
		markup: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 190 190"><circle fill=none stroke="#1c4279" stroke-miterlimit="10" stroke-width= "5px" cx="95" cy="95.14" r="91.67"/><path fill="#1d427a" d="M46.51,123.27v20.2H66.72l59.61-59.61L106.12,63.65Zm95.39-55a5.38,5.38,0,0,0,0-7.6l0,0L129.36,48.12a5.38,5.38,0,0,0-7.6,0l0,0L111.88,58l20.2,20.2,9.85-9.85Z"/></svg>',
		defaultStyles: {
			width: 14,
			height: 14
		}
	},
	alertStatsIcon: {
		markup: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" __width__ __height__ xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 39.31 34.85"><defs><style>.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}</style><clipPath id="clip-path"><path d="M19.65,27.2a.62.62,0,0,1-.62-.62.63.63,0,0,1,1.25,0A.63.63,0,0,1,19.65,27.2Zm0-2.31a1.69,1.69,0,1,0,1.71,1.69A1.7,1.7,0,0,0,19.65,24.89Zm17.13,6.8a2.14,2.14,0,0,1-1.88,1.09H4.41A2.17,2.17,0,0,1,2.55,29.5L17.8,4a2.15,2.15,0,0,1,3.71,0L36.76,29.5A2.15,2.15,0,0,1,36.78,31.69ZM37.69,29,22.44,3.43a3.24,3.24,0,0,0-5.57,0L1.62,29a3.24,3.24,0,0,0,2.79,4.9H34.9A3.24,3.24,0,0,0,37.69,29ZM21.12,12.36a2,2,0,0,0-3.46,1.5l.28,3.45a.54.54,0,0,0,.59.49.53.53,0,0,0,.49-.57l-.28-3.46a.93.93,0,0,1,.24-.69.93.93,0,0,1,1.35,0,.93.93,0,0,1,.24.69l-.72,8.85a.19.19,0,0,1-.2.18.19.19,0,0,1-.19-.18l-.29-3.52a.54.54,0,0,0-.58-.5.55.55,0,0,0-.5.58l.29,3.52a1.28,1.28,0,0,0,2.55,0l.72-8.84A2,2,0,0,0,21.12,12.36Zm-.54-7.83h0A1.09,1.09,0,0,0,19.66,4a1.11,1.11,0,0,0-.92.52v0L3.48,30.05v0a1.08,1.08,0,0,0,.91,1.64H27.64a.54.54,0,1,0,0-1.08H4.4S19.64,5.12,19.65,5.09,34.9,30.6,34.9,30.63s-5.08,0-5.1,0a.54.54,0,0,0,0,1.08h5.12a1.08,1.08,0,0,0,.91-1.64Z"/></clipPath><clipPath id="clip-path-2"><rect fill=none x="-918.85" y="-186.15" width="1440" height="2126"/></clipPath></defs><g class="cls-2"><g class="cls-3"><rect y="0.85" width="39.31" height="34"/></g></g></svg>',
		defaultStyles: {
			width: 37,
			height: 42
		}
	},
	resolve: {
		markup: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" __width__ __height__ __fill__ viewBox="0 0 512 512"><path d="M79.26,190.46H304.19a15,15,0,0,0,0-30H79.26c-19.81.71-19.92,29.25,0,30Z"/><path d="M159.6,417.52H79.26c-19.85.72-19.88,29.26,0,30H159.6a15,15,0,0,0,0-30Z"/><path d="M79.26,254.72H304.19a15,15,0,1,0,0-30H79.26c-19.81.7-19.92,29.24,0,30Z"/><path d="M393.17,274.16c-3.27,0-6.51.14-9.71.4V111.2a47.13,47.13,0,0,0-47.14-47.14H284.63C278,43.84,257.91,30.62,236.41,31.93c-14.48-42.59-74.91-42.56-89.37,0-21.5-1.31-41.58,11.91-48.21,32.13H47.13A47.12,47.12,0,0,0,0,111.2V464.65a47.13,47.13,0,0,0,47.13,47.13H336.32a47,47,0,0,0,21.7-5.31c74.43,24.32,155.3-34.89,154-113.5A118.94,118.94,0,0,0,393.17,274.16ZM143.53,61.93H159.6a15,15,0,0,0,15-15,17.14,17.14,0,0,1,34.27,0,15,15,0,0,0,15,15h16.07a17.14,17.14,0,0,1,0,34.27h-96.4a17.14,17.14,0,0,1,0-34.27ZM47.13,481.78A17.14,17.14,0,0,1,30,464.65V111.2A17.11,17.11,0,0,1,47.13,94.06H98.86a47.2,47.2,0,0,0,44.67,32.14h96.4a47.23,47.23,0,0,0,44.69-32.14h51.7a17.11,17.11,0,0,1,17.14,17.14V281a118.58,118.58,0,0,0-34.71,19.43A15,15,0,0,0,304.19,289H79.26c-19.82.71-19.91,29.25,0,30h221a118.51,118.51,0,0,0-19.08,34.27H79.26a15,15,0,0,0,0,30h195.5c-3.33,37.87,12.74,75,39.59,98.53Zm346,0A88.91,88.91,0,0,1,304.36,393c4.47-117.66,173.18-117.63,177.63,0A88.91,88.91,0,0,1,393.17,481.78Z"/><path d="M413.71,361.6l-30.92,30.92-10.16-10.16a15,15,0,1,0-21.2,21.22l20.76,20.76a15,15,0,0,0,21.21,0l41.52-41.53a15,15,0,0,0-21.21-21.21Z"/></svg>',
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003e7b'
		}
	},
	showLater: {
		markup: '<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" __width__ __height__ __fill__ viewBox="0 0 512 512"><path d="M59.05,145.36a225.94,225.94,0,0,1,368.26-36.6L398,104.11l-4.71,29.64,80.24,12.75L486,67.24,456.3,62.59l-4.49,28.64A257.46,257.46,0,0,0,344.43,15.88,256,256,0,0,0,6,311.14l29.31-6.5A225.34,225.34,0,0,1,59.05,145.36Z"/><path d="M502.19,186.16l-28.87,8.22A225.8,225.8,0,0,1,72.81,388l33.11,5.26,4.71-29.64L30.4,350.82,18,430.08l29.65,4.65,3.92-25A255.83,255.83,0,0,0,502.19,186.16Z"/><path d="M148.85,256A107.63,107.63,0,0,1,181,179.22c-49.72,24.66-93.27,76.89-93.27,76.89s26,31.38,54,52.42A251.53,251.53,0,0,0,181.27,333,107.61,107.61,0,0,1,148.85,256Z"/><circle cx="256.81" cy="256" r="77.95"/><path d="M370.21,203.69a254.57,254.57,0,0,0-35.76-22.61,107.74,107.74,0,0,1-.62,150.47c51.26-23.65,90.41-75.44,90.41-75.44S398.25,224.73,370.21,203.69Z"/></svg>',
		defaultStyles: {
			width: 16,
			height: 16,
			fill: '#003e7b'
		}
	},
	accordianRightArrow: {
		markup: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" __width__ __height__ __fill__ viewBox="0 0 60 60"><path d="M15.72,56.78V5.89a1.43,1.43,0,0,1,2.39-1.18L44.5,30.2a1.67,1.67,0,0,1,0,2.36L18.11,58A1.43,1.43,0,0,1,15.72,56.78Z"/></svg>',
		defaultStyles: {
			width: 12,
			height: 12,
			fill: '#003e7b'
		}
	},
	accordianDownArrow: {
		markup: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" __width__ __height__ __fill__ viewBox="0 0 60 60"><path d="M4.91,16.7H55.8A1.43,1.43,0,0,1,57,19.09L31.49,45.48a1.67,1.67,0,0,1-2.36,0L3.73,19.08A1.43,1.43,0,0,1,4.91,16.7Z"/></svg>',
		defaultStyles: {
			width: 12,
			height: 12,
			fill: '#003e7b'
		}
	},
	WellAssistPlus: {
		markup: 
		`<svg width="140" height="84" viewBox="0 0 140 84" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 5C1 2.79086 2.79086 1 5 1H136C138.209 1 140 2.79086 140 5V80C140 82.2091 138.209 84 136 84H5C2.79086 84 1 82.2091 1 80V5Z" fill="white"/> <path d="M77.2302 16.27H71.7702V10.81H68.2002V16.27H62.7402V19.84H68.2002V25.3H71.7702V19.84H77.2302V16.27ZM38.6915 48L41.6515 36.336H39.9875L37.8435 45.808L35.1875 36.336H33.5875L30.9955 45.808L28.8035 36.336H27.1395L30.1315 48H31.7635L34.3715 38.416L37.0595
		 48H38.6915ZM50.4361 44.256C50.4361 42.976 50.3401 42.208 50.1001 41.584C49.5561 40.208 48.2761 39.376 46.7081 39.376C44.3721 39.376 42.8681 41.152 42.8681 43.92C42.8681 46.688 44.3081 48.368 46.6761 48.368C48.5961 48.368 49.9241 47.28 50.2601 45.456H48.9161C48.5481
		 46.56 47.7961 47.136 46.7241 47.136C45.8761 47.136 45.1561 46.752 44.7081 46.048C44.3881 45.568 44.2761 45.088 44.2601 44.256H50.4361ZM44.2921 43.168C44.4041 41.616 45.3481 40.608 46.6921 40.608C48.0521 40.608 48.9961 41.664 48.9961 43.168H44.2921ZM54.2882
		 36.336H52.9442V48H54.2882V36.336ZM58.6351 36.336H57.2911V48H58.6351V36.336ZM73.3871 44.496L74.5871 48H76.2511L72.1551 36.336H70.2351L66.0751 48H67.6591L68.8911 44.496H73.3871ZM72.9711 43.248H69.2591L71.1791 37.936L72.9711 43.248ZM84.2361 41.952C84.2201 40.304
		 83.1321 39.376 81.1961 39.376C79.2441 39.376 77.9801 40.384 77.9801 41.936C77.9801 43.248 78.6521 43.872 80.6361 44.352L81.8841 44.656C82.8121 44.88 83.1801 45.216 83.1801 45.808C83.1801 46.608 82.3961 47.136 81.2281 47.136C80.5081 47.136 79.9001 46.928 79.5641
		 46.576C79.3561 46.336 79.2601 46.096 79.1801 45.504H77.7721C77.8361 47.44 78.9241 48.368 81.1161 48.368C83.2281 48.368 84.5721 47.328 84.5721 45.712C84.5721 44.464 83.8681 43.776 82.2041 43.376L80.9241 43.072C79.8361 42.816 79.3721 42.464 79.3721 41.872C79.3721
		 41.088 80.0601 40.608 81.1481 40.608C82.2201 40.608 82.7961 41.072 82.8281 41.952H84.2361ZM93.0674 41.952C93.0514 40.304 91.9634 39.376 90.0274 39.376C88.0754 39.376 86.8114 40.384 86.8114 41.936C86.8114 43.248 87.4834 43.872 89.4674 44.352L90.7154 44.656C91.6434
		 44.88 92.0114 45.216 92.0114 45.808C92.0114 46.608 91.2274 47.136 90.0594 47.136C89.3394 47.136 88.7314 46.928 88.3954 46.576C88.1874 46.336 88.0914 46.096 88.0114 45.504H86.6034C86.6674 47.44 87.7554 48.368 89.9474 48.368C92.0594 48.368 93.4034 47.328 93.4034
		 45.712C93.4034 44.464 92.6994 43.776 91.0354 43.376L89.7554 43.072C88.6674 42.816 88.2034 42.464 88.2034 41.872C88.2034 41.088 88.8914 40.608 89.9794 40.608C91.0514 40.608 91.6274 41.072 91.6594 41.952H93.0674ZM97.2594 39.616H95.9314V48H97.2594V39.616ZM97.2594
		 36.336H95.9154V38.016H97.2594V36.336ZM106.214 41.952C106.198 40.304 105.11 39.376 103.174 39.376C101.222 39.376 99.9582 40.384 99.9582 41.936C99.9582 43.248 100.63 43.872 102.614 44.352L103.862 44.656C104.79 44.88 105.158 45.216 105.158 45.808C105.158 46.608
		 104.374 47.136 103.206 47.136C102.486 47.136 101.878 46.928 101.542 46.576C101.334 46.336 101.238 46.096 101.158 45.504H99.7502C99.8142 47.44 100.902 48.368 103.094 48.368C105.206 48.368 106.55 47.328 106.55 45.712C106.55 44.464 105.846 43.776 104.182 43.376L102.902
		 43.072C101.814 42.816 101.35 42.464 101.35 41.872C101.35 41.088 102.038 40.608 103.126 40.608C104.198 40.608 104.774 41.072 104.806 41.952H106.214ZM112.023 39.616H110.647V37.312H109.319V39.616H108.183V40.704H109.319V47.04C109.319 47.904 109.895 48.368 110.935
		 48.368C111.287 48.368 111.575 48.336 112.023 48.256V47.136C111.831 47.184 111.655 47.2 111.383 47.2C110.807 47.2 110.647 47.04 110.647 46.448V40.704H112.023V39.616ZM56.3456 65.056H60.0096C60.9216 65.056 61.6416 64.784 62.2656 64.224C62.9696 63.584 63.2736
		 62.832 63.2736 61.76C63.2736 59.568 61.9776 58.336 59.6736 58.336H54.8576V70H56.3456V65.056ZM56.3456 63.744V59.648H59.4496C60.8736 59.648 61.7216 60.416 61.7216 61.696C61.7216 62.976 60.8736 63.744 59.4496 63.744H56.3456ZM66.9929 58.336H65.6489V70H66.9929V58.336ZM76.6198
		 70V61.616H75.2918V66.368C75.2918 68.08 74.3958 69.2 73.0038 69.2C71.9478 69.2 71.2758 68.56 71.2758 67.552V61.616H69.9478V68.08C69.9478 69.472 70.9878 70.368 72.6198 70.368C73.8518 70.368 74.6358 69.936 75.4198 68.832V70H76.6198ZM85.6064 63.952C85.5904 62.304
		 84.5024 61.376 82.5664 61.376C80.6144 61.376 79.3504 62.384 79.3504 63.936C79.3504 65.248 80.0224 65.872 82.0064 66.352L83.2544 66.656C84.1824 66.88 84.5504 67.216 84.5504 67.808C84.5504 68.608 83.7664 69.136 82.5984 69.136C81.8784 69.136 81.2704 68.928 80.9344
		 68.576C80.7264 68.336 80.6304 68.096 80.5504 67.504H79.1424C79.2064 69.44 80.2944 70.368 82.4864 70.368C84.5984 70.368 85.9424 69.328 85.9424 67.712C85.9424 66.464 85.2384 65.776 83.5744 65.376L82.2944 65.072C81.2064 64.816 80.7424 64.464 80.7424 63.872C80.7424
		 63.088 81.4304 62.608 82.5184 62.608C83.5904 62.608 84.1664 63.072 84.1984 63.952H85.6064Z" fill="#003E7B"/> 
		 </svg>`
	},
	medPartD: {
		markup: `<?xml version="1.0" standalone="no"?>
		<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
		 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		 __height__ viewBox="0 0 415.000000 102.000000"
		 preserveAspectRatio="xMidYMid meet">
		
		<g transform="translate(0.000000,102.000000) scale(0.100000,-0.100000)"
		__fill__ stroke="none">
		<path d="M198 896 c-82 -29 -131 -86 -147 -169 -25 -134 36 -238 300 -510
		l134 -139 88 90 88 89 -17 37 -18 37 -68 -68 -68 -67 -71 69 c-116 114 -225
		243 -259 307 -28 53 -32 67 -28 119 3 48 10 65 33 89 40 42 93 57 146 41 49
		-15 111 -69 146 -128 13 -23 28 -43 32 -43 4 0 15 14 25 32 58 97 145 155 217
		143 77 -13 124 -77 117 -160 l-3 -45 42 0 43 0 0 60 c0 105 -53 182 -147 216
		-87 31 -187 7 -253 -58 l-41 -41 -42 41 c-68 66 -163 89 -249 58z"/>
		<path d="M1000 715 l0 -175 -105 0 -106 0 -20 -35 c-12 -19 -23 -35 -25 -35
		-2 0 -24 40 -49 89 -24 49 -49 92 -54 95 -18 11 -39 -6 -75 -60 -41 -61 -67
		-69 -115 -33 -54 39 -121 3 -121 -66 0 -69 67 -105 121 -66 18 13 43 21 69 21
		33 0 47 6 70 32 16 17 31 30 34 27 2 -2 25 -46 50 -96 28 -57 52 -93 61 -93 9
		0 34 29 56 65 l41 65 129 0 129 0 1 168 c0 92 2 163 4 157 2 -5 20 -81 40
		-167 l37 -158 44 0 c37 0 44 3 49 23 3 12 21 87 39 167 l35 145 0 -167 1 -168
		45 0 45 0 0 220 0 220 -68 0 -67 0 -29 -132 c-16 -73 -34 -150 -40 -173 l-12
		-40 -28 120 c-15 66 -33 143 -40 170 l-12 50 -67 3 -67 3 0 -176z"/>
		<path d="M2050 816 l0 -74 -37 20 c-68 35 -140 8 -174 -65 -66 -147 44 -302
		171 -239 31 15 40 16 40 6 0 -10 13 -14 40 -14 l40 0 0 220 0 220 -40 0 -40 0
		0 -74z m-31 -125 c11 -11 23 -36 27 -55 17 -95 -53 -159 -117 -107 -21 16 -24
		28 -24 81 0 53 3 65 24 81 30 24 66 24 90 0z"/>
		<path d="M2380 671 l0 -221 45 0 45 0 0 80 0 80 81 0 c78 0 82 1 114 33 61 61
		57 172 -8 221 -25 18 -45 21 -153 24 l-124 4 0 -221z m226 124 c19 -26 18 -75
		-3 -97 -12 -13 -31 -18 -75 -18 l-58 0 0 71 0 71 61 -4 c45 -3 65 -10 75 -23z"/>
		<path d="M3720 670 l0 -220 108 0 c92 0 114 3 152 23 81 40 119 165 86 280
		-32 111 -78 137 -245 137 l-101 0 0 -220z m204 140 c43 -16 66 -66 66 -140 0
		-107 -39 -150 -136 -150 l-44 0 0 150 0 150 44 0 c25 0 56 -4 70 -10z"/>
		<path d="M3350 805 c0 -38 -3 -45 -20 -45 -15 0 -20 -7 -20 -25 0 -18 5 -25
		20 -25 19 0 20 -7 20 -110 0 -104 1 -112 25 -135 38 -39 105 -32 105 10 0 17
		-7 25 -22 27 -22 3 -23 8 -26 106 l-3 102 26 0 c20 0 25 5 25 25 0 20 -5 25
		-25 25 -23 0 -25 4 -25 45 l0 45 -40 0 -40 0 0 -45z"/>
		<path d="M1570 769 c-61 -25 -92 -79 -93 -158 0 -80 25 -129 81 -153 67 -30
		124 -18 177 35 l40 42 -38 3 c-26 2 -45 -3 -63 -17 -49 -39 -114 -16 -114 40
		l0 29 105 0 105 0 0 38 c0 45 -26 99 -60 124 -31 22 -106 31 -140 17z m88 -66
		c11 -10 23 -28 27 -40 6 -22 4 -23 -59 -23 -57 0 -66 2 -66 18 0 24 36 62 59
		62 10 0 28 -8 39 -17z"/>
		<path d="M2824 766 c-35 -15 -64 -51 -64 -78 0 -27 66 -25 80 3 9 16 19 20 53
		17 37 -3 42 -6 42 -28 0 -22 -7 -26 -73 -41 -41 -9 -81 -23 -89 -32 -8 -8 -17
		-35 -20 -58 -10 -85 65 -132 146 -92 32 16 41 17 45 7 3 -9 22 -14 51 -14 42
		0 58 11 35 25 -6 4 -10 56 -10 123 0 134 -8 155 -68 172 -49 13 -90 12 -128
		-4z m100 -237 c-10 -11 -30 -19 -50 -19 -28 0 -35 5 -40 26 -8 32 5 46 59 60
		42 10 42 10 45 -19 2 -17 -4 -37 -14 -48z"/>
		<path d="M3244 770 c-12 -5 -29 -19 -38 -32 l-16 -22 0 27 c0 25 -3 27 -40 27
		l-40 0 0 -160 0 -160 40 0 40 0 0 101 c0 55 5 109 10 120 7 11 26 21 50 25 39
		6 40 8 40 45 0 41 -7 45 -46 29z"/>
		</g>
		</svg>`,
		defaultStyles: {
			height: 28,
			fill: '#003e7b'
		}
	},
	rightDirectionArrow: {
		markup: '<svg __width__ __height__ viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(-1 0 0 1 28 0)" fill="none" fill-rule="evenodd"><circle fill="#FFF" opacity=".4" cx="14" cy="14" r="14"/><path d="m11.19 13.532 5.302-5.34A.645.645 0 0 1 16.953 8c.175 0 .339.068.461.192l.39.393a.66.66 0 0 1 0 .928l-4.452 4.485 4.458 4.489c.122.123.19.288.19.464 0 .176-.068.34-.19.464l-.39.393a.645.645 0 0 1-.462.192.645.645 0 0 1-.46-.192l-5.308-5.345a.655.655 0 0 1-.19-.465c0-.177.067-.342.19-.466z" __fill__ fill-rule="nonzero"/></g></svg>',
		defaultStyles: {
			height: 28,
			width: 28,
			fill: '#003e7b'
		}
	},
	hollowExclaimaitionWarning: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" __height__ __width__ viewBox="0 0 69 69"><g fill="none"><circle cx="34.5" cy="34.5" r="34.5" __fill__ /><g fill="#FFF" transform="translate(30 18)"><path d="M4 .618a2.734 2.734 0 0 0-2.734 2.734v17.243a2.734 2.734 0 0 0 5.468 0V3.352A2.734 2.734 0 0 0 4 .618z"/><circle cx="3.999" cy="32.167" r="3.691"/></g></g></svg>',
		defaultStyles: {
			fill: '#FF7676',
			height: 69,
			width: 69
		}
	},
	userGroups: {
		markup: `<?xml version="1.0" standalone="no"?>
		<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
		 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		 __width__ __height__ viewBox="0 0 512.000000 512.000000"
		 preserveAspectRatio="xMidYMid meet">
		<metadata>
		Created by potrace 1.16, written by Peter Selinger 2001-2019
		</metadata>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		__fill__ stroke="none">
		<path d="M2340 4300 c-227 -61 -409 -209 -509 -413 -67 -138 -84 -213 -84
		-362 1 -148 23 -238 90 -368 38 -75 64 -109 143 -188 84 -84 107 -101 200
		-146 132 -65 221 -85 365 -85 346 2 633 209 748 540 53 155 50 373 -10 532
		-60 161 -198 325 -343 407 -133 75 -213 96 -380 100 -122 3 -157 0 -220 -17z
		m341 -330 c196 -66 319 -236 319 -440 0 -283 -253 -504 -526 -460 -254 41
		-433 280 -394 525 28 175 153 323 318 376 80 25 205 25 283 -1z"/>
		<path d="M975 3489 c-84 -9 -140 -25 -217 -66 -137 -71 -242 -196 -295 -350
		-23 -67 -27 -94 -27 -193 0 -99 4 -125 26 -188 69 -194 213 -335 403 -395 93
		-29 272 -31 355 -3 204 69 348 212 413 409 15 47 20 89 20 177 1 103 -2 124
		-29 200 -37 104 -87 182 -163 252 -62 57 -168 118 -241 139 -63 17 -174 25
		-245 18z m192 -355 c134 -64 198 -237 135 -366 -91 -184 -320 -223 -457 -77
		-51 55 -70 92 -80 161 -20 134 94 285 231 307 66 10 109 4 171 -25z"/>
		<path d="M3950 3488 c-136 -15 -261 -79 -361 -186 -77 -81 -123 -163 -149
		-268 -114 -444 274 -844 725 -749 219 46 402 224 460 446 13 49 16 91 12 179
		-6 139 -28 210 -99 316 -128 192 -345 289 -588 262z m143 -333 c138 -36 217
		-138 217 -279 0 -158 -142 -288 -300 -273 -138 12 -245 119 -257 256 -13 141
		88 272 230 301 23 4 44 8 47 9 3 1 32 -6 63 -14z"/>
		<path d="M2430 2459 c-353 -38 -703 -240 -914 -529 -26 -36 -49 -66 -50 -68
		-2 -1 -28 9 -58 23 -163 75 -364 90 -541 42 -262 -71 -471 -236 -597 -470 -75
		-140 -110 -274 -113 -437 -2 -119 11 -156 73 -197 44 -30 131 -32 178 -3 54
		33 68 68 75 185 16 252 143 452 352 556 144 71 257 82 390 38 91 -30 88 -23
		55 -124 -48 -150 -80 -342 -80 -479 0 -117 63 -189 164 -189 104 0 166 71 166
		187 0 92 29 262 62 366 137 428 469 722 872 771 380 47 776 -181 975 -561 90
		-172 151 -404 151 -576 0 -116 62 -187 166 -187 101 0 164 72 164 189 0 137
		-32 329 -80 479 -33 101 -36 94 55 124 133 44 246 33 390 -38 210 -104 335
		-301 351 -555 8 -118 22 -153 76 -186 47 -29 134 -27 178 3 61 40 75 78 73
		194 -3 204 -56 367 -175 540 -54 78 -156 180 -232 233 -257 176 -586 213 -844
		95 -30 -14 -56 -24 -58 -23 -1 2 -22 30 -47 64 -220 299 -561 495 -928 534
		-106 11 -142 11 -249 -1z"/>
		</g>
		</svg>`,
		defaultStyles: {
			width: 24,
			height: 24
		}
	},
	permissions: {
		markup: `<?xml version="1.0" standalone="no"?>
		<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
		 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		 __width__ __height__ viewBox="0 0 512.000000 512.000000"
		 preserveAspectRatio="xMidYMid meet">
		<metadata>
		Created by potrace 1.16, written by Peter Selinger 2001-2019
		</metadata>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		__fill__ stroke="none">
		<path d="M2330 5105 c-432 -76 -803 -355 -996 -750 -56 -116 -105 -272 -123
		-392 -6 -39 -11 -134 -11 -210 0 -219 39 -390 135 -588 81 -169 207 -331 349
		-450 l48 -41 -113 -43 c-228 -88 -493 -239 -684 -392 -443 -354 -772 -870
		-905 -1419 -29 -122 -32 -146 -28 -245 4 -93 10 -122 36 -190 74 -187 224
		-319 417 -370 49 -12 133 -15 487 -15 402 0 431 1 466 19 47 24 77 56 97 103
		40 98 -1 210 -97 259 -35 18 -63 19 -406 19 -377 0 -458 6 -501 38 -92 68
		-109 144 -67 307 157 619 596 1151 1180 1431 314 150 610 217 956 216 248 0
		417 -27 679 -109 63 -19 136 -35 161 -35 177 0 264 214 140 343 -22 23 -58 45
		-99 60 l-64 23 49 40 c142 120 264 277 348 449 96 198 136 370 136 590 0 162
		-11 244 -51 387 -102 362 -368 677 -714 846 -116 56 -272 105 -392 123 -96 15
		-340 12 -433 -4z m480 -424 c327 -95 576 -345 672 -677 20 -69 23 -100 22
		-249 0 -156 -2 -177 -28 -260 -101 -330 -359 -576 -694 -661 -134 -34 -310
		-34 -444 0 -335 85 -593 331 -694 661 -26 83 -28 104 -28 260 -1 149 2 180 22
		249 102 354 374 611 728 690 102 23 344 16 444 -13z"/>
		<path d="M3703 1975 c-175 -47 -314 -182 -373 -361 l-22 -64 -680 0 c-607 0
		-684 -2 -714 -16 -44 -21 -422 -409 -440 -451 -19 -45 -17 -141 4 -179 29 -54
		404 -432 445 -449 30 -13 97 -15 414 -15 363 0 378 1 421 21 26 13 54 38 70
		62 23 35 27 51 27 117 0 66 -4 82 -27 117 -16 24 -44 49 -70 62 -42 20 -59 21
		-349 21 l-304 0 -77 78 -77 77 70 78 71 77 714 0 c694 0 716 1 754 20 58 30
		84 72 129 216 35 112 46 136 75 162 47 41 81 44 441 40 383 -4 364 4 431 -185
		99 -274 99 -524 3 -807 -38 -112 -62 -151 -102 -174 -29 -15 -69 -17 -378 -17
		l-345 0 -37 25 c-41 28 -61 69 -102 205 -15 50 -37 106 -50 126 -48 75 -172
		102 -263 58 -95 -46 -123 -149 -83 -299 65 -240 163 -384 311 -460 116 -59
		127 -60 571 -60 401 0 410 0 482 23 141 45 263 152 324 285 44 94 98 260 126
		382 19 82 22 125 21 310 0 235 -9 297 -75 500 -54 167 -100 253 -176 329 -76
		75 -135 112 -230 141 -61 19 -92 20 -472 19 -316 0 -418 -3 -458 -14z"/>
		<path d="M4212 1179 c-62 -31 -95 -86 -100 -165 -8 -124 61 -204 184 -212 124
		-8 204 61 212 184 5 81 -22 143 -81 182 -56 37 -154 42 -215 11z"/>
		</g>
		</svg>`,
		defaultStyles: {
			width: 20,
			height: 20
		}
	},
	forward: {
		markup: `
		<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
			<path d="M8.735.004C4.192.134.379 3.69.026 8.314c-.376 4.933 3.325 9.264 8.259 9.657 4.933.393 9.28-3.303 9.693-8.282v-.007c.347-4.984-3.39-9.298-8.326-9.657a9.02 9.02 0 0 0-.917-.021zm.061 1.999c.236-.007.475-.002.716.015 3.853.281 6.736 3.595 6.471 7.506v.007c-.328 3.91-3.682 6.753-7.536 6.446a6.991 6.991 0 0 1-6.426-7.512 6.985 6.985 0 0 1 6.775-6.462zM7.861 5a.8.8 0 0 0-.615.258.938.938 0 0 0-.246.638c0 .24.088.47.246.638L9.989 9.5l-2.743 2.963A.938.938 0 0 0 7 13.1c0 .24.088.47.246.638a.79.79 0 0 0 1.175 0l3.334-3.602A.938.938 0 0 0 12 9.499a.938.938 0 0 0-.245-.638L8.421 5.26a.804.804 0 0 0-.56-.258z" fill="#003E7B" fill-rule="nonzero"/>
		</svg>`
	},
	backward: {
		markup: `
		<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
			<path d="M10.422 18.99c4.54-.21 8.29-3.831 8.562-8.461.29-4.939-3.486-9.205-8.425-9.511-4.94-.307-9.22 3.465-9.547 8.45v.007c-.26 4.99 3.55 9.237 8.492 9.51.31.017.616.02.918.005zm-.096-1.997c-.236.01-.475.01-.716-.003-3.857-.214-6.798-3.477-6.601-7.392V9.59c.26-3.914 3.564-6.817 7.422-6.577a6.991 6.991 0 0 1 6.557 7.4 6.985 6.985 0 0 1-6.662 6.578zm.883-3.014a.8.8 0 0 0 .61-.27.938.938 0 0 0 .235-.642.938.938 0 0 0-.257-.633L9.002 9.518l2.692-3.01a.938.938 0 0 0 .234-.642.938.938 0 0 0-.257-.634.79.79 0 0 0-1.174.02l-3.272 3.66a.938.938 0 0 0-.233.642c.004.239.096.467.256.633l3.397 3.543a.804.804 0 0 0 .564.249z" fill="#003E7B" fill-rule="nonzero"/>
		</svg>`
	},
	viewUserGroup: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 31.6 31.826668" ><defs><clipPath clipPathUnits="userSpaceOnUse" id="a3"><path d="M114.625 153.98c-21.477-1.136-41.738-11.679-57.883-30.109-4.215-4.812-4.215-5.676.024-10.539 16.12-18.45 36.457-28.969 58.035-30.063 24.398-1.21 47.472 9.356 65.625 30.086 4.215 4.817 4.215 5.676-.024 10.54-11.781 13.472-25.793 22.734-41.281 27.273-4.82 1.418-10.637 2.441-15.207 2.699-4.973.254-6.043.278-9.289.113zm9.34-10.839c7.289-1.258 14.293-5.821 18.101-11.75 4.571-7.168 5.051-15.825 1.297-23.153-1.472-2.863-2.894-4.726-5.308-7.004-13.582-12.824-36.707-8.914-44.578 7.539-2.844 5.93-2.895 13.192-.125 19.383 2.664 6.024 8.476 11.285 15.101 13.68 5.027 1.816 10.055 2.234 15.512 1.305z"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="b3"><path d="M-12946.4-16495.9H1453.58V2474.08H-12946.4z"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="c3"><path d="M115.918 131.879c-4.137-.816-7.793-3.164-9.875-6.375-1.547-2.352-2.055-4.098-2.031-6.891 0-2.699.277-3.793 1.449-6.047 1.09-2.074 4.238-4.957 6.547-5.98 8.148-3.609 17.621.07 20.562 7.957.84 2.258.868 5.793.051 8.145-1.851 5.375-7.234 9.121-13.402 9.328-1.242.047-2.742-.024-3.301-.137z"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="d3"><path d="M-12946.4-16495.9H1453.58V2474.08H-12946.4z"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="e3"><path d="M118.586 4.086c63.512 0 115 51.488 115 115s-51.488 115-115 115c-63.516 0-115-51.488-115-115s51.484-115 115-115z" clip-rule="evenodd"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="f3"><path d="M-12946.4-16495.9H1453.58V2474.08H-12946.4z"/></clipPath></defs><g clip-path="url(#a3)" transform="matrix(.13333 0 0 -.13333 0 31.827)"><g clip-path="url(#b3)"><path d="M42.527 72.059h152.114v92.086H42.527V72.059" fill="#1f3769"/></g></g><g clip-path="url(#c3)" transform="matrix(.13333 0 0 -.13333 0 31.827)"><g clip-path="url(#d3)"><path d="M93.988 92.977h49.45v49.086h-49.45V92.977" fill="#1f3769"/></g></g><g clip-path="url(#e3)" transform="matrix(.13333 0 0 -.13333 0 31.827)"><g clip-path="url(#f3)"><path d="M118.586 4.086c63.512 0 115 51.488 115 115s-51.488 115-115 115c-63.516 0-115-51.488-115-115s51.484-115 115-115z" fill="none" stroke="#1f3769" stroke-width="30" stroke-miterlimit="10"/></g></g></svg>',
		defaultStyles: {
			width: 23,
			height: 23,
		}
	},
	editUserGroup: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" __width__ __height__  viewBox="0 0 31.6 31.826668" ><defs><clipPath clipPathUnits="userSpaceOnUse" id="a2"><path d="M72.856 85.324V64.231h21.093l62.211 62.21-21.094 21.094zm99.617 57.43a5.603 5.603 0 0 1 0 7.934l-13.16 13.16a5.598 5.598 0 0 1-7.93 0l-10.297-10.293 21.094-21.094z" clip-rule="evenodd"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="b2"><path d="M-17.145-25.77h281.25v281.25h-281.25z"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="c2"><path d="M118.48 4.355c63.512 0 115 51.489 115 115 0 63.512-51.488 115-115 115-63.511 0-115-51.488-115-115 0-63.511 51.489-115 115-115z" clip-rule="evenodd"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="d2"><path d="M-13246.5-16495.7H1153.48V2474.35H-13246.5z"/></clipPath></defs><g clip-path="url(#a2)" transform="matrix(.13333 0 0 -.13333 0 31.827)"><g clip-path="url(#b2)"><path d="M62.855 176.043h121.813V54.23H62.855v121.813" fill="#1f3769"/></g></g><g clip-path="url(#c2)" transform="matrix(.13333 0 0 -.13333 0 31.827)"><g clip-path="url(#d2)"><path d="M118.48 4.355c63.512 0 115 51.489 115 115 0 63.512-51.488 115-115 115-63.511 0-115-51.488-115-115 0-63.511 51.489-115 115-115z" fill="none" stroke="#1f3769" stroke-width="30" stroke-miterlimit="10"/></g></g></svg>',
		defaultStyles: {
			width: 23,
			height: 23,
		}
	},
	invalidGroupNameMessage: {
		markup: `<?xml version="1.0" standalone="no"?>
		<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
		 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		 __width__ __height__ viewBox="0 0 513.000000 512.000000"
		 preserveAspectRatio="xMidYMid meet">
		<metadata>
		Created by potrace 1.16, written by Peter Selinger 2001-2019
		</metadata>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		__fill__ stroke="none">
		<path d="M2151 5069 c-233 -41 -481 -119 -653 -205 -561 -279 -943 -661 -1222
		-1222 -89 -177 -165 -424 -206 -661 -29 -173 -29 -649 0 -822 72 -423 218
		-757 491 -1124 37 -50 89 -115 116 -145 27 -30 61 -70 75 -88 64 -78 294 -264
		449 -365 283 -182 568 -295 924 -363 132 -26 156 -28 435 -28 324 -1 399 8
		656 75 511 132 991 446 1329 869 224 280 389 605 474 934 67 257 76 332 75
		656 0 279 -2 303 -28 435 -82 424 -232 764 -479 1090 -78 101 -207 248 -249
		283 -18 14 -58 48 -88 75 -30 27 -95 79 -145 116 -367 273 -701 419 -1124 491
		-165 28 -670 28 -830 -1z m-451 -1305 c46 -21 118 -89 455 -430 220 -222 407
		-404 415 -404 8 0 195 182 415 404 456 462 458 463 586 454 55 -4 76 -11 106
		-33 77 -57 112 -121 113 -205 0 -112 -10 -124 -456 -565 -222 -221 -404 -407
		-404 -415 0 -8 182 -195 404 -415 462 -456 463 -458 454 -585 -4 -56 -11 -76
		-36 -110 -53 -72 -103 -102 -182 -108 -127 -9 -129 -8 -585 454 -220 222 -407
		404 -415 404 -8 0 -194 -182 -415 -404 -441 -446 -453 -456 -565 -456 -84 1
		-148 36 -205 113 -22 30 -29 51 -33 106 -9 128 -8 130 454 586 222 220 404
		407 404 415 0 8 -182 195 -404 415 -341 337 -409 409 -430 455 -100 214 110
		424 324 324z"/>
		</g>
		</svg>`,
		defaultStyles: {
			width: 14,
			height: 14,
			fill: '#e02124'
		}
	},
	deleteUserGroup: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 31.6 31.826668" ><defs><clipPath clipPathUnits="userSpaceOnUse" id="a1"><path d="M118.48 3.613c63.512 0 115 51.489 115 115 0 63.512-51.488 115-115 115-63.511 0-115-51.488-115-115 0-63.511 51.489-115 115-115z" clip-rule="evenodd"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="b1"><path d="M-13546.5-16496.4H853.48V2473.61H-13546.5z"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="c1"><path d="M85.98 80.695c0-5.957 4.876-10.832 10.833-10.832h43.335c5.957 0 10.832 4.875 10.832 10.832v65h-65zm70.418 81.25h-18.96l-5.415 5.418h-27.085l-5.415-5.418h-18.96v-10.832h75.835z" clip-rule="evenodd"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="d1"><path d="M-16.938-16.805h270.836v270.836H-16.938z"/></clipPath></defs><g clip-path="url(#a1)" transform="matrix(.13333 0 0 -.13333 0 31.827)"><g clip-path="url(#b1)"><path d="M118.48 3.613c63.512 0 115 51.489 115 115 0 63.512-51.488 115-115 115-63.511 0-115-51.488-115-115 0-63.511 51.489-115 115-115z" fill="none" stroke="#1f3769" stroke-width="30" stroke-miterlimit="10"/></g></g><g clip-path="url(#c1)" transform="matrix(.13333 0 0 -.13333 0 31.827)"><g clip-path="url(#d1)"><path d="M70.563 177.363h95.835v-117.5H70.563v117.5" fill="#1f3769"/></g></g></svg>',
		defaultStyles: {
			width: 23,
			height: 23,
		}
	},
	addUserIcon: {
		markup: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" __width__ __height__ viewBox="0 0 1362.37 1319.79"><defs><style>.cls-1,.cls-3{fill:#57bf96;}.cls-1,.cls-6{stroke:#58bf96;stroke-miterlimit:10;stroke-width:0.1px;}.cls-2,.cls-6{fill:none;}.cls-4{clip-path:url(#clip-path);}.cls-5{clip-path:url(#clip-path-2);}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:#fff;}.cls-9{clip-path:url(#clip-path-4);}</style><clipPath id="clip-path"><rect class="cls-1" x="42.57" y="42.57" width="1277.22" height="1234.64" rx="85.15"/></clipPath><clipPath id="clip-path-2"><rect class="cls-1" x="-6342.28" y="-2809.55" width="23369.01" height="17510.53"/></clipPath><clipPath id="clip-path-3"><rect class="cls-2" x="635.25" y="340.59" width="134.44" height="638.61"/></clipPath><clipPath id="clip-path-4"><rect class="cls-2" x="383.17" y="592.67" width="638.61" height="134.44"/></clipPath></defs><rect class="cls-3" x="42.57" y="42.57" width="1277.22" height="1234.64" rx="85.15"/><g class="cls-4"><rect class="cls-3" x="-6342.28" y="-2809.55" width="23369.01" height="17510.53"/><g class="cls-5"><rect class="cls-1" width="1362.37" height="1319.79"/></g><rect class="cls-6" x="-6342.28" y="-2809.55" width="23369.01" height="17510.53"/></g><rect class="cls-6" x="42.57" y="42.57" width="1277.22" height="1234.64" rx="85.15"/><g class="cls-7"><rect class="cls-8" x="592.67" y="298.02" width="219.59" height="723.76"/></g><g class="cls-9"><rect class="cls-8" x="340.59" y="550.1" width="723.76" height="219.59"/></g></svg>',
		defaultStyles: {
			width: 30,
			height: 30
		}
	},
	removeUserIcon: {
		markup: `<?xml version="1.0" standalone="no"?>
		<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
		 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		 __width__ __height__ viewBox="0 0 512.000000 512.000000"
		 preserveAspectRatio="xMidYMid meet">
		<metadata>
		Created by potrace 1.16, written by Peter Selinger 2001-2019
		</metadata>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		__fill__ stroke="none">
		<path d="M445 5089 c-229 -27 -406 -215 -422 -449 -7 -94 9 -171 52 -258 31
		-61 111 -144 910 -942 l875 -875 -884 -885 c-926 -928 -924 -926 -960 -1049
		-22 -76 -21 -213 3 -290 47 -151 157 -257 308 -296 72 -19 241 -19 309 -1 128
		34 115 22 1044 951 l875 875 880 -879 c929 -928 907 -908 1036 -945 77 -23
		240 -23 316 -1 203 58 333 235 333 454 0 108 -25 196 -76 273 -20 29 -430 445
		-912 925 l-877 871 876 879 c829 831 877 881 904 943 83 190 43 411 -99 550
		-110 108 -208 145 -369 138 -122 -6 -189 -29 -274 -93 -32 -24 -436 -422 -897
		-884 l-840 -840 -873 869 c-620 617 -888 877 -926 898 -92 53 -201 74 -312 61z"/>
		</g>
		</svg>`,
		defaultStyles: {
			width: 10,
			height: 10,
			fill: '#a6a6a6'
		}
	},
	editIcon: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 20 20"> <g __fill__ fill-rule="nonzero" __stroke__ stroke-width=".5"> <path d="M17.553 12.398a.445.445 0 0 0-.446.444v3.94c-.001.734-.6 1.33-1.34 1.33H3.233c-.74 0-1.339-.596-1.34-1.33V5.218c.001-.735.6-1.33 1.34-1.332H7.2a.445.445 0 0 0 .447-.443c0-.245-.2-.444-.447-.444H3.233A2.229 2.229 0 0 0 1 5.219V16.78A2.229 2.229 0 0 0 3.233 19h12.534A2.229 2.229 0 0 0 18 16.781v-3.94c0-.245-.2-.443-.447-.443z"/> <path d="M17.897 1.584a1.994 1.994 0 0 0-2.82 0L7.17 9.49a.443.443 0 0 0-.114.195l-1.04 3.753a.443.443 0 0 0 .545.546l3.754-1.04c.074-.02.141-.06.195-.114l7.907-7.906c.777-.779.777-2.04 0-2.82l-.52-.52zM8.135 9.778l6.471-6.47 2.087 2.086-6.47 6.47-2.088-2.086zm-.417.836l1.668 1.668-2.307.639.64-2.307zM17.79 4.298l-.47.47-2.087-2.087.47-.47a1.108 1.108 0 0 1 1.567 0l.52.52a1.11 1.11 0 0 1 0 1.567z"/> </g> </svg>',
		defaultStyles: {
			width: 20,
			height: 20,
			fill: '#000000',
			stroke: '#000000'
		}
	},
	errorIconCross: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" fill="#e51a1a" viewBox="0 0 30 30" __width__ __height__ ><path d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16.414,15 c0,0,3.139,3.139,3.293,3.293c0.391,0.391,0.391,1.024,0,1.414c-0.391,0.391-1.024,0.391-1.414,0C18.139,19.554,15,16.414,15,16.414 s-3.139,3.139-3.293,3.293c-0.391,0.391-1.024,0.391-1.414,0c-0.391-0.391-0.391-1.024,0-1.414C10.446,18.139,13.586,15,13.586,15 s-3.139-3.139-3.293-3.293c-0.391-0.391-0.391-1.024,0-1.414c0.391-0.391,1.024-0.391,1.414,0C11.861,10.446,15,13.586,15,13.586 s3.139-3.139,3.293-3.293c0.391-0.391,1.024-0.391,1.414,0c0.391,0.391,0.391,1.024,0,1.414C19.554,11.861,16.414,15,16.414,15z"/></svg>',
		defaultStyles: {
			width: 60,
			height: 60
		}
	},
	allPriorAuthItems: {
		markup: `<?xml version="1.0" standalone="no"?>
		<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
		 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		 __width__ __height__ viewBox="0 0 512.000000 512.000000"
		 preserveAspectRatio="xMidYMid meet">
		<metadata>
		Created by potrace 1.16, written by Peter Selinger 2001-2019
		</metadata>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		__fill__ stroke="none">
		<path d="M976 5091 c-15 -10 -37 -32 -47 -47 -18 -27 -19 -53 -19 -360 l0
		-332 -82 -26 c-120 -37 -200 -88 -303 -191 -72 -72 -99 -107 -133 -175 -81
		-162 -82 -174 -82 -747 l0 -503 -107 0 c-119 0 -147 -10 -184 -66 -18 -28 -19
		-68 -19 -1134 0 -1007 1 -1108 16 -1130 25 -37 293 -307 338 -341 l39 -29
		2167 0 2167 0 39 29 c45 34 313 304 338 341 15 22 16 123 16 1130 0 1066 -1
		1106 -19 1134 -37 56 -65 66 -183 66 l-108 0 -2 1038 -3 1037 -34 70 c-45 92
		-124 171 -216 216 l-70 34 -725 0 -725 0 -70 -34 c-92 -45 -171 -124 -216
		-216 l-34 -70 -3 -282 -3 -281 -67 39 c-37 22 -104 51 -149 65 l-83 26 0 332
		c0 307 -1 333 -19 360 -10 15 -32 37 -47 47 -28 18 -59 19 -684 19 -625 0
		-656 -1 -684 -19z m1134 -506 l0 -225 -450 0 -450 0 0 225 0 225 450 0 450 0
		0 -225z m2318 200 c18 -11 43 -36 55 -55 l22 -35 3 -992 2 -993 -750 0 -750 0
		2 993 3 992 22 35 c24 39 53 60 98 71 17 4 307 7 645 6 596 -2 616 -3 648 -22z
		m-2119 -735 c103 -14 188 -55 262 -129 72 -73 118 -164 126 -251 l6 -60 -1043
		0 -1043 0 6 60 c16 182 189 355 379 379 90 12 1218 12 1307 1z m401 -1040 l0
		-300 -1050 0 -1050 0 0 300 0 300 1050 0 1050 0 0 -300z m2110 -1537 l0 -938
		-112 -112 -113 -113 -2035 0 -2035 0 -112 112 -113 113 0 937 0 938 2260 0
		2260 0 0 -937z"/>
		<path d="M3376 4491 c-46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 39 -26
		129 -26 168 0 46 31 66 69 66 131 0 62 -20 100 -66 131 -20 13 -47 19 -84 19
		-37 0 -64 -6 -84 -19z"/>
		<path d="M3976 4491 c-46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 39 -26
		129 -26 168 0 46 31 66 69 66 131 0 37 -6 64 -19 84 -31 46 -69 66 -131 66
		-37 0 -64 -6 -84 -19z"/>
		<path d="M3376 3891 c-46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 39 -26
		129 -26 168 0 46 31 66 69 66 131 0 62 -20 100 -66 131 -20 13 -47 19 -84 19
		-37 0 -64 -6 -84 -19z"/>
		<path d="M3976 3891 c-46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 39 -26
		129 -26 168 0 46 31 66 69 66 131 0 62 -20 100 -66 131 -20 13 -47 19 -84 19
		-37 0 -64 -6 -84 -19z"/>
		<path d="M3376 3291 c-46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 39 -26
		129 -26 168 0 46 31 66 69 66 131 0 62 -20 100 -66 131 -20 13 -47 19 -84 19
		-37 0 -64 -6 -84 -19z"/>
		<path d="M3976 3291 c-46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 39 -26
		129 -26 168 0 46 31 66 69 66 131 0 37 -6 64 -19 84 -31 46 -69 66 -131 66
		-37 0 -64 -6 -84 -19z"/>
		<path d="M2176 2091 c-55 -37 -66 -66 -66 -178 l0 -103 -102 0 c-113 0 -142
		-11 -179 -66 -18 -27 -19 -53 -19 -384 0 -331 1 -357 19 -384 37 -55 66 -66
		179 -66 l102 0 0 -102 c0 -113 11 -142 66 -179 27 -18 53 -19 384 -19 331 0
		357 1 384 19 55 37 66 66 66 179 l0 102 103 0 c112 0 141 11 178 66 18 27 19
		53 19 384 0 331 -1 357 -19 384 -37 55 -66 66 -178 66 l-103 0 0 103 c0 112
		-11 141 -66 178 -27 18 -53 19 -384 19 -331 0 -357 -1 -384 -19z m534 -383 c0
		-113 11 -142 66 -179 24 -15 48 -19 132 -19 l102 0 0 -150 0 -150 -102 0
		c-113 0 -142 -11 -179 -66 -15 -24 -19 -48 -19 -131 l0 -103 -150 0 -150 0 0
		103 c0 83 -4 107 -19 131 -37 55 -66 66 -178 66 l-103 0 0 150 0 150 103 0
		c83 0 107 4 131 19 55 37 66 66 66 179 l0 102 150 0 150 0 0 -102z"/>
		</g>
		</svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	inProgress: {
		markup: `<?xml version="1.0" standalone="no"?>
		<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
		 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		 __width__ __height__ viewBox="0 0 512.000000 512.000000"
		 preserveAspectRatio="xMidYMid meet">
		<metadata>
		Created by potrace 1.16, written by Peter Selinger 2001-2019
		</metadata>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		__fill__ stroke="none">
		<path d="M29 4831 l-29 -29 0 -2237 0 -2237 34 -34 34 -34 2497 0 2497 0 29
		29 c24 25 29 38 29 78 0 54 -21 86 -67 104 -13 5 -96 9 -184 9 l-159 0 0 1435
		c0 1599 6 1479 -70 1509 -35 14 -90 16 -386 16 -370 0 -394 -3 -428 -51 -15
		-21 -16 -149 -16 -1471 l0 -1448 -100 0 -100 0 0 1176 0 1176 -29 29 -29 29
		-391 0 -391 0 -32 -29 -33 -29 -3 -1176 -2 -1176 -95 0 -95 0 0 875 c0 941 1
		918 -49 945 -13 6 -161 10 -408 10 l-389 0 -30 -31 -29 -30 -3 -885 -2 -884
		-95 0 -95 0 -2 576 -3 576 -33 29 -32 29 -386 0 -386 0 -34 -34 -34 -34 0
		-571 0 -571 -140 0 -140 0 -2 2166 -3 2166 -33 29 c-46 41 -111 41 -153 0z
		m4471 -2991 l0 -1370 -240 0 -240 0 0 1370 0 1370 240 0 240 0 0 -1370z
		m-1100 -270 l0 -1100 -240 0 -240 0 0 1100 0 1100 240 0 240 0 0 -1100z
		m-1110 -295 l0 -805 -235 0 -235 0 0 805 0 805 235 0 235 0 0 -805z m-1090
		-310 l0 -495 -240 0 -240 0 0 495 0 495 240 0 240 0 0 -495z"/>
		<path d="M2669 4261 c-24 -24 -29 -38 -29 -75 0 -72 31 -97 163 -131 68 -17
		104 -31 95 -36 -7 -4 -314 -192 -683 -418 -453 -277 -676 -420 -687 -438 -33
		-52 -15 -128 37 -151 64 -30 59 -33 764 404 370 228 675 413 677 411 3 -3 -4
		-41 -15 -85 -40 -155 -21 -210 77 -220 46 -4 54 -2 80 24 25 25 36 60 91 281
		68 272 69 289 19 326 -30 22 -466 137 -521 137 -29 0 -46 -7 -68 -29z"/>
		</g>
		</svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	complete: {
		markup: `<?xml version="1.0" standalone="no"?>
		<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
		 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
		<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		 __width__ __height__ viewBox="0 0 512.000000 512.000000"
		 preserveAspectRatio="xMidYMid meet">
		<metadata>
		Created by potrace 1.16, written by Peter Selinger 2001-2019
		</metadata>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		__fill__ stroke="none">
		<path d="M2230 5105 c-444 -55 -852 -220 -1220 -493 -150 -112 -400 -362 -512
		-512 -239 -322 -388 -659 -470 -1061 -22 -107 -23 -137 -23 -479 0 -342 1
		-372 23 -479 82 -402 231 -739 470 -1061 112 -150 362 -400 512 -512 372 -276
		779 -439 1230 -494 155 -18 465 -18 620 1 344 43 689 157 967 321 115 68 147
		112 146 206 -1 117 -84 198 -204 198 -47 0 -70 -7 -126 -37 -273 -147 -461
		-216 -723 -266 -156 -29 -571 -32 -720 -4 -466 87 -846 285 -1169 608 -323
		323 -521 703 -608 1169 -25 136 -25 564 0 700 87 466 285 846 608 1169 323
		323 703 521 1169 608 137 25 564 25 700 0 308 -58 608 -175 818 -319 136 -94
		254 -88 336 15 27 34 31 48 34 110 4 100 -17 135 -128 209 -319 214 -706 356
		-1105 403 -147 18 -480 18 -625 0z"/>
		<path d="M4814 4690 c-34 -17 -218 -241 -1095 -1333 -580 -721 -1067 -1324
		-1083 -1339 -22 -22 -38 -28 -72 -28 -51 0 10 -54 -667 590 -252 239 -477 445
		-500 458 -35 20 -53 23 -108 20 -83 -4 -138 -38 -170 -105 -29 -60 -24 -157
		11 -206 40 -55 1089 -1045 1153 -1088 161 -107 400 -107 563 0 32 21 75 56 95
		77 69 74 2134 2649 2152 2684 27 53 20 154 -15 207 -52 78 -174 107 -264 63z"/>
		<path d="M4737 3329 c-48 -26 -94 -89 -102 -143 -5 -28 2 -83 19 -167 39 -189
		49 -312 43 -524 -10 -390 -108 -720 -314 -1057 -61 -100 -68 -117 -71 -174 -8
		-124 61 -204 184 -212 98 -7 140 18 211 126 211 320 347 709 394 1121 17 155
		7 524 -20 676 -47 269 -66 312 -158 359 -45 23 -138 20 -186 -5z"/>
		</g>
		</svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	error: {
		markup: '<svg xmlns="http://www.w3.org/2000/svg" __width__ __height__ viewBox="0 0 69 69"><g fill="none"><circle cx="34.5" cy="34.5" r="34.5" __fill__ /><path fill="#FFF" d="M23.322 24.909c-.43-.43-.43-1.143 0-1.587.444-.43 1.143-.43 1.587 0l9.523 9.539 9.539-9.54c.429-.428 1.143-.428 1.57 0 .445.445.445 1.16 0 1.588l-9.522 9.524 9.523 9.539c.444.429.444 1.143 0 1.587-.43.429-1.143.429-1.571 0l-9.54-9.54-9.522 9.54c-.444.429-1.143.429-1.587 0-.43-.444-.43-1.16 0-1.587l9.523-9.54-9.523-9.523z"/></g></svg>',
		defaultStyles: {
			width: 69,
			height: 69,
			fill: '#FF7676'
		}
	},
	calling: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
			__width__ __height__ viewBox="0 0 512.000000 512.000000"
			preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		fill="#000000" stroke="none">
		<path d="M3665 5113 c-218 -28 -423 -104 -605 -226 -96 -64 -273 -241 -337
		-337 -101 -151 -172 -319 -210 -500 -24 -118 -24 -372 0 -490 38 -181 109
		-349 210 -500 105 -158 331 -353 494 -429 l52 -24 3 -198 c3 -219 6 -227 78
		-277 70 -47 78 -44 495 199 209 122 421 240 470 262 191 87 304 167 441 309
		331 345 448 856 299 1305 -71 213 -167 368 -329 528 -162 161 -311 253 -516
		319 -165 54 -393 78 -545 59z m224 -860 c49 -38 64 -77 69 -188 l5 -102 102
		-5 c77 -3 111 -9 135 -24 99 -58 105 -189 11 -251 -30 -20 -46 -23 -141 -23
		l-107 0 -5 -108 c-3 -84 -9 -117 -24 -142 -56 -96 -184 -105 -248 -17 -18 24
		-22 48 -26 145 l-5 117 -117 5 c-97 4 -121 8 -145 26 -88 64 -79 192 17 248
		25 15 58 21 142 24 l108 5 0 107 c0 95 3 111 23 141 45 68 143 88 206 42z"/>
		<path d="M675 4170 c-126 -25 -200 -73 -361 -234 -107 -108 -126 -132 -171
		-221 -247 -486 -171 -1101 216 -1745 179 -298 395 -564 721 -890 513 -514 959
		-817 1436 -976 446 -149 855 -136 1199 39 89 45 113 64 221 171 66 67 137 146
		157 176 101 153 111 342 27 511 -27 53 -72 103 -269 300 -249 250 -278 271
		-402 304 -113 30 -259 13 -363 -43 -29 -15 -110 -84 -186 -158 -160 -155 -196
		-174 -333 -174 -242 0 -515 156 -841 478 -247 244 -395 456 -467 667 -20 57
		-24 90 -24 180 0 160 9 179 169 345 73 75 143 157 158 186 56 104 73 250 43
		363 -32 123 -55 153 -304 403 -197 197 -247 241 -300 268 -104 52 -225 70
		-326 50z"/>
		</g>
	   </svg>`,
		defaultStyles: {
			width: 19,
			height: 19,
			fill: '#FF7676'
		}
	},
	dropDownList: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		__width__ __height__ viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet">
	   <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
	   __fill__ stroke="none">
	   <path d="M414 4902 c-291 -146 -353 -185 -354 -219 0 -8 -13 -13 -30 -13 l-30
	   0 0 -300 0 -300 30 0 c17 0 30 -5 30 -13 0 -33 70 -77 321 -202 l269 -135 0
	   -255 0 -255 -269 -135 c-251 -125 -321 -169 -321 -202 0 -8 -13 -13 -30 -13
	   l-30 0 0 -300 0 -300 30 0 c17 0 30 -5 30 -13 0 -33 70 -77 321 -202 l269
	   -135 0 -255 0 -255 -269 -135 c-251 -125 -321 -169 -321 -202 0 -8 -13 -13
	   -30 -13 l-30 0 0 -300 0 -300 30 0 c17 0 30 -5 30 -13 0 -34 71 -78 361 -222
	   170 -85 318 -155 329 -155 11 0 163 72 338 160 225 113 323 168 337 187 19 27
	   20 44 20 343 0 299 -1 316 -20 343 -14 19 -103 69 -298 167 l-277 140 0 255 0
	   255 277 140 c195 98 284 148 298 167 19 27 20 44 20 343 0 299 -1 316 -20 343
	   -14 19 -103 69 -297 167 l-278 140 0 255 0 255 278 140 c194 98 283 148 297
	   167 19 27 20 44 20 343 0 299 -1 316 -20 343 -23 32 -639 347 -677 347 -13 -1
	   -163 -72 -334 -158z m460 -361 c54 -36 66 -66 66 -171 0 -76 -4 -101 -19 -124
	   -36 -54 -67 -66 -169 -66 -157 0 -192 34 -192 188 0 157 34 192 190 192 76 0
	   101 -4 124 -19z m0 -1810 c54 -36 66 -66 66 -171 0 -76 -4 -101 -19 -124 -36
	   -54 -67 -66 -169 -66 -157 0 -192 34 -192 188 0 157 34 192 190 192 76 0 101
	   -4 124 -19z m0 -1810 c54 -36 66 -66 66 -171 0 -76 -4 -101 -19 -124 -36 -54
	   -67 -66 -169 -66 -157 0 -192 34 -192 188 0 157 34 192 190 192 76 0 101 -4
	   124 -19z"/>
	   <path d="M1916 4751 c-16 -11 -38 -33 -48 -50 -19 -29 -19 -31 -1 -61 10 -17
	   32 -40 49 -51 31 -19 67 -19 1544 -19 1486 0 1513 0 1544 20 18 10 38 31 46
	   45 9 18 22 25 42 25 15 0 28 5 28 10 0 6 -13 10 -28 10 -20 0 -33 7 -42 25 -8
	   14 -28 35 -46 45 -31 20 -58 20 -1545 20 -1473 0 -1515 -1 -1543 -19z"/>
	   <path d="M1916 4151 c-16 -11 -38 -33 -48 -50 -19 -29 -19 -31 -1 -61 10 -17
	   32 -40 49 -51 30 -18 58 -19 789 -19 842 0 792 -4 837 68 l20 32 -20 33 c-45
	   71 5 67 -839 67 -729 0 -759 -1 -787 -19z"/>
	   <path d="M1916 2941 c-16 -11 -38 -33 -48 -50 -19 -29 -19 -31 -1 -61 10 -17
	   32 -40 49 -51 31 -19 67 -19 1544 -19 1486 0 1513 0 1544 20 18 10 38 31 46
	   45 9 18 22 25 42 25 15 0 28 5 28 10 0 6 -13 10 -28 10 -20 0 -33 7 -42 25 -8
	   14 -28 35 -46 45 -31 20 -58 20 -1545 20 -1473 0 -1515 -1 -1543 -19z"/>
	   <path d="M1916 2341 c-16 -11 -38 -33 -48 -50 -19 -29 -19 -31 -1 -61 10 -17
	   32 -40 49 -51 30 -18 58 -19 789 -19 842 0 792 -4 837 68 l20 32 -20 33 c-45
	   71 5 67 -839 67 -729 0 -759 -1 -787 -19z"/>
	   <path d="M1916 1131 c-16 -11 -38 -33 -48 -50 -19 -29 -19 -31 -1 -61 10 -17
	   32 -40 49 -51 31 -19 67 -19 1544 -19 1486 0 1513 0 1544 20 18 10 38 31 46
	   45 9 18 22 25 42 25 15 0 28 5 28 10 0 6 -13 10 -28 10 -20 0 -33 7 -42 25 -8
	   14 -28 35 -46 45 -31 20 -58 20 -1545 20 -1473 0 -1515 -1 -1543 -19z"/>
	   <path d="M1916 531 c-16 -11 -38 -33 -48 -50 -19 -29 -19 -31 -1 -61 10 -17
	   32 -40 49 -51 30 -18 58 -19 789 -19 842 0 792 -4 837 68 l20 32 -20 33 c-45
	   71 5 67 -839 67 -729 0 -759 -1 -787 -19z"/>
	   </g>
	   </svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	drugPreference: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		__width__ __height__ viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet">
	   <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
	   __fill__ stroke="none">
	   <path d="M2520 5014 c-351 -53 -635 -222 -818 -486 -55 -80 -1515 -2605 -1580
	   -2733 -50 -98 -87 -208 -108 -317 -24 -125 -15 -371 19 -500 115 -438 449
	   -758 891 -854 100 -22 308 -29 403 -15 237 37 455 138 624 290 51 45 58 49 70
	   35 23 -28 126 -94 197 -126 190 -86 501 -155 852 -190 175 -17 741 -17 915 0
	   617 61 1020 208 1113 405 22 47 22 48 22 640 l0 593 -26 52 c-135 272 -885
	   444 -1784 410 -124 -4 -231 -10 -238 -13 -16 -6 -39 -47 308 555 164 283 311
	   542 327 575 158 316 158 701 -1 1030 -197 408 -604 659 -1056 654 -58 -1 -116
	   -3 -130 -5z m375 -233 c165 -43 365 -164 474 -287 243 -273 313 -669 177
	   -1004 -14 -34 -188 -344 -388 -690 l-362 -628 -47 27 c-1130 647 -1608 928
	   -1606 941 4 16 656 1148 715 1240 48 76 181 210 263 265 109 73 254 131 386
	   155 83 15 298 5 388 -19z m-1135 -2256 c390 -225 710 -413 710 -417 0 -3 -15
	   -10 -32 -13 -58 -12 -213 -74 -284 -112 -38 -21 -97 -65 -131 -99 -96 -94 -93
	   -74 -93 -685 l0 -518 -83 -84 c-285 -287 -721 -367 -1083 -198 -257 121 -435
	   328 -520 607 -26 82 -28 103 -28 259 -1 187 12 254 73 390 54 119 734 1286
	   747 1283 7 -2 333 -187 724 -413z m2116 -524 l81 -6 -608 -268 c-334 -148
	   -617 -271 -628 -274 -45 -12 -326 69 -444 129 -62 31 -137 93 -137 113 0 24
	   83 88 165 126 156 73 437 138 735 170 225 24 608 29 836 10z m605 -90 c277
	   -71 452 -167 426 -235 -10 -26 -99 -84 -183 -120 -177 -75 -437 -130 -759
	   -162 -170 -17 -695 -21 -791 -7 l-52 8 617 272 c339 150 619 273 622 273 4 0
	   58 -13 120 -29z m-2090 -599 c303 -99 668 -144 1144 -144 369 1 688 32 952 93
	   117 27 298 86 365 120 32 16 60 29 63 29 3 0 5 -175 5 -390 l0 -390 -35 -39
	   c-145 -160 -725 -281 -1357 -281 -433 0 -887 62 -1135 155 -98 37 -201 94
	   -228 127 l-25 30 0 393 0 394 63 -28 c34 -16 119 -47 188 -69z"/>
	   <path d="M2712 4635 c-60 -50 -49 -138 23 -172 75 -36 153 24 142 110 -7 52
	   -34 78 -89 84 -37 4 -49 1 -76 -22z"/>
	   <path d="M2390 4627 c-121 -44 -208 -96 -299 -182 -61 -57 -136 -158 -152
	   -204 -23 -65 27 -133 97 -133 44 0 78 22 110 74 69 109 198 207 326 248 82 26
	   108 54 108 116 0 92 -72 123 -190 81z"/>
	   </g>
	   </svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	enroll: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		__width__ __height__ viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet">
	   <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
	   __fill__ stroke="none">
	   <path d="M1370 5105 c-168 -41 -199 -67 -766 -637 -650 -653 -604 -569 -604
	   -1109 0 -380 -2 -369 77 -369 71 0 71 1 75 300 4 290 7 304 67 373 18 19 53
	   46 79 59 45 22 59 23 367 28 292 5 324 8 371 26 116 47 221 139 271 238 56
	   111 56 110 62 451 6 304 7 322 28 361 28 52 79 97 134 118 40 15 152 16 1284
	   14 l1240 -3 57 -28 c76 -37 143 -104 176 -175 l27 -57 3 -1133 2 -1133 -221
	   -392 c-122 -216 -222 -393 -223 -393 0 -1 -46 56 -101 128 -55 71 -120 147
	   -144 169 -127 113 -315 135 -477 54 -124 -61 -204 -173 -225 -317 -13 -93 7
	   -200 52 -272 53 -86 638 -833 677 -866 195 -162 496 -114 634 100 l30 45 -4
	   -130 c-3 -119 -5 -135 -3	1 -187 -36 -74 -101 -139 -175 -175 l-57 -28 -1815 0
	   -1815 0 -55 26 c-118 57 -191 156 -210 285 -6 43 -10 503 -10 1200 0 1083 -1
	   1132 -18 1147 -26 23 -94 22 -115 -1 -16 -17 -17 -115 -17 -1209 0 -1158 1
	   -1193 20 -1254 39 -126 136 -241 252 -300 124 -63 1 -59 1968 -59 1580 0 1803
	   2 1855 15 179 47 323 191 370 370 12 46 15 118 15 321 l0 262 70 124 c46 82
	   70 134 70 156 0 45 -30 72 -79 72 -52 0 -52 0 -232 -324 -167 -301 -209 -354
	   -303 -381 -73 -21 -136 -13 -204 26 -45 26 -91 80 -361 427 -170 219 -319 418
	   -331 442 -16 31 -23 63 -23 106 -2 192 193 321 369 245 63 -27 79 -44 234
	   -246 67 -88 132 -168 142 -177 26 -24 90 -24 110 0 9 9 129 218 268 464 138
	   246 265 465 281 487 65 91 201 127 307 81 63 -27 133 -101 150 -158 19 -64 15
	   -141 -12 -197 -12 -27 -91 -170 -174 -318 -166 -292 -175 -317 -126 -356 33
	   -26 78 -27 102 -3 29 29 349 603 367 660 26 79 17 228 -18 305 -30 65 -110
	   155 -171 191 -121 70 -273 75 -418 11 -17 -7 -18 46 -18 1032 0 1145 3 1094
	   -63 1217 -41 78 -125 162 -203 203 -125 66 -44 63 -1484 62 -1059 -1 -1315 -3
	   -1360 -14z m-145 -272 c-4 -16 -10 -170 -14 -343 -6 -313 -6 -315 -32 -370
	   -55 -115 -154 -189 -279 -209 -36 -6 -180 -11 -320 -11 -140 0 -270 -4 -288
	   -9 -17 -5 -32 -7 -32 -3 0 7 962 972 969 972 2 0 0 -12 -4 -27z"/>
	   <path d="M1541 3734 c-12 -15 -21 -37 -21 -49 0 -12 9 -34 21 -49 l20 -26 679
	   0 679 0 20 26 c12 15 21 37 21 49 0 12 -9 34 -21 49 l-20 26 -679 0 -679 0
	   -20 -26z"/>
	   <path d="M784 2930 c-28 -11 -54 -48 -54 -76 0 -12 9 -33 21 -48 l20 -26 1468
	   0 c1406 0 1469 1 1484 18 30 33 32 75 4 108 l-25 29 -1449 2 c-803 1 -1458 -2
	   -1469 -7z"/>
	   <path d="M773 2390 c-47 -19 -57 -87 -18 -125 l24 -25 1458 0 c1593 0 1492 -4
	   1507 56 9 36 -9 79 -40 93 -31 14 -2897 15 -2931 1z"/>
	   <path d="M755 1835 c-30 -29 -32 -74 -6 -106 l19 -24 757 0 757 0 19 24 c26
	   32 24 77 -6 106 l-24 25 -746 0 -746 0 -24 -25z"/>
	   <path d="M960 1361 c-90 -29 -174 -103 -212 -186 -18 -40 -23 -67 -23 -140 0
	   -78 4 -97 28 -147 33 -68 90 -121 166 -156 49 -24 71 -27 184 -30 l127 -4 0
	   -103 c0 -88 3 -106 21 -129 26 -33 88 -37 119 -6 18 18 20 33 20 130 0 107 1
	   110 23 110 33 1 99 34 129 66 37 40 48 74 48 149 0 72 18 102 50 85 16 -8 18
	   -26 22 -142 4 -151 15 -186 80 -249 49 -47 112 -69 200 -69 60 0 72 3 93 25
	   33 32 33 78 0 110 -20 21 -34 25 -79 25 -116 0 -136 29 -136 195 0 123 -11
	   169 -53 213 -71 76 -202 77 -276 3 -42 -42 -61 -96 -61 -173 0 -49 -12 -78
	   -31 -78 -4 0 -9 62 -11 138 -3 126 -6 141 -31 190 -34 65 -92 123 -155 153
	   -51 24 -193 36 -242 20z m179 -172 c20 -11 48 -36 61 -56 23 -33 25 -48 28
	   -155 l4 -118 -101 0 c-140 0 -192 23 -232 102 -75 148 95 309 240 227z"/>
	   </g>
	   </svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	languagePreference: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		__width__ __height__  viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet">
	   <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
	   __fill__ stroke="none">
	   <path d="M1956 5109 c-21 -5 -68 -23 -105 -41 -78 -37 -192 -146 -233 -224
	   -58 -108 -58 -107 -58 -846 l0 -678 -557 0 c-347 0 -575 -4 -603 -11 -24 -5
	   -74 -24 -110 -41 -77 -37 -191 -147 -232 -224 -59 -111 -58 -87 -58 -1064 0
	   -578 4 -911 11 -940 27 -117 123 -252 229 -320 27 -17 80 -42 117 -55 l68 -24
	   3 -294 2 -295 27 -26 c20 -21 35 -26 73 -26 l47 0 374 320 374 319 895 1 c577
	   0 911 4 940 11 179 41 348 210 389 389 7 29 11 294 11 723 l0 677 118 0 117
	   -1 374 -319 374 -320 47 0 c38 0 51 5 73 28 l27 28 2 292 3 293 68 24 c37 13
	   90 38 117 55 106 68 202 203 229 320 14 62 14 1818 0 1880 -5 24 -24 74 -41
	   110 -37 77 -147 191 -224 232 -104 56 -127 58 -635 58 l-466 0 -27 -26 c-37
	   -38 -37 -110 0 -147 l25 -26 457 -3 457 -3 56 -26 c112 -53 179 -140 198 -259
	   15 -89 15 -1611 0 -1700 -25 -154 -133 -260 -288 -281 -134 -18 -135 -19 -141
	   -292 l-5 -219 -294 251 -293 250 -932 3 -931 3 -67 33 c-77 38 -130 92 -167
	   171 l-26 56 0 875 0 875 26 56 c37 79 90 133 167 171 l67 33 457 3 457 3 25
	   26 c37 37 37 109 0 147 l-27 26 -471 -1 c-259 -1 -488 -5 -510 -10z m-396
	   -2116 c0 -147 21 -223 85 -320 30 -46 34 -56 24 -75 -7 -12 -108 -274 -225
	   -582 -153 -402 -214 -573 -214 -602 0 -60 36 -94 100 -94 55 0 87 25 109 86 8
	   22 27 74 43 117 l30 77 268 0 268 0 30 -77 c16 -43 35 -95 43 -117 22 -61 54
	   -86 109 -86 38 0 53 5 74 26 47 48 42 67 -160 602 -102 271 -184 494 -183 495
	   2 1 318 1 702 -1 l697 -2 0 -623 c0 -386 -4 -647 -11 -687 -19 -119 -86 -206
	   -198 -259 l-56 -26 -931 -3 -932 -3 -293 -250 -294 -251 -5 219 c-6 273 -7
	   274 -142 292 -121 17 -213 86 -267 200 l-26 56 0 875 0 875 26 56 c51 108 147
	   183 253 199 28 4 282 8 564 9 l512 1 0 -127z m324 -957 c47 -126 86 -231 86
	   -233 0 -1 -86 -3 -191 -3 -178 0 -191 1 -184 18 3 9 42 109 85 222 111 292
	   101 269 110 245 4 -11 47 -123 94 -249z"/>
	   <path d="M3266 5094 c-21 -21 -26 -36 -26 -74 0 -38 5 -53 26 -74 21 -21 36
	   -26 74 -26 38 0 53 5 74 26 21 21 26 36 26 74 0 38 -5 53 -26 74 -21 21 -36
	   26 -74 26 -38 0 -53 -5 -74 -26z"/>
	   <path d="M3294 4601 c-47 -20 -54 -45 -54 -203 l0 -147 -311 -3 -311 -3 -24
	   -28 c-33 -39 -33 -105 0 -144 l24 -28 186 -3 c102 -2 186 -6 186 -10 0 -4 5
	   -47 10 -97 22 -193 77 -343 187 -512 13 -20 11 -24 -49 -72 -108 -88 -281
	   -166 -408 -185 -67 -11 -94 -24 -113 -55 -33 -56 -12 -128 42 -151 39 -16 115
	   -7 230 26 147 43 273 110 394 207 l57 47 58 -47 c120 -97 246 -164 393 -207
	   167 -48 238 -45 272 13 32 55 11 130 -42 150 -14 5 -46 13 -71 17 -70 10 -168
	   43 -245 81 -66 33 -190 118 -213 146 -8 9 0 30 31 77 75 119 137 293 151 426
	   4 32 9 78 12 101 l5 42 185 3 186 3 24 28 c33 39 33 105 0 144 l-24 28 -311 3
	   -311 3 0 149 c0 140 -1 150 -23 175 -24 29 -86 42 -123 26z m178 -618 c-2 -32
	   -12 -96 -23 -142 -21 -90 -91 -251 -109 -251 -18 0 -88 161 -109 251 -11 46
	   -21 110 -23 142 l-5 57 137 0 137 0 -5 -57z"/>
	   </g>
	   </svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	notes: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		__width__ __height__  viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet">
	   <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
	   __fill__ stroke="none">
	   <path d="M379 5097 c-175 -60 -306 -192 -359 -366 -20 -62 -20 -104 -20 -2041
	   l0 -1977 26 -27 27 -26 273 0 274 0 0 -304 0 -303 26 -27 27 -26 1577 0 1577
	   0 27 26 26 27 0 303 0 303 488 3 487 3 60 29 c77 38 153 114 191 191 27 56 29
	   68 29 175 0 107 -2 119 -29 175 -38 77 -114 153 -191 191 l-60 29 -487 3 -488
	   3 0 1279 0 1280 74 0 c223 0 426 153 503 379 32 93 32 249 0 342 -61 180 -196
	   309 -376 363 -47 14 -126 16 -576 16 l-522 0 -27 -26 c-37 -38 -37 -110 0
	   -147 l25 -26 507 -3 c505 -3 507 -4 566 -27 80 -32 166 -118 195 -195 47 -127
	   19 -266 -72 -360 -62 -62 -124 -94 -209 -107 -59 -8 -2958 -14 -2958 -5 0 2
	   16 30 35 62 54 89 75 169 75 284 0 115 -21 195 -75 284 -19 32 -35 60 -35 62
	   0 2 263 4 584 4 l583 0 27 26 c37 38 37 110 0 148 l-27 26 -856 0 -856 -1 -66
	   -22z m297 -208 c77 -29 164 -116 193 -193 64 -170 -12 -359 -175 -436 -35 -17
	   -70 -41 -79 -53 -13 -19 -15 -207 -15 -1684 l0 -1663 -200 0 -200 0 2 1888 3
	   1887 24 58 c32 80 117 167 191 195 75 29 180 29 256 1z m2984 -2149 l0 -1280
	   -570 0 -570 0 -309 -155 c-170 -85 -319 -164 -330 -177 -29 -30 -29 -106 0
	   -136 11 -13 160 -92 330 -177 l309 -155 570 0 570 0 0 -230 0 -230 -1430 0
	   -1430 0 0 1910 0 1910 1430 0 1430 0 0 -1280z m660 -1680 l0 -200 -780 0 -780
	   0 0 200 0 200 780 0 780 0 0 -200z m480 175 c49 -24 69 -44 91 -87 36 -70 18
	   -181 -37 -229 -47 -41 -88 -52 -211 -57 l-123 -5 0 203 0 203 123 -5 c90 -4
	   131 -9 157 -23z m-2240 -175 l0 -180 -175 87 c-96 48 -175 90 -175 93 0 4 334
	   176 348 179 1 1 2 -80 2 -179z"/>
	   <path d="M1226 3234 c-37 -38 -37 -110 0 -148 l27 -26 977 0 977 0 27 26 c21
	   21 26 36 26 74 0 38 -5 53 -26 74 l-27 26 -977 0 -977 0 -27 -26z"/>
	   <path d="M1226 2834 c-37 -38 -37 -110 0 -148 l27 -26 977 0 977 0 27 26 c21
	   21 26 36 26 74 0 38 -5 53 -26 74 l-27 26 -977 0 -977 0 -27 -26z"/>
	   <path d="M1226 2434 c-37 -38 -37 -110 0 -148 l27 -26 977 0 977 0 27 26 c21
	   21 26 36 26 74 0 38 -5 53 -26 74 l-27 26 -977 0 -977 0 -27 -26z"/>
	   <path d="M1226 2034 c-37 -38 -37 -110 0 -148 l27 -26 977 0 977 0 27 26 c21
	   21 26 36 26 74 0 38 -5 53 -26 74 l-27 26 -977 0 -977 0 -27 -26z"/>
	   <path d="M2486 5094 c-21 -21 -26 -36 -26 -74 0 -38 5 -53 26 -74 21 -21 36
	   -26 74 -26 38 0 53 5 74 26 21 21 26 36 26 74 0 38 -5 53 -26 74 -21 21 -36
	   26 -74 26 -38 0 -53 -5 -74 -26z"/>
	   </g>
	   </svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	personalId2: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		__width__ __height__  viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet">
	   <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
	   __fill__ stroke="none">
	   <path d="M3702 4945 c-218 -40 -454 -161 -621 -319 -206 -195 -361 -540 -361
	   -802 l0 -64 -1178 0 c-1135 0 -1181 -1 -1234 -19 -138 -47 -242 -151 -289
	   -288 -18 -55 -19 -96 -19 -1493 0 -1389 1 -1439 19 -1492 47 -138 151 -242
	   288 -289 55 -19 101 -19 2103 -19 2002 0 2048 0 2103 19 137 47 241 151 288
	   289 18 53 19 100 19 1272 l0 1217 31 39 c129 160 220 357 254 553 19 107 19
	   315 0 423 -39 223 -158 457 -319 627 -157 166 -421 306 -654 346 -104 18 -330
	   18 -430 0z m458 -324 c297 -86 536 -326 622 -626 19 -68 23 -103 23 -235 0
	   -132 -4 -167 -23 -235 -86 -302 -325 -541 -627 -627 -68 -19 -103 -23 -235
	   -23 -132 0 -167 4 -235 23 -300 86 -541 326 -625 622 -31 108 -38 299 -15 411
	   71 351 339 625 690 703 101 23 324 16 425 -13z m-1381 -1246 c33 -97 87 -206
	   150 -300 60 -91 216 -247 308 -308 105 -69 262 -142 378 -173 94 -26 113 -28
	   305 -28 194 0 211 1 305 27 55 16 142 48 194 73 51 24 95 44 98 44 2 0 2 -480
	   1 -1067 -3 -1048 -3 -1069 -23 -1101 -11 -18 -36 -43 -55 -55 l-35 -22 -1995
	   0 -1995 0 -35 22 c-19 12 -44 37 -55 55 -20 33 -20 51 -20 1418 l0 1385 22 35
	   c24 39 53 60 98 71 17 4 547 6 1179 5 l1148 -1 27 -80z"/>
	   <path d="M4290 4194 c-14 -9 -136 -127 -272 -263 l-248 -246 -97 96 c-125 123
	   -135 129 -203 129 -62 0 -100 -20 -131 -66 -24 -37 -26 -129 -3 -164 25 -37
	   293 -307 338 -341 32 -24 49 -29 96 -29 47 0 64 5 96 29 46 34 614 605 638
	   641 10 15 16 45 16 80 0 62 -20 100 -66 131 -37 24 -129 26 -164 3z"/>
	   <path d="M1185 2841 c-206 -60 -366 -224 -419 -428 -21 -79 -20 -228 0 -307
	   19 -73 73 -180 118 -232 l32 -37 -90 -91 c-102 -102 -154 -182 -193 -301 -26
	   -77 -27 -91 -31 -330 -4 -279 -1 -295 63 -335 31 -19 52 -20 685 -20 633 0
	   654 1 685 20 64 40 67 56 63 335 -4 239 -5 253 -31 330 -39 119 -91 199 -193
	   301 l-90 91 32 37 c45 52 99 159 118 232 20 79 21 228 0 307 -54 208 -223 377
	   -431 431 -82 21 -240 20 -318 -3z m280 -315 c73 -34 110 -69 144 -138 73 -146
	   17 -314 -131 -387 -193 -97 -418 42 -418 259 0 115 58 207 162 259 80 40 167
	   43 243 7z m17 -895 c76 -26 106 -43 159 -89 102 -90 146 -193 156 -367 l6
	   -115 -453 0 -453 0 6 113 c9 156 39 241 115 328 52 59 107 96 184 125 82 30
	   201 32 280 5z"/>
	   <path d="M2786 2241 c-46 -31 -66 -69 -66 -131 0 -95 55 -150 150 -150 95 0
	   150 55 150 150 0 95 -55 150 -150 150 -37 0 -64 -6 -84 -19z"/>
	   <path d="M3386 2241 c-46 -31 -66 -69 -66 -131 0 -95 55 -150 150 -150 95 0
	   150 55 150 150 0 95 -55 150 -150 150 -37 0 -64 -6 -84 -19z"/>
	   <path d="M3986 2241 c-46 -31 -66 -69 -66 -131 0 -95 55 -150 150 -150 95 0
	   150 55 150 150 0 95 -55 150 -150 150 -37 0 -64 -6 -84 -19z"/>
	   <path d="M2786 1641 c-46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 28 -18
	   59 -19 684 -19 625 0 656 1 684 19 46 31 66 69 66 131 0 62 -20 100 -66 131
	   -28 18 -59 19 -684 19 -625 0 -656 -1 -684 -19z"/>
	   <path d="M2786 1041 c-46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 28 -18
	   59 -19 684 -19 625 0 656 1 684 19 46 31 66 69 66 131 0 62 -20 100 -66 131
	   -28 18 -59 19 -684 19 -625 0 -656 -1 -684 -19z"/>
	   </g>
	   </svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	stickyNotes: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		__width__ __height__ viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet">
	   <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
	   __fill__ stroke="none">
	   <path d="M3606 5109 c-116 -27 -244 -133 -298 -247 -31 -66 -34 -69 -80 -80
	   -161 -38 -305 -171 -362 -335 l-22 -64 -684 184 c-377 101 -703 183 -726 183
	   -82 0 -45 119 -543 -1740 -248 -927 -451 -1698 -451 -1713 0 -15 12 -40 28
	   -57 25 -28 55 -38 357 -119 l330 -88 5 -492 5 -493 28 -24 28 -24 1667 0 1666
	   0 28 27 28 27 0 1739 0 1739 35 129 c40 150 42 177 15 212 -25 31 -8 26 -439
	   141 -194 52 -355 96 -357 98 -3 4 13 79 18 81 1 1 33 17 69 35 118 58 209 173
	   244 307 61 237 -81 493 -316 566 -66 21 -202 24 -273 8z m260 -234 c77 -45
	   134 -141 134 -225 0 -109 -88 -224 -194 -255 -126 -37 -253 20 -312 140 -22
	   47 -26 64 -22 122 2 38 12 84 22 104 21 44 79 105 120 126 71 37 177 32 252
	   -12z m-587 -371 c27 -84 75 -158 136 -212 53 -47 149 -97 207 -107 l37 -7 -20
	   -40 c-54 -105 -162 -172 -280 -172 -126 0 -244 82 -289 201 -54 144 3 300 140
	   382 19 11 38 21 41 21 3 0 16 -30 28 -66z m-1109 -158 c344 -92 636 -171 650
	   -175 19 -6 30 -22 47 -69 12 -34 30 -73 39 -87 17 -26 17 -26 -45 -89 -70 -71
	   -84 -111 -57 -164 20 -39 44 -52 96 -52 38 0 49 6 108 64 l67 63 30 -18 c43
	   -27 145 -57 218 -65 123 -12 284 42 380 127 l47 41 348 -94 348 -93 -337
	   -1255 c-185 -690 -341 -1254 -345 -1253 -5 0 -119 30 -254 66 -135 36 -256 67
	   -270 68 -97 9 -103 -1 -189 -323 l-73 -274 -572 153 c-314 84 -826 221 -1138
	   305 -312 83 -573 155 -580 159 -19 12 822 3141 842 3136 8 -2 296 -79 640
	   -171z m2230 -2881 l0 -1265 -1515 0 -1515 0 0 385 c0 268 3 385 11 385 6 0
	   380 -99 832 -221 466 -125 835 -219 852 -217 38 4 852 474 870 502 7 12 113
	   398 236 858 123 461 225 838 227 838 1 0 2 -569 2 -1265z m-942 -377 c62 -17
	   111 -32 110 -33 -12 -11 -340 -196 -342 -193 -2 1 13 63 33 136 35 131 36 133
	   61 127 14 -3 76 -20 138 -37z"/>
	   <path d="M1643 3415 c-35 -25 -48 -83 -29 -128 8 -20 25 -42 38 -47 53 -24
	   2004 -540 2040 -540 92 0 133 126 58 181 -32 24 -1989 549 -2045 549 -22 0
	   -50 -7 -62 -15z"/>
	   <path d="M1564 3041 c-62 -26 -84 -116 -41 -166 20 -23 126 -54 1027 -296 552
	   -148 1020 -269 1038 -269 101 0 129 161 35 198 -15 6 -291 82 -613 167 -322
	   86 -758 203 -970 260 -422 113 -445 118 -476 106z"/>
	   <path d="M1448 2644 c-35 -19 -48 -43 -48 -93 0 -77 10 -82 345 -172 209 -56
	   309 -79 331 -75 48 10 79 49 79 102 0 79 -13 86 -347 175 -161 43 -302 79
	   -313 78 -11 0 -32 -6 -47 -15z"/>
	   <path d="M2423 2375 c-32 -23 -47 -77 -33 -120 15 -45 49 -68 102 -68 34 0 47
	   6 70 32 62 70 19 171 -74 171 -24 0 -53 -7 -65 -15z"/>
	   </g>
	   </svg>`,
		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},
	copy: {
		markup: `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
		__width__ __height__ viewBox="0 0 512.000000 512.000000"
			preserveAspectRatio="xMidYMid meet">
		<metadata>
		Created by potrace 1.16, written by Peter Selinger 2001-2019
		</metadata>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
		fill="#003e7b" stroke="none">
		<path d="M1699 5106 c-112 -42 -194 -115 -243 -216 -41 -87 -49 -201 -17 -254
		53 -85 190 -87 246 -3 9 14 19 47 24 73 9 58 25 86 62 108 25 14 141 16 1244
		16 1341 0 1250 4 1289 -60 15 -26 16 -175 16 -1762 0 -1698 0 -1734 -20 -1765
		-23 -38 -44 -50 -101 -59 -89 -13 -139 -68 -139 -152 0 -49 33 -101 80 -125
		28 -14 48 -17 98 -12 169 16 303 122 356 280 15 47 16 198 14 1850 l-3 1800
		-31 65 c-40 83 -111 154 -194 194 l-65 31 -1290 2 c-1045 1 -1297 -1 -1326
		-11z"/>
		<path d="M833 4220 c-143 -29 -260 -134 -307 -275 -15 -47 -16 -198 -14 -1850
		l3 -1800 31 -65 c40 -83 111 -154 194 -194 l65 -31 1300 0 1300 0 65 31 c83
		40 154 111 194 194 l31 65 3 1802 c2 1788 2 1802 -18 1856 -44 118 -126 204
		-237 249 l-58 23 -1255 2 c-690 0 -1274 -3 -1297 -7z m2521 -303 c59 -39 56
		69 56 -1808 0 -1546 -2 -1724 -16 -1754 -32 -69 49 -65 -1289 -65 -1333 0
		-1254 -4 -1289 63 -16 30 -17 161 -14 1774 l3 1741 24 26 c14 15 39 30 55 35
		18 6 550 9 1236 8 1150 -2 1207 -3 1234 -20z"/>
		</g>
	   </svg>`,
		defaultStyles: {
			width: 15,
			height: 18
		}
	},
	ivrpin: {
		markup:`<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 __width__ __height__ viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet">
	   <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
	   __fill__ stroke="none">
<path d="M365 3660 c-75 -13 -112 -26 -165 -60 -100 -64 -168 -165 -190 -280
-13 -70 -13 -940 0 -1011 29 -152 144 -278 299 -325 39 -12 289 -14 1549 -14
l1503 0 24 25 c32 31 32 66 1 102 l-24 28 -1509 5 -1508 5 -41 22 c-56 30
-108 91 -128 150 -15 45 -16 105 -14 529 3 472 3 480 25 520 30 56 79 103 133
128 l45 21 2195 0 2195 0 45 -21 c54 -25 103 -72 133 -128 21 -39 22 -57 27
-309 5 -268 5 -269 29 -288 32 -26 77 -24 106 6 l25 24 0 239 c0 132 -5 263
-10 292 -29 151 -137 275 -286 327 -46 17 -189 18 -2229 19 -1199 1 -2202 -2
-2230 -6z"/>
<path d="M4125 3302 c-138 -47 -247 -140 -308 -264 -44 -90 -57 -159 -57 -302
l0 -111 -28 -13 c-39 -17 -89 -68 -115 -116 -20 -37 -22 -59 -25 -224 -4 -226
9 -306 75 -441 82 -171 250 -308 438 -357 80 -20 252 -20 330 0 191 51 353
183 438 356 66 135 79 213 75 442 -3 181 -3 183 -33 236 -27 50 -97 112 -124
112 -7 0 -11 41 -11 118 0 64 -7 147 -15 185 -37 175 -181 329 -355 381 -72
21 -219 20 -285 -2z m298 -176 c139 -71 197 -188 197 -398 l0 -88 -351 0 -352
0 5 123 c6 141 27 209 85 276 74 87 154 121 273 118 71 -2 94 -7 143 -31z
m312 -658 c48 -21 55 -52 55 -225 0 -183 -13 -253 -66 -353 -119 -228 -393
-331 -637 -240 -159 60 -287 210 -323 379 -17 80 -19 344 -3 390 21 60 20 60
506 61 322 0 449 -3 468 -12z"/>
<path d="M4200 2278 c-24 -13 -52 -35 -63 -49 -45 -63 -37 -156 18 -210 25
-25 35 -43 35 -66 0 -46 18 -80 51 -94 58 -23 109 21 109 94 0 23 10 41 35 66
55 54 63 147 18 210 -23 31 -97 71 -133 71 -14 0 -46 -10 -70 -22z"/>
<path d="M984 3228 c-34 -16 -44 -52 -44 -163 0 -58 -2 -105 -5 -105 -2 0 -44
23 -92 52 -96 56 -138 65 -173 33 -13 -12 -20 -30 -20 -56 0 -45 24 -67 136
-130 l76 -42 -83 -47 c-46 -26 -94 -56 -106 -68 -30 -28 -31 -84 -3 -112 32
-32 74 -25 170 30 48 28 90 50 94 50 3 0 6 -49 6 -109 0 -94 3 -112 21 -135
29 -37 89 -37 118 0 18 23 21 41 21 135 0 60 3 109 6 109 4 0 46 -22 94 -50
95 -54 134 -61 171 -31 26 21 32 79 10 105 -7 9 -53 39 -102 67 -49 28 -87 54
-85 58 3 4 45 31 95 60 67 40 93 61 100 83 13 36 0 71 -33 94 -34 21 -57 15
-160 -46 -47 -28 -87 -50 -90 -50 -3 0 -6 51 -6 113 -1 116 -6 133 -47 155
-26 14 -41 14 -69 0z"/>
<path d="M2013 3230 c-35 -14 -43 -43 -43 -159 0 -61 -2 -111 -5 -111 -2 0
-49 25 -102 55 -54 30 -106 55 -116 55 -25 0 -77 -54 -77 -80 0 -39 19 -58
115 -115 52 -31 95 -57 95 -59 0 -2 -40 -27 -90 -55 -122 -71 -144 -107 -99
-165 32 -41 75 -35 176 24 47 28 89 50 94 50 5 0 9 -51 9 -112 1 -121 7 -140
51 -157 34 -12 86 11 99 44 6 15 10 71 10 126 0 54 2 99 5 99 3 0 45 -22 93
-50 52 -30 100 -50 118 -50 65 0 99 86 52 130 -13 12 -52 37 -88 57 -114 63
-113 54 -11 113 50 28 98 61 106 73 30 43 15 96 -33 116 -34 14 -48 10 -157
-53 l-80 -46 -5 116 c-5 112 -6 117 -33 140 -30 25 -48 28 -84 14z"/>
<path d="M3024 3217 c-28 -25 -29 -28 -34 -141 l-5 -116 -80 46 c-109 63 -123
67 -157 53 -48 -20 -63 -73 -33 -116 8 -12 56 -45 106 -73 102 -59 103 -50
-11 -113 -36 -20 -75 -45 -88 -57 -47 -45 -13 -130 53 -130 16 0 67 22 117 50
48 28 90 50 93 50 3 0 5 -45 5 -99 0 -55 4 -111 10 -126 13 -33 65 -56 99 -44
44 17 50 36 51 157 0 61 4 112 9 112 5 0 47 -22 94 -50 101 -59 144 -65 176
-24 45 58 23 94 -99 165 -50 28 -90 53 -90 55 0 2 43 28 95 59 96 57 115 76
115 115 0 26 -52 80 -77 80 -10 0 -62 -25 -116 -55 -53 -30 -100 -55 -102 -55
-3 0 -5 51 -5 114 0 127 -10 151 -66 162 -24 5 -37 0 -60 -19z"/>
</g>
</svg>`,

		defaultStyles: {
			width: 30,
			height: 30,
			fill: '#003e7b'
		}
	},

};
